// tslint:disable:max-line-length
import {IFamilyMember} from "@app-types/websocket/family.types";
import {addDays, isSameDay} from "@helpers/DateHelper";
import {isPreschool} from "@helpers/schoolHelper";
import SCHOOL_TYPES from "@constants/schoolTypes";
import * as React from "react";
import {ISchedule, TemplateName} from '@app-types/websocket/schedule.types';
import {FamilyMemberSex, FamilyMemberType} from "@services/family/family.constants";
import {EcoRepeat, EcoTransferMethod} from '@app-types/websocket/economy.types';
import { REPEATABLE } from "@app-types/websocket/event.types";
import ImgAvatar from "@components/common/avatar/ImgAvatar";
import { secondaryColor, primaryColor } from 'src/main.style';
import { CSSProperties } from '@material-ui/styles';

const baselanguage = {

  // General
  close: 'Stäng',
  clear: 'Rensa',
  yes: 'Ja',
  no:'Nej',
  agree: 'Godkänn',
  deny: 'Neka',
  sirname: "Efternamn",
  name: "Förnamn",
  continue: "Fortsätt",
  connecting: "Kopplar",
  skip: "Hoppa över",
  cancel: "Avbryt",
  here: "här",
  missing: "Saknas",
  examples: "Exempel",
  discard:"Släng",
  remove: "Ta Bort",
  back: "Tillbaka",
  update: 'Ändra',
  edit: 'Redigera',
  copy: 'Kopiera',
  copyToClipboard: 'Kopiera till urklipp',
  error: "Oups, något gick fel 🙃",
  unknown: "Okänd",
  private: 'Privat',
  agreed: "Beslutat",
  shared: "Delat",
  delete: 'Radera',
  download: 'Ladda ner',
  deleted: "Borttagen",
  waiting: "Väntar",
  createNew: "Skapa Nytt",
  updateExisting: "Uppdatera befintligt",
  send: "Skicka",
  okay: "Okej",
  help:"Hjälp",
  OK: "OK",
  great: "Toppen",
  explain: "Förklara",
  expand:"Expandera",
  collapse:"Minimera",
  question: "Ifrågasätt",
  from: "Från",
  to: "Till",
  sum: "Summa",
  approve: "Godkänn",
  for: "Artiklar för",
  noone: "ingen",
  youSub: "Du",
  thanks: "Tack",
  rateAppTitle: "Hur funkar appen?",
  rateAppText: "Ditt omdöme hjälper oss att göra appen bättre.",
  rateAppLater: "Inte nu",
  rateAppSubmit: "Skicka",
  rateAppStarLabel: (rating:number): string => `${rating} av 5`,
  before: "Innan",
  unsub: "Avprenumerera",
  pay: "Betala",
  search: "Sök",
  showMore: "Visa mer",
  list: "Lista",
  all: "Alla",

  done: "Klart!",
  fail:"Misslyckades",
  working: "Tänker",
  add: "Lägg till",
  tryAgain: 'Försök igen',
  title: 'Titel',
  activity: 'Aktivitet',
  today: 'Idag',
  empty: 'Tom',
  weekLabel: 'Vecka',
  sent: 'Skickat!',
  camera : "Kamera",
  library : "Bilder",
  analyzing : "Analyserar",
  libraryLabel: "Bibliotek",
  uploadImage: "Ladda upp bild",
  prompt: "Prompt",
  sort: "Sortera",

  loading: "Laddar...",
  loginTakingLonger: "Inloggningen tar mycket längre tid än normalt. Vi rekommenderar att du trycker på Tillbaka-knappen längst ner.",
  readMore: 'Läs mer',
  invert: 'Växla dagar',
  adjustDay: 'Flytta bytesdagar',

  archive: 'Arkivera',
  include: "Inkludera gratis",
  import: 'Importera',
  suggestCange: 'Föreslå',
  boughtBy: "Köpt av",
  at: "hos",
  housing: "Boende",
  now: "Nu",
  hoursShort: "tim",
  icon: "Ikon" ,
  generate: "Generera",
  details: "Detaljer",


  verifying: "Verifierar...",
  invite: 'Bjud in',
  emailOnly: 'Endast epost',

  other: 'Annat',
  
  selectWhatToExport: 'Markera vad som ska exporteras',
  updateAvailable: 'En ny version finns tillgänglig',

  dueDate: 'Deadline',
  addDueDate: 'Lägg till deadline',
  addTodo: "Lägg till",
  editTodo: "Uppdatera",
  addTodoThing: "Lägg till",
  addListTodo: "Lägg till sak",
  varannanVecka: 'Varannan Vecka',


  btnUseAnotherEmail: 'Använd en annan epost',
  finish: "Klar",
  uConfirm: 'Är du säker?',
  iConfirm: 'Ja, jag är säker',
  deleteTodoInfo: 'Om du raderar så kommer den inte automatiskt att förnyas till nästa överlämning.',
  exitHelper: 'Avsluta hjälpen',
  handovers: "Byten",

  erased: "Raderat",
  erase: "Radera",
  undo: "Ångra",
  price: "Pris",
  submit: "Skicka",
  noThanks: "Nej tack",
  show: "Visa",
  scheduleAiEditPreviewUpdated: "Klart! Förhandsvisningen har uppdaterats.",
  scheduleAiEditPlaceholder: "Beskriv ändringarna du vill göra i detalj",
  scheduleAiEditUserLabel: "Du",
  scheduleAiEditAssistantLabel: "Schemaassistent",
  scheduleAiEditThinkingLabel: "Tänker...",
  scheduleAiEditIntro: "Beskriv vad du vill ändra i schemat så tar jag fram en förhandsvisning du kan granska.",
  scheduleAiFeedbackTitle: "Blev det inte rätt med AI?",
  scheduleAiFeedbackText: "Beskriv vad du försökte göra så förbättrar vi AIn.",
  scheduleAiFeedbackPlaceholder: "Beskriv vad du försökte ändra",
  scheduleAiFeedbackSupportUnavailable: "Support-chatten är inte tillgänglig just nu.",
  scheduleAiEditThinkingMessages: [
    "Går igenom den nuvarande schemaläggningen...",
    "Jämför din begäran med den befintliga rotationen...",
    "Kartlägger möjliga justeringar av föräldratiden...",
    "Kontrollerar hur detta påverkar veckorytmen...",
    "Letar efter den minsta giltiga schemaändringen...",
    "Testar en tydligare bytesstruktur...",
    "Bygger mall för de önskade dagarna över tidslinjen...",
    "Bygger om förhandsvisningen utifrån de senaste instruktionerna...",
    "Verifierar att mallen är konsekvent...",
    "Matchar de föreslagna ändringarna mot nuvarande schemaposter...",
    "Utvärderar kantfall kring överlämningstider...",
    "Översätter din begäran till konkreta schemablock...",
    "Kontrollerar om ändringen repeterar över tid...",
    "Finjusterar förhandsvisningen så att ändringarna blir lätta att läsa...",
    "Validerar att schemar förblir sammanhängande...",
    "Räknar om berörda datum och intervall...",
    "Kontrollerar om sommartid påverkar schemaläggningen...",
    "Optimerar schemat...",
    "Slutför en förhandsvisning som matchar din begäran...",
    "Förbereder schemat för granskning...",
  ],
  inviteF2ReadMoreLink: "/app/knowledge/7069",
  change: "Ändra",
  color: "Färg",

  activityLog: "Aktivitetslogg",



  // countries
  sweden: "Sverige",
  norway: "Norge",
  finland: "Finland",
  denmark: "Danmark",
  spain: "Spanien",
  switzerland: "Schweiz",
  france: "Frankrike",
  germany: "Tyskland",
  belgium: "Belgien",
  nl: "Nederländerna",
  uk: "Storbritannien",
  us: "USA",
  ca: "Kanada",
  italy: "Italien",
  austria: "Österrike",
  poland: "Polen",
  ireland: "Irland",
  portugal: "Portugal",
  greece: "Grekland",
  iceland: "Island",
  estonia: "Estland",
  latvia: "Lettland",
  lithuania: "Litauen",
  luxembourg: "Luxemburg",
  cyprus: "Cypern",
  czechia: "Tjeckien",
  malta: "Malta",
  australia: "Australien",
  newzealand: "Nya Zeeland",


  // Sex
  sex:"Kön",
  girl: "Flicka",
  woman: "Kvinna",
  boy: "Pojke",
  man: "Man",


  split: "Delad",
  month: "Månad",

  week: (week: number) => `Vecka ${week}`,
  monday: "Måndag",
  tuesday: "Tisdag",
  wednesday: "Onsdag",
  thursday: "Torsdag",
  friday: "Fredag",
  saturday: "Lördag",
  sunday: "Söndag",

  mon: "Mån",
  tue: "Tis",
  wed: "Ons",
  thu: "Tors",
  fri: "Fre",
  sat: "Lör",
  sun: "Sön",

  january: "Januari",
  february: "Februari",
  march: "Mars",
  april: "April",
  may: "Maj",
  june: "Juni",
  july: "Juli",
  august: "Augusti",
  september: "September",
  october: "Oktober",
  november: "November",
  december: "December",

  januaryShort: "Jan",
  februaryShort: "Feb",
  marchShort: "Mars",
  aprilShort: "April",
  mayShort: "Maj",
  juneShort: "Juni",
  julyShort: "Juli",
  augustShort: "Aug",
  septemberShort: "Sep",
  octoberShort: "Okt",
  novemberShort: "Nov",
  decemberShort: "Dec",

  getWeekName: (weekNum: number) => {
    return "v. " + weekNum;
  },

  getQuarterName: (date: Date) => {
    if (date.getMonth() < 3) {
      return ("Q1 " + date.getFullYear());
    } else if (date.getMonth() < 6) {
      return ("Q2 " + date.getFullYear());
    } else if (date.getMonth() < 9) {
      return ("Q3 " + date.getFullYear());
    } else {
      return ("Q4 " + date.getFullYear());
    }
  },

  getTermName: (date: Date) => {
    if (date.getMonth() < 6) {
      return ("VT " + date.getFullYear());
    } else {
      return ("HT " + date.getFullYear());
    }
  },

  getMonthName: (monthNumber: number) => {
    switch (monthNumber) {
      case 0:
        return baselanguage.january;
      case 1:
        return baselanguage.february;
      case 2:
        return baselanguage.march;
      case 3:
        return baselanguage.april;
      case 4:
        return baselanguage.may;
      case 5:
        return baselanguage.june;
      case 6:
        return baselanguage.july;
      case 7:
        return baselanguage.august;
      case 8:
        return baselanguage.september;
      case 9:
        return baselanguage.october;
      case 10:
        return baselanguage.november;
      case 11:
        return baselanguage.december;
      default:
        return "Unknown";

    }
  },
  getMonthNameShort: (monthNumber: number) => {
    switch (monthNumber) {
      case 0:
        return baselanguage.januaryShort;
      case 1:
        return baselanguage.februaryShort;
      case 2:
        return baselanguage.marchShort;
      case 3:
        return baselanguage.aprilShort;
      case 4:
        return baselanguage.mayShort;
      case 5:
        return baselanguage.juneShort;
      case 6:
        return baselanguage.julyShort;
      case 7:
        return baselanguage.augustShort;
      case 8:
        return baselanguage.septemberShort;
      case 9:
        return baselanguage.octoberShort;
      case 10:
        return baselanguage.novemberShort;
      case 11:
        return baselanguage.decemberShort;
      default:
        return "Unknown";

    }
  },
  dateMonthOrder: (date: Date) => {
    return (date.getDate() + baselanguage.dateEnding(date.getDate()) +
      ' ' + baselanguage.getMonthName(date.getMonth()));
  },

  dateEnding: (date: number) => {
    return "";
    // let dateEnd = "e";
    // if (date === 1) { dateEnd = "a"; }
    // else if (date === 2) { dateEnd = "a"; }
    // else if (date === 21) { dateEnd = "a"; }
    // else if (date === 22) { dateEnd = "a"; }
    // else if (date === 31) { dateEnd = "a"; }
    // return dateEnd;
  },

  getWeekdayName: (weekdayNumber: number) => {
    switch (weekdayNumber) {
      case 0:
        return baselanguage.sunday;
      case 1:
        return baselanguage.monday;
      case 2:
        return baselanguage.tuesday;
      case 3:
        return baselanguage.wednesday;
      case 4:
        return baselanguage.thursday;
      case 5:
        return baselanguage.friday;
      case 6:
        return baselanguage.saturday;
      default:
        return "Unknown";

    }
  },

  getWeekdayNameShort: (weekdayNumber: number) => {
    switch (weekdayNumber) {
      case 0:
        return baselanguage.sun;
      case 1:
        return baselanguage.mon;
      case 2:
        return baselanguage.tue;
      case 3:
        return baselanguage.wed;
      case 4:
        return baselanguage.thu;
      case 5:
        return baselanguage.fri;
      case 6:
        return baselanguage.sat;
      default:
        return "Unknown";

    }
  },

  dateOfBirth: 'Född år',
  save: 'Spara',
  uploading:'Laddar upp',
  publish: 'Publicera',
  school: 'Skola',
  schoolAge: (age:number, school:SCHOOL_TYPES|undefined):string => isPreschool(school, age) ? "Förskola" : "Skola",
  sendInvite: 'Skicka inbjudan',

  importSchool : 'Skola',
  importSchoolRegion : 'Kommun',
  importSchoolCountry : 'Land',
  importSchoolExample : 'Engelska skolan',
  importSchoolregionExample : 'Enskede',
  importSchoolChildren: 'Barn på skolan',
  doNotClearPreviousSchoolImport: 'Behåll de skollov som redan importerats',

  // Header
  headerScheduleVisibleForYou: "Synligt bara för dig",





  // Infobank
  tabChild: "Barninfo",
  tabImages: "Bilder",

  // external cal
  externalCalImportViaUrl: "Importera via länk",

  externalCalImportedCalendar: "Importerade kalendrar",
  externalCalName: "Kalendernamn",
  externalCalCalendarPerson: "Gäller för:",
  externalCalCalendarShare: "Delas med:",

  externalCalUrlError: "URL är inte giltig eller tillgänglig.",
  externalCalEmptyError: "Inga händelser hittades i ICS-filen.",
  externalCalHowItWorks: "Händelser hämtas från länken och är skrivskyddade.",
  externalCalAdd: "Lägg till kalender",
  externalCalEmptyTitle: "Alla tider på samma ställe",
  externalCalEmptyDescription: "Lägg till en kalender med en prenumerationslänk, till exempel från skolan, laget eller Google Kalender.",
  externalCalSource: "Källa",
  externalCalPerson: "Gäller för",
  externalCalNoPerson: "Ingen särskild person",
  externalCalVisibleTo: "Synlig för",
  externalCalOnlyYou: "Bara dig",
  externalCalYou: "Du",
  externalCalMember: "Familjemedlem",
  externalCalMine: "Tillagd av dig",
  externalCalSharedBy: (name: string) => `Delad av ${name}`,
  externalCalManage: "Hantera",
  externalCalDetails: "Visa detaljer",
  externalCalEdit: "Hantera kalender",
  externalCalBackToList: "Till kalendrarna",
  externalCalStepLink: "Kalenderlänk",
  externalCalStepDetails: "Namn och delning",
  externalCalLinkTitle: "Börja med en kalenderlänk",
  externalCalLinkDescription: "Kopiera prenumerationslänken från kalendern du vill lägga till och klistra in den här.",
  externalCalLinkLabel: "Länk till kalendern",
  externalCalLinkHint: "Använd en iCal-/ICS-länk.",
  externalCalFindLink: "Var hittar jag kalenderlänken?",
  externalCalGoogleHelp: "Öppna Google Kalender på webben. Välj kalenderns Inställningar och delning → Integrera kalender → Hemlig adress i iCal-format.",
  externalCalAppleHelp: "Öppna kalenderdelning i Apple Kalender eller iCloud. Om du väljer Offentlig kalender kan du kopiera länken. Alla som har den länken kan läsa kalendern.",
  externalCalOutlookHelp: "Öppna Outlook på webben: Inställningar → Kalender → Delade kalendrar → Publicera en kalender. Kopiera ICS-länken om publicering är tillgänglig.",
  externalCalOtherHelp: "Leta efter ”Prenumerera”, ”iCal” eller ”Exportera kalender” hos skolan eller laget. Kopiera länken.",
  externalCalOtherProvider: "Skola eller förening",
  externalCalCheckLink: "Kontrollera och fortsätt",
  externalCalChecking: "Kontrollerar länken…",
  externalCalInvalidLink: "Ange en kalenderlänk som börjar med https://, http:// eller webcal://.",
  externalCalCannotRead: "Kalendern kunde inte läsas. Kontrollera att du har kopierat en iCal-/ICS-länk som kan öppnas utan inloggning och försök igen.",
  externalCalConnected: (count: number) => `Länken fungerar · ${count} ${count === 1 ? "händelse hittad" : "händelser hittade"}`,
  externalCalConnectedEmpty: "Länken fungerar. Kalendern är tom just nu, men du kan lägga till den ändå.",
  externalCalNameHint: "Till exempel ”Skolan” eller ”Basket”.",
  externalCalNameRequired: "Ge kalendern ett namn.",
  externalCalPersonHint: "Vems tider är det? Personens bild visas vid händelserna. Det här valet ändrar inte vem som kan se kalendern.",
  externalCalSharingTitle: "Vem får se kalendern?",
  externalCalSharingHint: "Bara du ser kalendern från början. Markera de familjemedlemmar som också ska kunna se händelserna.",
  externalCalAlwaysVisible: "Du · har alltid tillgång",
  externalCalReadOnly: (name: string) => `${name} har delat den här kalendern med dig och hanterar länken och delningen.`,
  externalCalRemove: "Ta bort kalender",
  externalCalLeave: "Sluta visa för mig",
  externalCalRemoveTitle: (name: string) => `Ta bort ”${name}”?`,
  externalCalRemoveDescription: "Kalendern och dess händelser slutar visas här för dig och dem du delat den med. Den ursprungliga kalendern påverkas inte.",
  externalCalLeaveDescription: "Kalendern slutar visas för dig. Den finns kvar för personen som delade den och andra som har tillgång.",

  // Kalender 2
  calGuideMe : "Hjälp",
  calCounterSuggestion : "Gör ett motförslag",
  calUpdateSuggestion : "Du kan göra justeringar",

  calInspect : "Granska",

  calQuickChangeResponsibility: "Ändra ansvar",

 
  calExistingSuggestion : "Det finns redan ett obesvarat förslag. Vi rekommenderar du uppdaterar detta förslag med fler ändringar.",

  calNewSuggestion : "Nytt ändringsförslag",

  calSchedules : "Schemaändring",

  calNewEvent : "Ny aktivitet",
  calActivity: "Senaste aktivitet",

  calSuggWaiting : "Väntande förslag",


  calHelpWhereSentSuggestion : "Här kan du se dina skickade förslag",
  calHelpBiggerChanges : "Ändra boendeschemat här",

  calHelpClickEdit : "Klicka eller dra dagar att ändra",
  calHelpWrenchTools : "Verktyg för återkommande ändringar",



  calChangeSchedule : "Ändra bytesschemat",
  calChangeScheduleName : (scheduleName:string) =>"Ändra "+scheduleName,
 
  calAiTooLongError : "för långt",
  calAiBadDatesError : "start måste vara före slut",
  calAiTooLong2Error : "välj en kortare period",
  calAiLimit: "Begränsa ändringar till",
  
  calHelpPlaceHolder : "Skriv din pompt eller klicka på examplen nedan för inspiration.",

  calExample1Short : "Tvåveckors...",
  calExample2Short : "Ändra byten...",
  calExample3Short : "Lägg till dagbesök...",

  calExample1: (nextMonday: string) => "Ändra så att byten sker i tvåveckorsperioder. Överlämningarna ska ske på måndagar och äga rum hos den som hämtar klockan 18:00. Första bytet ska vara " + nextMonday,
  calExample2:  "Ändra alla överlämningar när jag tar över till: klockan 18:00, hos mig",
  calExample3: (coparent: string) => "Lägg till ett dagsbesök med mig mellan klockan 15:00 och 18:00 på onsdagar när barnen är hos " + coparent +
    ". Jag hämtar dem i skolan och lämnar dem hos " + coparent,
  

  calEventCantSee : "Kan inte se denna aktivitet",
  calEventCreator : "Skapare av aktivitet. ",
  calEventNotSeen : "Har inte sett aktiviteten än. ",
  calEventNoAccount : "Om inbjuden. ",
  calMoreOptions : "Fler val",
  calTitleMustBeSet : "Titel måste sättas",
  calEventOverlap : (count:number) => count === 1
    ? "Befintlig aktivitet:"
    : `${count} befintliga aktiviteter:`,
  calHasCheckmark : "Inkludera en avbocknings-ruta",
  calCompletedBy : (name:string) => `, klarmarkerad av ${name}`,
  calImage : "Bild",
  calFile : "Fil",

  calPlaceMissing :"Plats saknas (dock ej obligatoriskt)",
  calEndMustBeAfterStart : "Slutdatum och tid måste vara efter startdatum och tid.",

  calTakesOver : (name:string) => `${name} tar ansvaret`,
  calTakesOverFor : (names:string) => `för ${names}`,
  calResponsibilityFromSchool: (school:SCHOOL_TYPES|undefined, age:number):string =>
    isPreschool(school, age) ? "när förskolan slutar" : "när skolan slutar",
  calResponsibilityUntilSchool: (school:SCHOOL_TYPES|undefined, age:number):string =>
    isPreschool(school, age) ? "när förskolan börjar" : "när skolan börjar",

  calContinueStart : (name:string, date:string) => `${name} fortsättar att ha ansvaret från bytet den  ${date}`,
  calContinueEnd : (name:string, date:string) => `${name} fortsättar att ha ansvaret fram till bytet den ${date}`,

  calEventYourNotifications : "Notiser",
  calEventOthersNotificationsShow : "Andras notiser",


  calReminderName: (minutes:number): string => {
    switch (minutes) {
      case 0:
        return baselanguage.calReminder0Min;
      case 5:
        return baselanguage.calReminder5Min;
      case 10:
        return baselanguage.calReminder10Min;
      case 15:
        return baselanguage.calReminder15Min;
      case 30:
        return baselanguage.calReminder30Min;
      case 60:
        return baselanguage.calReminder60Min;
      case 120:
        return baselanguage.calReminder120Min;
      case 720:
        return baselanguage.calReminder12H;  
      case 1440:
        return baselanguage.calReminder1Day;
      case 2880:
        return baselanguage.calReminder2Day;
      default:
        return "Unknown";
    }
  },

  calReminder0Min   : "Vid aktivitetstiden",
  calReminder5Min   : "5 minuter innan",
  calReminder10Min  : "10 minuter innan",
  calReminder15Min  : "15 minuter innan",
  calReminder30Min  : "30 minuter innan",
  calReminder60Min  : "1 timme innan",
  calReminder120Min : "2 timmar innan",
  calReminder12H    : "12 timmar innan",
  calReminder1Day   : "1 dag innan",
  calReminder2Day   : "2 dagar innan",

  calWeekPlanning : "Veckoplanering",

  calPackingList :"Packlista",
 
  calDayvisit: "Dagbesök",  
  calDayvisitAt: "Dagbesök hos",
  calDayvisitOnDay : (name: string, day: string) => `${name} på en ${day}`,
  calDayvisitToFrom : (from: string, to: string) => `Från ${from} till ${to}`,

  calEventUpdateAll : "Uppdatera alla?",
  calEventEraseAll : "Radera alla?",
  calEventOnlyThis : "Bara denna",
  calEventConfirmEraseAll : "Radera alla",
  calEventConfirmEraseFollowing : "Radera denna och alla efterföljande",
  calEventConfirmUpdateAll : "Updatera alla",
  calEventAll : "Alla",

  calConfirmReply : "Bekräfta val",
  calConfirmDecline : "Vill du neka förslaget?",
  calConfirmDelete : "Vill du radera förslaget?",
  calConfirmNew : <span>Är du säker på att du vill göra ett nytt förslag när det redan finns ett som väntar på svar? <br /><br/>Om du gör flera förslag för samma dag kommer bara ett kunna accepteras.</span>,
  calConfirmNewEditExisting : "Justera existerande",
  calConfirmNewMakeNew : "Gör ett nytt",
  calShowNewSchedule : "Vill du visa det nya schemat?",
  calShareNewSchedule : "Vill du dela det nya schemat?",

  calQuickChangeFor:(kids:string) => `Ändra bytet för ${kids}`,
  calQuickChangeDayvisitFor:(kids:string) => `Ändra ${kids}s dagbesök`,

  calShowAs : (s:"TEXT"|"IMAGE") => <><span>Visa som:</span><span style={{fontWeight:(s==="TEXT"?700:400)}}>text</span><span>/</span><span style={{fontWeight:(s==="IMAGE"?700:400)}}>bild</span></>,
  calTakesResponsibility : "tar ansvaret under perioden:",
  calHandoverChangeWas : (from:string, to:string) => `Överlämningen från ${from} till ${to} som var den`,
  calChangeDate : (date:Date) => `${date.getDate()} ${baselanguage.getMonthName(date.getMonth()).toLowerCase()}`,
  calHandoverChangeTime : (date:Date, timeAndPlace:string) => `${baselanguage.calChangeDate(date)} ${timeAndPlace}`,
  calHandoverChangeTo : "ändras till",
  calDayVisitAdded : "Nytt dagbesök hos",
  calDayVisitChanged : "Ändrat dagbesök hos",
  calDayVisitRemoved : "Borttaget dagbesök hos",
  calDayVisitDay : (date:Date) => `${baselanguage.getWeekdayName(date.getDay())} ${baselanguage.calChangeDate(date)}`,
  calDayVisitSchool : (school:SCHOOL_TYPES|undefined, age:number):string => isPreschool(school, age) ? "Förskolan" : "Skolan",
  calDayVisitNoLocation : "Obestämd plats",

  calInvert : "Växla hela schemat",
  calChanges : "Ändringar",
  calNext : "Nästa",
  calOriginal: "Nuvarande schema",
  calScheduleSuggestion : "Förslag",
  calChange : (change:number, of:number) => `Ändring ${change}/${of}`,
  calKidChange : (from:string, to:string) => `Det här schemat gäller för ${to} istället för ${from}`,
  calPickDateRange :"Välj datumintervall",

 
  calPickDateAllDays :"Välj bara vissa veckodagar",
  calDaysMarked : (days:number) => `${days} valda dagar`,

  calWizardStart : "Startdatum",
  calWizardEnd : "Slutdatum",
  calWizardRepeat: "Efter hur många dagar upprepar sig schemat?",
  calWizardError : <span>För att kunna lägga ett schema enligt en mall så måste du välja en sammanhängande period om minst 10 dagar.</span>,
  calWizardCustomExplain : "I Nästa steg kan du göra schema i din egen variant. T.ex. för dig som jobbar skift.",
  calWizardEven : "I nästa steg kan du flytta bytesdagarna.",
  calWizardUneven : "I nästa steg kan du byta och flytta vem som har vilka dagar.",
  calWizardShift : "Flytta bytesdagar fram eller bak",
  calWizardWhereSleeps : "Var sover barnet?",
  calWizardWhereSleepsTip : "Tips: titta ovanför, schemat uppdateras när du klickar",
  calClickDaysToSwap : "Klicka på dagarna för att växla ansvar!",

  calSelectAll : (day:string) => `Välj alla ${day}ar?`,
  calSelectEveryOther : (day:string) => `Välj varannan ${day}?`,

  calParents: "Föräldrar",
  calForKids: "Det här schemat gäller för",

  calEntireSched : "Påverkar hela schemat",


  calSleepsAt: (name:string) => `${name} har ansvaret`,
  calChangeTimePlace: "Ändra plats och klockslag",
  calChildren : "Barn",
  calAddVisit : "Lägg till dagbesök",
  calShiftDays : "Flytta/invertera hela schemat",
  calMakeChangesFromDate : "Gör ändringar från datum",
  calWizard : "Använd mall",
  calAi : "Prompta fram ändringar",
  calClearDays : "Rensa dagar",


  calTimePlaceHelp:<span>Klicka på dagarna <b>med byten</b> som du vill ändra bytesdetaljer för.</span>,
  calDayvisitHelp:<span>Klicka på dagarna som du vill lägga till dagbesök på.</span>,
  calDayvisitTooShort : "Dagbesöket måste vara minst 15 minuter.",

  calEraseChange : (name:string) => `Detta schema raderas (${name}).`,

  calErrorApplySuggestion : "Förslaget kunde inte visas då de dagar som förslaget gäller redan har ändrats av ett annat förslag.",
  calErrorSuggestionNotFound : "Förslaget kan inte visas då det redan besvarats eller har raderats av den som skapade det.",
  calErrorDeleteSuggestion : "Radera förslag",

  calChatSuggestionTopic : (id:number) => `Schemaändring ${id}`,

  calInfo : "Information",
  calSuggestionAccepted : "Förslaget blev godkänt!",
  calSuggestionDeleted : "Förslaget raderades av din medförälder.",
  calSuggestionRejected : "Förslaget accepterades inte av din medförälder.",

  calMessage : "Meddelande",
  calAddMessage : "Vill du skicka med ett meddelande kan du skriva det här",

  calExchangeNoHandoverDays : "Dagarna du har valt resulterar inte i att du behöver skriva in bytesplats.",

  calWhenExchange : "När byte sker",
  calHandoverToFrom : (from: string, to: string) => `Från ${from} till ${to}`,
  calDayvistAt : (at: string) => `Hos ${at}`,

  calOccurences : (days:number) => ((days === 1)?`${days} tillfälle`:`${days} tillfällen`),
  calHandoverAtSchool : (school:SCHOOL_TYPES|undefined, age:number):string =>
    isPreschool(school, age) ? "Bytet sker på förskolan" : "Bytet sker på skolan",

  calPrivate : "Privat",
  calShared : "Delat",
  calActive : "Gällande",


  calParentingSchedules : "Boendeschema",
  calOldSuggestions : "Besvarade förslag",
  calSchoolSetting : "Förskola eller skola",
  calSchoolCalculatedOnAge : "Utifrån barnens ålder",
  calSchoolPreschool : "Förskola",
  calSchoolSchool : "Skola",
  calDeleteSchedules : "Radera schema",
  calDeleteSuggestion : "Radera förslag",
  calAdjustSuggestion : "Justera förslag",
  calMustBeShared : "Schemat måste delas med dig",
  calShareSchedule : "Dela schema",
  calMakeActive : "Välj som gällande",
  calMakeInactive : "Sluta använd schema",
  calMakeSuggestion : "Ändra specifika dagar",
  calMakeSuggestionGuide : "Ändra",
  calMakeNew : "Skapa ett till schema",
  calMakeNewWarningTitle : "Vill du verkligen skapa ett till schema?",
  calMakeNewWarning : <span>Det här är troligen inte vad du vill. Ett till schema används när du har flera barn som har olika scheman.<br/><br/>Vill du ändra det schema som redan finns? Klicka på <b>Nytt ändringsförslag</b> uppe till vänster, sedan på den röda skiftnyckeln och välj <b>Använd mall</b>.</span>,
  calMakeNewWarningContinue : "Skapa ändå",
  calSuggestionAwaitReply : "Väntar på svar",
  calSuggestionAwaitReplyFYou : "Väntar på svar från dig",
  calSuggestionFrom : (name:string, date:string) => `Förslag från ${name} ${date}`,
  calSuggestionSubAccepted : (name:string, date:string) => `Accepterat av ${name} ${date}`,
  calSuggestionSubRejected : (name:string, date:string) => `Nekades av ${name} ${date}`,
  calSuggestionSubDeleted : (name:string, date:string) => `Återkallades av ${name} ${date}`,
  calSuggestionStatusAccepted : (name:string, date:string) => <><b>Accepterat</b> av {name} {date}</>,
  calSuggestionStatusRejected : (name:string, date:string) => <><b>Nekades</b> av {name} {date}</>,
  calSuggestionStatusDeleted : (name:string, date:string) => <><b>Återkallades</b> av {name} {date}</>,
  calSuggestionErase : `Förslag att radera schemat`,
  calStopUsing : "Sluta använd",

  calGuideTopic : "Vill du använda en guide?",
  calGuideWhatGuide : "Om du vill ändra schematyp eller planera en ny period rekommenderar vi Guiden.",
  calGuideWhatTool : "För andra ändringar rekommenderar vi Verktyg.",
  calGuideUseGuide : "Guide",
  calGuideUseTool : "Verktyg",



  // ta inte bort dessa de är listan för sidebar
  settings: "Inställningar ",

 // sidebarnamn slut

  selectCalendarShow: "Välj bytesschema att visa",
  recentEvents: "Senaste aktivitet",
  deletedAccount: "Borttaget konto",
  support: "Support",
 

  // Todo
  todoYours: (date: string) => `Du gjorde detta ${date}`,
  todoNotYours: (name: string, date: string) => `${name} gjorde detta ${date}`,

  todoSeenBy: "Sedd av: ",
  packingSeenByAll: "Allt har setts av:",
  packingUnseenNotice: "Du har osedda saker i listan, scrolla ner för att se",
  packingGeneral: "Allmänt",
  packingTaggedChild: "Vems sak",
  todoTitleMin: (min: number) => `Skriv minst ${min} tecken`,
  sharedNoteUnseen: "Osedd",
  notShared : "Inte delad",
  todoSeenPrivate: (calendar:string) => `Från kalender ${calendar}. Kan bara ses av dig`,
  calUrlImp:  (shared?:boolean):string => shared?`Importerad från URL. Kan inte ändras`:`Importerad från URL. Kan inte ändras. Bara du kan se (ändra i import om du vill)`,
  calUrlInternal: (shared?:boolean):string => shared?`Byt grupp för att ändra`:`Byt grupp för att ändra. Bara du kan se (ändra i import om du vill)`,
  todoNextHandover: "Se nästa byte",

  timePickerFullDay: "Heldag",

  todoList: "ToDo",
  todoAssigned: "Ansvarig",
  todoResponsibleForCheckingOff: "Ansvarig för att bocka av",
  todoUnassigned: "Ej tilldelad",
  todoUnseen: "Osedd",
  todoDue: (date: string) => `Senast ${date}`,
  todoMarkComplete: (title: string) => `Klarmarkera: ${title}`,
  todoMarkIncomplete: (title: string) => `Markera som inte klar: ${title}`,
  todoHide: "Dölj",
  todoCompletedBy: (date: string | undefined, name: string) => `✔️ ${date ? date + " " : ""}av ${name}`,
  todoCalendarInfo: "Kalenderaktiviteter med klarmarkering, 3 dagar bakåt till 7 dagar framåt.",
  todoCalendarNoPeople: "Ingen vald",
  todoVisibleTooltip: "Synlig för",
  todoRenewalDropOff: "Den som överlämnar",
  todoRenewalPickUp: "Den som tar över",
  todoRenewalStatic: "Samma person varje gång",
  todoRenewalOnce: "Förnyas inte",

  todoRenewNo: "Upprepas inte",
  todoRenewHandover: "Upprepas nästa byte",

  // Next Handover
  handoverLocation: "Plats: ",

  nextHandoverTitle: (names: string) => `Nästa byte för ${names}:`,
  noDataForNextHandover: "Vi kan inte hitta nästa byte som du skall göra.",
  nextHandoverHasBeen: "Det här bytet har redan varit.",
  handoverExchange: (childrenNames: string, parentPickingUp: string, parentDroppingOff: string, startDate: Date, atSchool: boolean, location?: string,
    school?: SCHOOL_TYPES, age?: number) => {
    const day = baselanguage.handoverDay(startDate);
    let timeAndPlace;
    if (atSchool) {
      timeAndPlace = isPreschool(school, age) ? "på förskolan" : "på skolan";
    } else {
      timeAndPlace = baselanguage.handoverTimeAndPlace(startDate, location);
    }
    return `${parentDroppingOff} lämnar och ${parentPickingUp} hämtar ${day} ${timeAndPlace}.`;
  },
  handoverPickup: (atSchool: boolean, location?: string, school?: SCHOOL_TYPES, age?: number) => {
    if (atSchool) {
      return isPreschool(school, age) ? "Byte genom förskolan" : "Byte genom skolan";
    } else {
      return location ? ("Plats: "+location) : "Obestämd plats";
    }
  },
  handoverDropoff: (atSchool: boolean, location?: string, school?: SCHOOL_TYPES, age?: number) => {
    if (atSchool) {
      return isPreschool(school, age) ? "Byte genom förskolan" : "Byte genom skolan";
    } else {
      return location ? ("Plats: "+location) : "Obestämd plats";
    }
  },
  handoverDayAndTime: (startDate: Date) =>
    `${baselanguage.handoverDay(startDate)} kl ${TranslateNew.getInstance().formatTime(startDate)}`,
  handoverDay: (startDate: Date) => {
    if (isSameDay(startDate, new Date())) {
      return "Idag";
    } else if (isSameDay(startDate, addDays(new Date(), 1))) {
      return "Imorgon";
    } else {
      return baselanguage.getWeekdayName(startDate.getDay()) + ", "
        + startDate.getDate() + " " + baselanguage.getMonthName(startDate.getMonth());
    }
  },
  handoverTimeAndPlace: (startDate: Date, location?: string) => {
    let timeAndPlace = "kl " + TranslateNew.getInstance().formatTime(startDate);
    if (location) {
      timeAndPlace = timeAndPlace + " " + location;
    } else {
      timeAndPlace = timeAndPlace + " på obestämd plats";
    }
    return timeAndPlace;
  },

  // Labels
  labelLocation: "Plats",
  labelDescription: "Beskrivning",
  labelMessageOptional: "Meddelande (inte nödvändigt)",
  labelDisplay: (label: string) => `Visa ${label}`,
  labelEmail: "E-post",
  labelUsername: "Användarnamn",
  labelPassword: "Lösenord",
  labelSchoolStartEnd: (school:SCHOOL_TYPES|undefined, age:number):string =>
    isPreschool(school, age) ? "Förskolan börjar/slutar" : "Skolan börjar/slutar",
  labelParentsHome: (parent: string) => `hos ${parent}`,
  labelUnspecified: "Ospecificerat",
  labelTodos: "Att göra",
  labelEvents: "Aktiviteter",
  labelSchoolBreaks: "Skollov",
  labelFirstName: "Förnamn",
  labelSirName: "Efternamn",
  labelDateOfBirth: 'Född år',
  labelTitle: "Titel",
  labelMessage: "Meddelande...",
  signupTermsNoticeStart: "Genom att skapa ett konto godkänner du ",
  termsOfUseLinkText: "Användarvillkoren",
  signupTermsNoticeMiddle: " och bekräftar att du tagit del av ",
  privacyPolicyLinkText: "Integritetspolicyn",
  termsOfUseUrl: "https://www.varannanvecka.app/anvandarvillkor/",
  privacyPolicyUrl: "https://www.varannanvecka.app/integritetspolicy/",
  labelInviteToken: "Jag är inbjuden av en förälder och har en familjekod",
  copiedToClipboard: "Kopierat till urklipp",

  // Placeholders
  placeholderInviteToken: 'Skriv koden här',

  // Expert booking
  labelPhone: "Telefonnummer",
  inviteChooseContact: "Välj från kontakter",
  inviteOpeningContacts: "Öppnar kontakter…",
  inviteChooseContactPhone: "Välj telefonnummer",
  inviteContactNoPhone: "Kontakten saknar telefonnummer. Välj en annan kontakt eller skriv numret manuellt.",
  inviteContactInvalidPhone: "Numret kunde inte fyllas i. Kontrollera landskoden och skriv numret manuellt.",
  inviteContactError: "Det gick inte att öppna kontakter. Försök igen eller skriv numret manuellt.",
  inviteSmsConsent: "Jag bekräftar att den här personen har godkänt att få en engångsinbjudan via sms från Co-parenting.",

  getPhoneValidationMessage(countryCode: string): string {
    const errorMessagesMap: { [key: string]: string } = {
      "+46": "Formatet skall vara: 707123456",
      "+358": "Formatet skall vara: 401234567",
      "+47": "Formatet skall vara: 41234567",
      "+45": "Formatet skall vara: 20123456",
      "+34": "Formatet skall vara: 612345678",
      "+41": "Formatet skall vara: 791234567",
      "+49": "Formatet skall vara: 15123456789",
      "+33": "Formatet skall vara: 612345678",
      "+32": "Formatet skall vara: 471234567",
      "+31": "Formatet skall vara: 612345678",
      "+44": "Formatet skall vara: 7123456789",
      "+1":  "Formatet skall vara: 2125551234",

      "+354": "Formatet skall vara: 6123456",
      "+372": "Formatet skall vara: 51234567",
      "+371": "Formatet skall vara: 21234567",
      "+370": "Formatet skall vara: 61234567",
      "+353": "Formatet skall vara: 851234567",
      "+352": "Formatet skall vara: 62123456",
      "+43":  "Formatet skall vara: 6641234567",
      "+423": "Formatet skall vara: 6612345",
      "+377": "Formatet skall vara: 61234567",
      "+376": "Formatet skall vara: 312345",
      "+378": "Formatet skall vara: 666123456",
      "+39":  "Formatet skall vara: 3123456789",
      "+350": "Formatet skall vara: 57123456",
      "+351": "Formatet skall vara: 912345678",
      "+356": "Formatet skall vara: 99123456",
      "+30":  "Formatet skall vara: 6912345678",
      "+357": "Formatet skall vara: 96123456",
      "+48":  "Formatet skall vara: 512345678",
      "+420": "Formatet skall vara: 601234567",
      "+421": "Formatet skall vara: 901234567",
      "+36":  "Formatet skall vara: 201234567",
      "+386": "Formatet skall vara: 31234567",
      "+385": "Formatet skall vara: 912345678",
      "+387": "Formatet skall vara: 61123456",
      "+381": "Formatet skall vara: 611234567",
      "+382": "Formatet skall vara: 67123456",
      "+389": "Formatet skall vara: 71234567",
      "+355": "Formatet skall vara: 671234567",
      "+383": "Formatet skall vara: 43123456",
      "+359": "Formatet skall vara: 881234567",
      "+40":  "Formatet skall vara: 712345678",
      "+373": "Formatet skall vara: 62123456",
      "+380": "Formatet skall vara: 671234567",
      "+375": "Formatet skall vara: 291234567",
      "+7":   "Formatet skall vara: 9123456789",
      "+90":  "Formatet skall vara: 5012345678",
      "+995": "Formatet skall vara: 555123456",
      "+374": "Formatet skall vara: 77123456",
      "+994": "Formatet skall vara: 501234567",
      "+61":  "Formatet skall vara: 412345678",
      "+64":  "Formatet skall vara: 21234567",
      "+349": "Formatet skall vara: 612345678",
    };
    return errorMessagesMap[countryCode] || "Ogiltigt telefonnummerformat.";
  },

  validationEmailNotValid: "Ogiltig E-post!",
  validationEmailRequired: "Fyll i E-post!",
  validationFirstNameInvalid: "Ogiltigt förnamn!",
  validationFirstNameRequired: "Fyll i förnamn!",
  validationSirNameInvalid: "Ogiltigt efternamn!",
  validationSirNameRequired: "Fyll i Efternamn!",

  validationNewPasswordMin: (min: number) => `Minst ${min} tecken långt`,
  validationPasswordRequired: "Fyll i lösenord!",
  validationYearInvalid: "Ogiltigt år",
  validationChildMin: (min: number) => `Måste vara minst ${min} barn`,
  validationChildRequired: "Barn måste fyllas i",

  validationInvitationCode: "Ogiltigt format för inbjudningskod",
  validationInvitationCodeRequired: "Inbjudningskod krävs",


  // Landing

  landingTitle: <span>Allt om barnen på <i>ett</i> ställe</span>,
  landingImNewCreateAccount: "Skapa konto",
  landingUseBroswer: "Använd webversionen",

  // Selectlang
  swedish: 'Svenska',
  english: 'Engelska',
  swedishCompact: '🇸🇪',
  englishCompact: '🇬🇧',

  // Subscription and paywall
  subscription: 'Prenumeration',
  subscriptionPaywall: (style:React.CSSProperties) => 
    <ul style={style}>
      <li>Du har fått appen gratis och utan förbindelser.</li>
      <li>Appen är gratis för alla du bjuder in.</li>
      <li>Du har inte förbundigt dig till något när provperioden är över.</li>
    </ul>,

  // <span><b>Alla</b> i barnens familj har tillgång till appen om <b>en</b> förälder har en prenumeration.<ul><li>Ingen bindningstid</li><li>Bara en behöver betala.</li></ul></span>,
  // subscriptionFree: 'Lite mer gratis tack',
  // subscriptionPaywallFree: <span>Appen är <b>gratis</b> att utforska.<ul><li><b>Alla</b> i barnens familj har tillgång till appen om <b>en</b> förälder har en prenumeration.</li><li><b>Ingen bindningstid.</b></li><li>Det går att dela på kostnaden.</li></ul></span>,
  subApple: 'Prenumeration via Apple',
  subAppleTest: 'Prenumeration via Apple Sandbox',
  subGoogle: 'Prenumeration via Google',
  subGoogleTest: 'Prenumeration via Google Sandbox',
  subWeb: 'Prenumeration via Web',
  subWebTest: 'Prenumeration via Web Sandbox',
  subPlan: 'Din plan',
  subFullAccess: 'Full tillgång till hela appen.',
  subTimeLeft: 'Förnyas / löper ut:',
  subTimeOut: 'löpt ut',
  subByUser: (name: string) => `Betald av ${name}.`,
  subManage: "Du behöver inte betala något när din provperiod löpt ut. Prenumerationen övergår inte till en betald plan utan ditt uttryckliga samtycke.",
  subManageApp: "Du avbryter prenumerationen på telefonens inställningar, inte i den här appen.",

  initializing: "Initierar...",
  noPaymentYet: "Gratis just nu",
  noPurchasePossible: "Prenumerationsköp inte tillgängligt",
  subscriptionExists: "Klart!", 
  orderCancelled: "Order avbruten",
  sendingSubRequest: "Skickar till server",
  orderPending: "Väntar på att köpet skall bli klart",
  validatingSub: "Validerar prenumeration",
  subValidatingExisintg: "Validerar existerande prenumeration",
  savingSub: "Sparar prenumeration",
  freeTrial:" dagars provperiod",
  cancelTrial:"Ingen bindningstid - avbryt när du vill",


  // countries

  // campaign
  campaignTitle : "Specialerbjudande",
  campaignSpecialOffer : (benefactor:string) => `Du har ett erbjudande från ${benefactor} som bjuder på tjänsten initialt.`,
  campaignEnterEmail : "Skriv in din e-postadress så läggs erbjudandet på när du registrerar dig i appen med samma adress.",

  campaignKommun : (benefactor:string) => `Erbjudande för dig som bor i ${benefactor} kommun`,
  campaignKommun2 : (benefactor:string) => `Du som bor i ${benefactor} kommun får använda dig av appen Varannan vecka kostnadsfritt under 1 år från och med det datum du registrerar dig. Erbjudandet gäller för registreringar till och med 31 dec 2026.`,
  
  // Log in
  logInTitle: "Logga in",
  logInButton: "Logga in",
  useSavedPassword: "Använd sparat lösenord",
  savedPasswordUnavailable: "Inget sparat lösenord kunde hämtas. Du kan skriva in e-post och lösenord manuellt.",
  passwordSaveFailed: "Du är inloggad, men lösenordet kunde inte sparas i telefonens lösenordshanterare. Du kan försöka igen vid nästa inloggning.",
  logInForgot: "Glömt lösenord?",



  // Sign up
  signUpTitle: "Skapa konto",
  signUpInviteQuestion: "Har du blivit inbjuden av en annan förälder?",
  signUpJoinGroupButton: "Ja - gå med i grupp",
  signUpStartNewGroupButton: "Nej - starta ny grupp",
  signUpButton: "Skapa konto",
  signUpEmailUsed: "Det finns redan ett konto registrerat med den eposten.",
  signUpEmailUsedWithGuide: (<>
    <p>Det verkar som om ett konto har redan skapats med den eposten.</p>
    <p>Du kan registrera det nya kontot med en annan epostadress eller så loggar du in på ditt befintliga konto och raderar det under inställningar först.</p>
  </>),

  signUpHandoverTitle: "Justera bytesdagar",
  importWeekendsFor: "Skollov och helgdagar",
  importDaysOffFor: 'Går barnen i skola? Vi lägger in alla skollov och helgdagar åt dig. ',
  importDaysArea: 'Välj kommun',
  signupCampaign: 'Med specialerbjudande från',

  geoLocAuto: "Hitta min kommun automatiskt",
  geoLocSearching: "Söker",
  geoLocNotSupported: "Geolocation saknas",
  geoLocDone: "Geolocation klar",
  geoLocUserDenied: "Ej tillåtet",
  geoLocUnavail: "Geolocation saknas",
  geoLocTimeOut: "Timed out",
  
  // calling
  calling : "Ringer till...",
  calledBy : "ringer dig",
  called : (name:string) => `${name} ringde`,
  calledFor : (seconds:string) => " i "+seconds+"s och lade sedan på.",
  callRangFor : (seconds:string) => " i "+seconds+"s.",
  callDeclined : (name:string) => `${name} avböjde`,
  callAnswered : (name:string) => `${name} svarade`,
  callRejected : (name:string) => `${name} avvisade`,
  callNoAnswer : (name:string) => `${name} svarade ej`,
  callTechError : (name:string) => `${name} tekniskt fel`,
  callTechErrorSeconds : (name:string, seconds:string) => `${name} fick tekniskt fel efter ${seconds} sekunder`,
  callDuration : (duration:number) => `Samtalet varade i ca ${duration} min`,
  callsRecorded : "Videosamtalet spelas in och sparas",
  callRecording : "Samtalets skrivs ner till fil, det kan dröja några minuter innan den är tillgänglig.",
  callNewFunctionality : "Samtal är en ny funktionalitet under utveckling. Ge gärna feedback i support-chatten!",
  callTurnOff : "Vill du inte kunna bli uppringd kan du stänga av funktionen i ",
  videoOn: "Video är på",
  videoOff: "Video är av",
  callPermissionTitle : "Behörighet saknas",
  callPermission : <span>Du behöver ge appen behörighet att använda mikrofon och kamera för att kunna göra samtal. Prova att <b>slå av och på behörigheten</b> i inställningarna.</span>,
  callPermissionBrowser : <span>Du behöver tillåta mikrofon och kamera i webbläsaren för att kunna göra samtal. Kontrollera behörigheten för den här sidan i webbläsaren och prova sedan samtalet igen.</span>,


  longpressToDownload : "Långtryck bilden och ladda ner",

  // Sign upinvite
  signUpInviteError: `Ingen inbjudan matchar koden, eller så är den redan använd! Dubbelkolla att den verkligen stämmer!`,
 
  // Messages create
  chatSubject : "Ämne",
  createChatNoTopic: 'Chattämne måste anges',
  createChat: 'Skapa',
  createNewChat: "Skapa en ny chattråd",
  editChat: "Ändra chatt",
  noMessagesYet: 'Inga meddelanden än 🤷',
  chatSeen: (names: string) => `Sett av ${names}`,
  chatReadBy: (readers: string) => `Läst av ${readers}`,
  chatArchivedBy: (names: string) => `Arkiverad av: ${names}`,
  chatSearch:"Sök...",
  chatArchive: "Arkivera",
  chatCall: "Ring",
  chatCallUnavailableSupport: "Samtal är inte tillgängligt i support-chatten",
  chatCallUnavailableSignup: (names: string) => `${names}: har inte registrerat sig`,
  chatCallUnavailableDisabled: (names: string) => `${names}: har stängt av samtal`,
  chatUnarchive: "Återställ",
  chatNameChange: "Ändra",
  chatGenerateIcon: "Generera ikon",
  chatGeneratingIcon: "Genererar ikon...",
  chatGenerateIconFailed: "Kunde inte generera en ikon. Försök igen.",
  chatPolish: "Finslipa",
  chatPolishing: "Finslipar...",
  chatPolishFailed: "Misslyckades, försök igen",
  chatReply: "Svara",
  chatReplyTo: "Svar på:",
  chatReplyingTo: "Svarar på:",
  chatReplyToEarlierMessage: "ett tidigare meddelande",
  chatCancelReply: "Avbryt svar",
  chatShowArchive: "Visa arkiv",
  chatHistorySaved: "Chatt-historik skickas till din e-postadress. Det kan ta några minuter.",
  chatCheckIn: "Dela din plats",
  chatCheckInTitle: "Dela din plats?",
  chatCheckInConfirm: "Din nuvarande plats läggs upp i chatten, så att alla i den kan se var du är.",
  chatCheckInLocating: "Hämtar din plats…",
  chatCheckInDeniedTitle: "Platsåtkomst saknas",
  chatCheckInDenied: "Appen behöver få använda din plats för att du ska kunna dela den. Slå på platsåtkomst för appen i inställningarna.",
  chatCheckInDeniedBrowser: "Webbläsaren behöver få använda din plats för att du ska kunna dela den. Tillåt plats för den här sidan i webbläsarens inställningar och försök igen.",
  chatCheckInUnavailable: "Det gick inte att hitta din plats. Kontrollera att platstjänster är påslagna och försök igen.",

  // Gif
  chatGifSearch: "Sök efter GIF",
  


  // ChildInfo
  vaccineDose : "Dos",
  vaccineDate : "Datum",
  vaccineNextDose : "Nästa dos",
  vaccineAdd: "Lägg till vaccination",
  vaccineNew: "Ny vaccination",
  vaccineEmpty: "Inga vaccinationer tillagda än.",
  vaccineNamePlaceholder: "Vaccinationens namn",
  vaccineDosesReceived: "Antal doser",
  vaccineLastDose: "Senaste dosen",
  vaccineSelectDate: "Välj datum",
  vaccineIncreaseDose: "Öka antal doser",
  vaccineDecreaseDose: "Minska antal doser",
  vaccineRemoved: "Vaccination borttagen",
  vaccineNameRequired: "Ange vaccinationens namn.",
  vaccineDosesInvalid: "Ange ett heltal, 0 eller högre.",

  childInfoSocialNo: 'Personnummer',
  childInfoPassNo: 'Passnummer',
  childInfoPassLoc: 'Var är passet?',
  childInfoClothing: 'Klädstorlek ',
  childInfoShoeSize: 'Skostorlek ',
  childInfoMeds: 'Med. / allergi',
  childInfoAllergies: 'Övrigt',
  childInfoInsurance: 'Försäkring',
  childInfoVaccination: 'Vaccination',
  childInfoVaccinations: 'Vaccinationer',
  childInfoPassHistory: 'Historik: Var är passet?',
  childInfoNoData: 'Ingen data inlagd än',
  childInfoVaccSubline:(date:string, dose:number) => `${date ? date + ", " : ""}dos ${dose}`,

  // avatar
  avatarDrawn : 'Ritad avatar',
  avatarPhoto : 'Foto',

  // flow post
  flowPostNew: 'Dela bild',
  flowPostSddComment: 'Lägg till en kommentar...',
  flowTip1 : 'Att vara generös och dela bilder och annan info bygger starka föräldrateam runt barnen.',
  flowTip2 : 'Tips: Dela din favorit-bild på barnen!',

  flowPostRecentActionImageUploaded:` laddade upp en bild.`,

  sharedTaskHelper: "Dela på uppgifterna med tydlig ansvarsfördelning och påminnelser från oss!",


  // AI stuff
  aiOnboardingSlide1Title : <span>Låt AI göra det <span style={{color:secondaryColor}}>tråkiga</span> jobbet!</span>,
  aiOnboardingSlide1Text : "Oavsett om det är en kalasinbjudan, skolaktivitet eller veckans läxor så hämtar vår AI informationen åt dig.",
  aiOnboardingSlide2Title : "Gör så här",
  aiOnboardingSlide2Text : "Ta ett foto eller välj en skärmdump",
  aiOnboardingSlide3Title : "Vi analyserar",
  aiOnboardingSlide3Text : "Vår AI scannar bilden efter datum, tid och annan info så bekräftar du att vi gjort rätt.",
  aiOnboardingSlide4Title : <span>Fungerar med <span style={{color:primaryColor}}>allt!</span></span>,
  aiOnboardingSlide4Text : "Kalasinbjudningar, tandläkartid, träningar, SMS, e-post, skolplattform, till och med vanliga lappar!",
  aiOnboardingSlide4Button : "Nu kör vi!",


  // shared notes
  sharedSharedAccounts: "Konton",
  sharedSharedNotes: "Notes",
  sharedNoteVisible: 'Synlig för',
  sharedNoteCreated: (title: string) => `skapade en lista "${title}"`,
  sharedNoteModified: (title: string) => `ändrade en lista "${title}"`,
  sharedNoteHelper: "Här kan ni enkelt dela önskelistor, inköp eller packlistor inför sommarlägret. \n\nTips: AIn kan sortera sakerna i listan. Gör en privat matvarulista till ICA och testa!",
  sharedAccountHelper: "Finns det kanske någon streaming-tjänst eller PIN-kod som barnet har? Lägg in kontot och dela på kostnaden!",
  sharedNoteGeneratingIcon: "Skapar ikon",
  service: "Tjänst",
  selectService: "Välj tjänst",
  otherStreamingService: "Annan tjänst",
  otherStreamingServiceDesc: "Streamingtjänst",
  reorderNotes: "Ändra ordning",
  promptSharedNote: "Prompta ändring",
  sharedNoteAddText: "Lägg till text",
  sharedNoteGenerateIcon: "Generera ikon",
  sharedNoteCreate:"Ny lista",
  sharedNoteEdit:"Modifiera lista",

  // shared note AI
  sharedNoteExamplePromptTitle1:"Meny för veckan",
  sharedNoteExamplePromptPrompt1:"Gör ett förslag på menyn till veckan som kommer. Sätt veckans dagar som rubriker. För varje dag skapa två olika alternativ av lättlagad mat.",
  sharedNoteExamplePromptTitle2:"Packlista till resan",
  sharedNoteExamplePromptPrompt2:"Skapa en packlista för en 12 åring som skall på sommarläger i 7 dagar. Inkludera antal av varje sak. Skapa lämpliga rubriker med emojis.",
  sharedNoteExamplePromptTitle3:"Sommarplaner",
  sharedNoteExamplePromptPrompt3:"Ge förslag på 20 sommaraktiviteter att göra tillsammans med barn i åldrarna 9 och 12 år. Gruppera med rubriker som innehåller emojis.",
  sharedNoteExamplePromptTitle4:"Filmer att se",
  sharedNoteExamplePromptPrompt4:"Lista 30 filmer som är roliga för en familj med barn i åldrarna 9-12 år, inkludera rotten tomatoes betyg för varje film. Gruppera dem i lämpliga kategorier.",
  sharedNoteExamplePromptTitle5:"Presenter",
  sharedNoteExamplePromptPrompt5:"Ge 10 förslag på presenter till en kille som är 9 år. Pris runt 150kr",
  sharedNoteExampleHandover:"Överlämningsbrev",

  sharedNoteExampleEditPromptTitle1:"Gruppera listan",
  sharedNoteExampleEditPromptPrompt1:"Ordna listan i lämpliga grupper med rubriker. Om det är en inköpslista gruppera enligt butikens olika sektioner. Om passande använd emojis i rubrikerna.",
  sharedNoteExampleEditPromptTitle2:"Skapa Inköpslista",
  sharedNoteExampleEditPromptPrompt2:"Baserat på innehållet i listan; gör en inköpslista på saker som jag behöver. Behåll orginallistan överst med samma rubriker och skapa en inköpslista under grupperat i olika sektioner.",
  sharedNoteExampleEditPromptTitle3:"Överlämningsbrev",
  sharedNoteExampleEditPromptPrompt3:(coparentName:string, childrenNames:string) => "Baserat på min lista skriv en anteckning hur barnen ("+childrenNames+") har haft det i perioden de bodde hos mig. Skriv det som en text och inte som en lista.",
  

  // Settings
  account: "Konto",
  preferences: "Preferenser",
  settingsChat: "Chatt",
  changePassword: "Byt lösenord",
  changeEmail: "Byt e-post",
  eraseAccount: "Radera konto",
  newPassword: "Nytt Lösenord",
  newEmail: "Nytt e-post",
  emailUpdated: "E-post uppdaterad!",
  allowCalls: "Tillåt samtal",
  notifyHandover: "Notifieringar: Inför byte",
  notifyMorningSummary: "Notifieringar: Morgonsammanställning",
  muteListNotifications: "Notifieringar: listuppdateringar",
  emailMissedMessages: "Skicka missade chatmeddelande med epost",
  messageScreening: "Granskning av meddelanden",
  messageScreeningNormal: "Normal",
  messageScreeningStrict: "Strikt",
  messageScreeningVeryStrict: "Mycket strikt",
  veryStrictScreeningTitle: "Slå på mycket strikt granskning?",
  veryStrictScreeningWarning: "Mycket strikt granskning kan av misstag stoppa meddelanden som inte är olämpliga. Den gäller för alla deltagare i alla chattar.",
  veryStrictScreeningConfirm: "Ja, slå på",
  disablePreviews: "Inaktivera förhandsvisning av meddelanden från mig",
  chatPreviewHidden: (name: string) => `Ett meddelande från ${name}`,
  autoApproveSuggestions: "Godkänn förslag automatiskt",
  autoApproveSuggestionsTitle: "Godkänna förslag till dig automatiskt?",
  autoApproveSuggestionsWarning: "Förslag som den andra föräldern skickar till dig godkänns automatiskt, som om du själv hade klickat på Godkänn direkt. Det gäller bara förslag till dig: de du själv skickar behöver fortfarande godkännas av den andra föräldern.",
  autoApproveSuggestionsConfirm: "Jag förstår, slå på",
  settingsDownload: "Ladda ner",
  downloadScheduleChanges: "Ladda ner schemaändringar",
  downloadEconomy: "Ladda ner ekonomi",
  downloadTodos: "Ladda ner att göra",
  todosExportEmailQueued: "Din att göra-PDF skickas till din e-postadress inom en minut.",
  strictToxicFilterHelp: "Så fungerar AI-filtret",
  enhancedVisibility: "Större font",
  darkMode: "Mörkt läge",
  darkModeSameAsPhone: "Samma som telefonen",
  darkModeAlwaysDark: "Alltid mörkt",
  darkModeAlwaysLight: "Alltid ljust",
  gmailSettingsHeading: "E-post integration",
  gmailSettingsExplanation: "Du kan vidarebefordra mail till Varannan Vecka (t.ex. veckobrev från skolan) så tolkar vi det åt dig och ger förslag på aktiviteter som behöver läggas in i kalendern.",
  emailIntegrationActivate: "Aktivera",
  emailIntegrationActivating: "Aktiverar…",
  emailIntegrationForwardTo: "Vidarebefordra brev till",
  emailIntegrationCopied: "Kopierad!",
  emailIntegrationCopyError: "Det gick inte att kopiera. Markera och kopiera adressen manuellt.",
  emailIntegrationAddContact: "Lägg till i kontakter",
  emailIntegrationOpeningContacts: "Förbereder kontakt…",
  emailIntegrationContactName: "Varannan Vecka",
  emailIntegrationContactError: "Det gick inte att förbereda kontakten. Försök igen eller kopiera adressen och skapa kontakten manuellt.",
  emailIntegrationGmailHeading: "Gmail™-integrationen",
  emailIntegrationError: "Det gick inte att hämta eller aktivera e-postadressen. Försök igen.",
  emailIntegrationUnavailable: "E-postadressen är inte tillgänglig just nu.",
  emailIntegrationActivationError: "Det gick inte att aktivera e-postadressen. Försök igen.",
  gmailInstallAddon: "Installera Gmail™-tillägg",
  gmailInstallStepOne: "Installera tillägget med ditt Google-konto.",
  gmailInstallStepTwo: "Öppna ett e-postmeddelande i Gmail™ och välj Co-parenting.",
  gmailInstallPlatforms: "En installation fungerar i Gmail™ på dator, Android och iPhone.",
  gmailConnectedDate: (date: string) => `ansluten ${date}`,
  gmailDisconnect: "Koppla från Gmail™",
  gmailDisconnectConfirmation: (email: string) => `Koppla från ${email}? E-postmeddelanden kan inte längre läggas till från det här Gmail™-kontot.`,
  gmailConnectionStopped: "Anslutningen stoppades eftersom åtkomsten till privat e-post återkallades.",
  gmailReconnect: "Återanslut i Gmail™",
  gmailReconnectInstructions: "Öppna ett e-postmeddelande i Gmail™, välj Co-parenting och tryck på Anslut.",
  gmailSettingsOffline: "Du verkar vara offline. Kontrollera anslutningen och försök igen.",
  gmailSettingsUnauthorized: "Din session har gått ut. Logga in igen för att hantera Gmail™.",
  gmailSettingsError: "Det gick inte att läsa Gmail™-anslutningar. Försök igen.",
  gmailDisconnectError: "Det gick inte att koppla från Gmail™. Försök igen.",
  gmailDisconnecting: "Kopplar från…",
  gmailDisconnectRetry: "Försök koppla från igen",
  gmailInstallationUnavailable: "Installationslänken till Gmail™-tillägget finns inte här ännu. Har du redan installerat tillägget, öppna ett mejl i Gmail™, välj Co-parenting och tryck på Anslut.",

  // Gmail add-on connection confirmation
  gmailConnectHeading: "Anslut Gmail™",
  gmailConnectQuestion: (email: string, family: string) => `Anslut ${email} till ${family}?`,
  gmailConnectExplanation: "Det här gör att du kan skicka ett öppet e-postmeddelande från Gmail™ till Co-parenting för förslag på händelser.",
  gmailChooseFamily: "Välj vilken familj eller kalender som ska ta emot förslagen.",
  gmailFamilyLegend: "Familj eller kalender",
  gmailConnectButton: "Anslut",
  gmailCheckingLink: "Kontrollerar anslutningslänken…",
  gmailConnectedHeading: "Gmail™ är anslutet",
  gmailConnectedText: (email: string, family: string) => `${email} är ansluten till ${family}. Välj Återvänd till Gmail™ för att stänga fönstret och uppdatera tillägget. Om tillägget fortfarande ber dig att ansluta, klicka på Uppdatera.`,
  gmailReturnToGmail: "Återvänd till Gmail™",
  gmailCloseFallback: "Om fönstret inte stängs automatiskt kan du stänga det och återvända till Gmail™.",
  gmailCancelledHeading: "Anslutningen avbröts",
  gmailCancelledText: "Inga ändringar gjordes. Du kan stänga det här fönstret och återvända till Gmail™.",
  gmailLinkExpired: "Den här anslutningslänken har gått ut. Återvänd till Gmail™ och tryck på Anslut igen.",
  gmailAccountConflict: "Det här Gmail™-kontot är redan anslutet. Koppla först från det i Co-parenting-inställningarna och försök sedan igen.",
  gmailNoAuthorizedFamilies: "Du har inga familjer som kan ta emot e-post ännu. Skapa eller gå med i en familj under Familjeinställningar, återvänd sedan hit och försök igen.",
  gmailOpenFamilySetup: "Öppna familjeinställningarna",
  gmailOfflineError: "Du verkar vara offline. Kontrollera anslutningen och försök igen.",
  gmailServerError: "Gmail™ kunde inte anslutas just nu. Försök igen.",
  showLocalCal: "Visa kalendrar från telefonen",
  addChild: "Lägg till barn",
  addUserAsView: (name:string) => "+"+name+" som medlem",
  addViewer: "Lägg till viktig vuxen",
  addParent: "Lägg till förälder",
  addUserName: (name:string) => "Är du säker på att du vill lägga till "+name+" i den här gruppen?",
  addUser: "Lägg till medlem",

  // COPPA - the invite is blocked from US time zones unless the child is provably 13
  coppaInviteBlockedTitle: "Inbjudan kan inte skickas",
  coppaInviteBlockedLaw: "Den amerikanska lagen COPPA (Children's Online Privacy Protection Act) skyddar barn under 13 år. Ett barn under 13 år får därför inte bjudas in till ett eget konto i den här tjänsten.",
  coppaInviteBlockedNextStep: (name: string) => `${name} finns kvar i gruppen och du planerar schemat precis som vanligt. Du kan skicka en inbjudan när ${name} har fyllt 13 år.`,
  coppaInviteBlockedUnknownAge: (name: string) => `Det finns inget födelseår registrerat för ${name}, så vi kan inte fastställa att barnet har fyllt 13 år. ${name} finns kvar i gruppen och du planerar schemat precis som vanligt.`,
  coppaInviteBlockedTheChild: "Barnet",

  extendedFamily: "Varannanvecka-grupp",
  logout: "Logga ut",
  createNewFamily: "Skapa en till grupp",
  newGroup:"Ny grupp",
  switchGroup: "Byt grupp",
  deleteGroup: "Radera grupp",
  deleteGroupTitle: "Radera grupp?",
  deleteGroupWarning: (name: string) => `${name} tas bort från ditt konto och du byter till en av dina andra grupper. Det går inte att ångra.`,
  deleteGroupFailed: "Gruppen kunde inte raderas. Försök igen.",
  groupDeleted: (name: string) => `${name} raderades`,
  createNewFamilyInfo: "Om du har barn med en annan förälder (separerad eller inte) kan du skapa en till grupp och bjuda in dem till den gruppen.",
  createNewFamilyInfo1: "Efter att du skapat en ny grupp kan du växla grupp i drop-down som kommer upp.",
  createNewFamilyName: "Namn på gruppen",
  seperated: "Bor separerat",
  synchCal: "Exportera kalender",
  importExportCal: "Importera / Exportera",
  missingTitle: "Titel saknas",

  role: (role: FamilyMemberType): string => {
    switch (role) {
      case FamilyMemberType.CHILD:
        return "Barn";
      case FamilyMemberType.DELETED:
        return "Raderad";
      case FamilyMemberType.EXPERT:
        return "Expert";
      case FamilyMemberType.MODERATOR:
        return "Admin";
      case FamilyMemberType.PARENT:
        return "Förälder";
      case FamilyMemberType.VIEWER:
        return "Viktig vuxen";
      default:
        return "Okänd";
    }
  },

  implement: "Implementeras inom kort",

  // erase account
  eraseAccountSure: "Är du säker på att du vill radera ditt konto?",
  eraseAccountSurePt2: "Vänligen observera att om du har betalat för en prenumeration till den här tjänsten avbryts den i inställningar på din telefon och inte i denna app.",
  eraseAccountYes: "RADERA mitt konto",

  toxicSheetTitle: 'Det här meddelandet kan vara otrevligt',
  // link renders its text as a link to toxicSheetArticleLink
  toxicSheetInfo: (link: (text: string) => React.ReactNode) =>
    <>Den här typen av meddelanden är ofta skadliga och kan {link('påverka ditt barn negativt')}.</>,
  toxicSheetBlockedTitle: 'Det här meddelandet kan inte skickas',
  toxicSheetBlockedInfo: (link: (text: string) => React.ReactNode) =>
    <>Det är konfliktdrivande, och toxisk kommunikation mellan föräldrar {link('påverkar barn negativt')}.</>,
  toxicSheetArticleLink: 'https://www.varannanvecka.app/artikel/toxiska-meddelanden-till-medforaldern-sa-paverkas-barnet/',
  toxicSheetAiSuggestion: 'AI:s förslag:',
  toxicSheetNoSuggestion: 'AI:n kunde inte föreslå något annat sätt att skriva det här.',
  toxicSheetUseSuggestion: 'Använd förslag',
  toxicSheetEditMyself: 'Redigera själv',
  toxicSheetSendAnyway: 'Skicka ändå',
  toxicSheetDelete: 'Radera meddelande',

  // Family Settings
  locationAndTimezone: "Helgdagar och tidszon",


  settingsUpdateFamilyMemberName: (name: string) => `Uppdatera ${name}`,
  settingsUserStatusInvited: (email: string, date: string) => `Har aldrig loggat in, inbjuden ${email} ${date}`,
  settingUserStatusNotInvited: "Är inte inbjuden ännu",
  settingUserStatusLastSeen: (date: string) => `Senast online ${date}`,
  settingUserStatusOnline: "Online",
  restoreAccount: "Återställ konto",
  restoreAccountDeletedHelper: "Användaren har raderat sitt konto. Du kan skicka en återställningslänk här.",
  restoreAccountInstructionsSent: "Instruktioner för hur kontot återställs har skickats till användaren",
  nudgeToLogIn: "Hjälp att logga in",
  nudgeToLogInInstructionsSent: "Instruktioner för hur man loggar in har skickats till användaren",
  limitedAccess: "Begränsad åtkomst",
  limitAccess: "Begränsa åtkomst",
  unlimitAccess: "Ta bort begränsning",
  limitAccessWarning: (name: string) => `${name} kan fortfarande se allt som delas, men kan inte längre skicka meddelanden eller skapa/ändra något. Du kan ta bort begränsningen när som helst.`,
  deleteChildWarningTitle: "Vill du verkligen radera barnet?",
  deleteChildWarning: (name: string) => `Om du raderar ${name} ur gruppen försvinner mycket av funktionaliteten för barnet, till exempel boendescheman och barninfo.`,
  deleteChildWarningNotUser: "Att ett barn finns i gruppen betyder inte att barnet är användare i appen.",
  deleteChildWarningOnlyIf: "Radera bara barn som har lagts in av misstag eller som inte är gemensamma barn.",
  settingsPickImage: "Välj bild",
  settingsAdjustImage: "Justera bild",
  settingsColorChoice : "Färgvalet syns bara för dig",
  // Cookie Banner

  // Settings export
  selectWhatToExportDetail: `Markera om aktiviteter, uppgifter och skollov skall exporteras.`,
  settingsExportCalendar: "Vilket eller vilka bytesscheman vill du visa?",


  settingsExportAppleDevice: "Till mobiltelefonen",
  settingsExportAppleGmail: "Google Calendar / Gmail",
  settingsExportOutlookOnline: "Outlook online, Hotmail, Live",
  settingsExportOutlook: "Program på datorn, t.ex. Outlook",
  settingsExportInfoLinkManuel: "I andra kalendrar ej listade ovan kan du ofta importera en kalender, du skall då importera följande länk:",
  settingsExportDelayInfo: "Det kan ta lite tid innan ändringar syns i din kalender. Det är tyvärr inget vi kan påverka utan bestäms av din kalender.",


  settingsImportComputer: "Den här funktionen fungerar bara i appen på din telefon inte via web-versionen.",
  settingsImportInfo: "Ingen information här förs över till någon annan i gruppen. Vill du importera en kalendrar och dela den måste du 'importera via länk' i menyn.",

  settingsSubscriptionsHeader : "Prenumeration",


  // Calendar
  calFullDay: "Heldag",
  calenderPublicHolidays: 'Helgdagar',
  
  // New calendaronboarding
  newCalendarChildrenTitle: "Bytesdagar",
  newCalendarChildrenMainText: "Lägg in bytesdagarna genom att göra ett schemaförslag. Du kan alltid göra om eller ändra i det senare.",
  newCalendarSureCancel: "Är du säker? Mycket av funktionaliteten i appen (packlista med mera) bygger på att det finns ett schema i appen. Du kan alltid ändra schemat senare.",
  newCalendarChildrenSubTitle: "Schemat ska gälla för",
  newCalendarStartDateTitle: "Välj startdatum för schemat",
  newCalendarEndDateTitle: "Välj slutdatum för schemat",
  newCalendarTemplateTitle: "Välj schema",
  newCalendarTemplateCustomTitle: "Skapa mall för bytesdagar",
  newCalendarTemplateCustomSubtitle: "Välj vem som har ansvaret för vilka dagar",
  newCalendarRepeat: "Efter hur många veckor upprepar sig schemat?",
  newCalendarTemplateSubTitle: <span>Välj det schema som bäst visar era bytesdagar (nu eller i framtiden).<br/>Om inget alternativ är som du vill ha det, välj “Egen variant”.</span>,
  newCalendarAdjustSubTitle: "Eller Justera bytesdagarna genom att trycka på \"",
  newCalendarHandoverTitle: "Var och när sker bytet?",
  newCalendarWithParent: (parentName: string) => `Med ${parentName}`,
  newCalendarWhereIsHandover: (parent: string, date: string) =>
    <>Välj plats och tid när {parent} ska ta över ansvaret på {date}.</>,

  calendarTemplateName : (template : TemplateName):string => {
    if (template === TemplateName.ALTERNATING_WEEKS ) {return "Varannan Vecka";}
    else if (template === TemplateName.T3443 ) {return "3, 4, 4, 3";}
    else if (template === TemplateName.T223 ) {return "2, 2, 3";}
    else if (template === TemplateName.T255 ) {return "2, 2, 5, 5";}
    else if (template === TemplateName.T3NIGHTSPW ) {return "3 nätter per vecka";}
    else if (template === TemplateName.T2NIGHTSNPW ) {return "2 nätter per vecka";}
    else if (template === TemplateName.T6NIGHTS8NIGHTS ) {return "6 nätter varannan vecka";}
    else if (template === TemplateName.T5NIGHTS9NIGHTS ) {return "5 nätter varannan vecka";}
    else if (template === TemplateName.T4NIGHTS10NIGHTS ) {return "4 nätter varannan vecka";}
    else if (template === TemplateName.T3NIGHTS11NIGHTS ) {return "3 nätter varannan vecka";}
    else if (template === TemplateName.T2NIGHTS12NIGHTS ) {return "2 nätter varannan vecka";}
    else if (template === TemplateName.TDOUBLEWEEK ) {return "2 Veckors";}
    else if (template === TemplateName.TTENELEVEN ) {return "10/11 nätter";}
    else if (template === TemplateName.CUSTOM ) {return "Egen variant";}
    else {return "Okänt";}
  },


  // CalendarTemplatesError
  CalendarTemplatesErrorChildren: "Vänligen välj minst ett barn",
  CalendarTemplatesErrorTemplate: "Vänligen välj en mall",
  CalendarTemplatesErrorHandover: "Alla fält måste fyllas i",


  // New calendar onboarding buttons
  newCalendarTwoParents: "För att skapa ett nytt schema måste familjen ha två föräldrar och minst ett barn. Lägg till familjemedlemmar under Inställningar",
  newCalendar: "Nytt schema",


  // Calendar status description


  // Event
  unseenEvent : "Osedd aktivitet",
  eventYearly: "Årsvis",
  eventMonthly: "Månadsvis",
  event4Weeks: "4e vecka",
  eventBiWeekly: "Varannan vecka",
  eventDescriptionOptional: "Beskrivning (frivilligt)",
  eventLastOccurence: "Sista datum",
  eventOccurences: "Tillfällen",
  eventReoccuring: "Återkommande",
  eventStart: "Start",
  eventEnd: "Slut",
  eventWeekly: "Veckovis",
  eventRecentActionUnknown: " Okänd handling 🤷‍♂️",
  eventRecentActionAgreementResponded: (action: number) => ` svar till kommande köp #${action}`,
  eventRecentActionAgreementSuggested: (action: number) => ` föreslog nytt kommande inköp #${action}`,
  eventRecentActionFamilyCreated: " skapade den här Varannanvecka gruppen",
  eventRecentActionFamilyMemberCreate: (action: string) => ` lade till ${action}`,
  eventRecentActionFamilyMemberDelete: (action: string) => ` tog bort ${action}`,
  eventRecentActionFamilyMemberInvite: (action: string) => ` bjöd in ${action}`,
  eventRecentActionFamilyMemberModify: (action: string) => ` ändrade ${action}`,
  eventRecentActionHolidaysScheduleUpdated: " uppdaterade högtider",
  eventRecentActionScheduleShare: " uppdaterade schemat",
  eventRecentActionSchooldaysScheduleUpdated: " uppdaterade skoldagar",
  eventRecentActionSuggestionAccepted: (action: number) => ` godkände bytesändring #${action}`,
  eventRecentActionSuggestionCreated: (action: number) => ` föreslog bytesändring #${action}`,
  eventRecentActionSuggestionRejected: (action: number) => ` nekade bytesändring #${action}`,
  eventRecentActionEventCreated: (actionTitle: string) => ` skapade aktivitet ${actionTitle}`,
  eventRecentActionEventGroupCreated: (actionTitle: string) => ` skapade aktivtet ${actionTitle}`,
  eventRecentActionEventModified: (actionTitle: string) => ` ändrade aktivtet ${actionTitle}`,
  eventRecentActionEventGroupModified: (actionTitle: string) => ` ändrade aktivitet ${actionTitle}`,
  eventRecentActionEventDeleted: (actionTitle: string) => ` tog bort aktivtet ${actionTitle}`,
  eventRecentActionEventGroupDeleted: (actionTitle: string) => ` tog bort aktivtet ${actionTitle}`,
  eventRecentActionTodoCreated: (todoTitle: string) => ` skapade uppgift ${todoTitle}`,
  eventRecentActionTodoModified: (todoTitle: string) => ` ändrade uppgift ${todoTitle}`,
  eventRecentActionTodoDeleted: (todoTitle: string) => ` raderade uppgift ${todoTitle}`,
  shareFutureEvents: "Dela aktiviteter?",
  shareEventWithImportantAdult: "Vill du dela befintliga aktiviteter med ",
  // handover editor

  handoverLocationLabel: "Plats",

 


  // schedule selector

  selectedAsActiveBy: (names: string) => `Valt som gällande av ${names}`,
  selectedAsActiveByExluding: (names: string) => `, men inte av ${names}`,
  scheduleUsingDifferent: "Ni använder olika scheman!",
  scheduleUsingDifferentUses: " använder ",


  // schedule selector page
  scheduleNamePlaceholder: "Schemanamn",
  renameSchedule: "Byt namn på schema",
  calendarLayout: "Kalenderlayout",

  scheduleShowWeeks: "Visa veckonummer",
  scheduleShowOnlyMyWeeks: "Visa bara mina veckor",
  // Svenska namn som slutar på s, x eller z får ingen extra genitiv-s ("Lars veckor").
  scheduleShowOnlyWeeksOf: (name:string) => `Visa bara ${/[sxz]$/i.test(name) ? name : name + "s"} veckor`,
  scheduleShowOnlyMyWeeksQuestion: "För att översikten skall bli tydligare, vill du bara visa dina egna veckor? (du kan ändra tillbaka i menyn om du vill)",
  scheduleShowActivities : "Visa aktiviteter",


  // Schedule
  schedulePickup: "Byte",

  handoverExplain1 : "Överlämningen den ",
  handoverExplain2 : " sker ",

 
  schedulePickupSchool: (school:SCHOOL_TYPES|undefined, age:number):string =>
    isPreschool(school, age) ? "genom förskolan" : "genom skolan",
  scheduleDropoffSchool: (school:SCHOOL_TYPES|undefined, age:number):string =>
    isPreschool(school, age) ? "genom förskolan" : "genom skolan",


  scheduleShared: (name: string) => `${name} delade schemat`,

  suggestionName: (id: number) => `Förslag #${id}`,
  scheduleName: (id: number) => `Bytesschema #${id}`,
  scheduleNameNew: (schedule: ISchedule | undefined) => schedule ? ((schedule.name && schedule.name.trim().length > 0) ? schedule.name : `Schema #${schedule.id}`) : `Okänt Schema`,

  
 
  // Password
  magicTokenTitle: "Du har fått en länk som ger dig inträde. Kolla din E-post 😊!",
  magicTokenBody: "Skriv in din E-post som ska ta emot en magisk länk att logga in med",
  invalidMagicToken: "Du behöver skicka en GILTIG magic token!",
  submitMagicLink: "Skicka magisk länk",
  openApp: "Öppna mail-app",
  alreadyLoggedInTitle: "Du är redan inloggad",
  alreadyLoggedInLinkBody: "Du kan inte använda den här länken eftersom du redan är inloggad. Logga ut först under Inställningar.",

  // Economy
  economyDone: 'Inköpt',
  economyAgree: 'Planering',

  transfer: 'Överföring',
  purchase: 'Inköp',
  purchaseNew: 'Nytt inköp',
  purchaseDone: 'Registrera avklarat inköp',
  purchaseDoneClosed: 'Stängt inköp',
  purchaseEdit: 'Ändra inköp',
  purchaseEditNotMine: 'Inspektera inköp',
  purchaseRegardingTitle: (item: string) => `Angående inköp ${item}`,
  agreementRegardingTitle: (item: string) => `Angående planerat inköp ${item}`,
  transferRegardingTitle: (sum: string, date: string) => `Angående överföring ${sum} den ${date}`,
  purchaseEditSubtitle: (name: string) => `Registrerat av ${name}`,

  purchaseProposalNew: 'Inköpsförslag',
  purchaseRecurringNew: 'Lägg in planerat inköp',
  purchaseProposalEdit: 'Ändra förslag',
  purchaseProposalClosed: 'Förslag som inhandlats',
  purchaseProposalDeleted: 'Raderat förslag',

  purchaseTransferNew: 'Registrera överföring',
  purchaseTransferEdit: 'Ändra överföring',
  purchaseTransferEditNotMine: 'Inspektera överföring',
  purchaseTransferDeleted: 'Raderad överföring',

  purchaseTransferAccountShared: 'Gemensamma kontot',

  confirmRepeatingDelete: "Radera återkommande inköp",
  confirmRepeatingDeleteThis: "Detta inköp",
  confirmRepeatingDeleteThisOne: "Radera",
  confirmRepeatingDeleteFuture: "Detta och framtida inköp",

  agreementForWho: 'För vem',
  agreementNoPrice: 'ej angett',
  agreementPaysAll: (name: string) => `${name} betalar allt`,
  agreementMyPart: (andel: number) => `Min del ${andel}%`,
  agreementEstimatePrice: 'Estimera pris',
  agreementMyPartSet: 'Min del',
  agreementCoparentPart: (name: string) => `${name} del`,
  agreementSplitQuestion: 'Hur skall kostnaden fördelas?',
  agreementResponsible: 'Ansvarig för inköp',
  agreementTooltipHelp: 'Du eller båda är ansvarig för att köpa detta. Tryck här för att bokföra inköpet när det är genomfört.',

  agreGuideTitle : "Snabbguide",
  agreGuide : <span>Du kommer få förslag på återkommande kostnader som ofta delas. Lägg in totalkostnaden för posterna. <br/><br/>Du kan alltid justera eller lägga till pris senare om du inte vet det just nu.</span>,
  agreGuideDone : <span>Snyggt jobbat, nu är det klart!</span>,
  agreGuideInsurance : (name:string) => "Barnförsäkring för "+name,
  agreGuideInsuranceDesc : (name:string) => "Försäkring "+name,
  agreGuidePocketmoney : (name:string) => "Fickpengar för "+name,
  agreGuidePocketmoneyDesc : (name:string) => "Fickpengar "+name,
  agreGuidePhone : (name:string) => name+"s mobiltelefon per månad",
  agreGuidePhoneDesc : (name:string) => "Mobiltelefon "+name,
  agreGuideKindergarten : (name:string) => "Förskolekostnad för "+name,
  agreGuideKindergartenDesc : (name:string) => "Förskoleavgift "+name,
  agreGuideSchool : (name:string) => "Skolans fritidskostnad per månad för "+name,
  agreGuideSchoolDesc : (name:string) => "Fritids "+name,
  agreGuideTransport : (name:string) => "Busskort eller annat transportmedel för "+name,
  agreGuideTransportDesc : (name:string) => "Transportmedel "+name,
  agreGuideActivity : (name:string) => "Fritidsaktivitet för "+name+" (Skriv bara in en om det är flera)",
  agreGuideActivityMore : (name:string) => "Har "+name+" fler fritidsaktiviteter?",
  agreGuideStream : (mult:boolean) => "Har "+(mult?"barnen":"ert barn")+" någon streamingtjänst som ni vill dela på kostnaden för?",
  agreGuideStreamMore : "Fler streamingtjänster?",

  ecoSuggestion : "Förslag",
  ecoRecurring : "Återkommande",

  ecoBalanceRegister: <>Registrera<br />överföring</>,
  ecoBalanceSettings: 'Ekonomi-inställningar',
  ecoExportEmailQueued: 'Din ekonomi-PDF skickas till din e-postadress inom en minut.',
  ecoExportOffline: 'Anslut till internet och försök igen.',
  ecoBalancePaymentMethod: "Välj Betalningsmetod",
  ecoBalanceCurrency: 'Valuta',
  ecoBalanceSplit: 'Standard-fördelning',
  ecoBalanceHistory: 'Visa tidigare fördelningar',

  ecoBalanceMonth: 'Månadens balans:',
  ecoBalanceTotalSpent: (month: string) => `Totalt spenderat ${month}:`,
  ecoNotIncluded: 'Ej inkluderade',
  ecoDeletedByCreator: 'Raderad',
  ecoDeclinedToShare: 'Vill inte dela denna kostnad',
  ecoRestore: 'Återställ',

  ecoTransferBooking : 'Bokför i',
  ecoTransferMethod: 'Överföringssätt',
  ecoPrivateAcc: 'Privat konto',
  ecoSharedAcc: 'Gemensamt konto',
  ecoPaidBy: 'Vem betalade?',

  ecoComeBack : 'Kom tillbaka och bekräfta överföringen när du är klar',

  ecoRecentActionPurchaseCreated: (purchaseTitle: string) => `skapade ett inköp "${purchaseTitle}"`,
  ecoRecentActionPurchaseChanged: (purchaseTitle: string) => `ändrade ett inköp "${purchaseTitle}"`,
  ecoRecentActionNewTransferCreated: (sum: number, currency: string) => `registrerade en överföring på ${sum} ${currency}`,



  ecoTransferTitle: (doneTo: IFamilyMember | undefined, doneBy: IFamilyMember | undefined) => `Överföring ${doneBy ? "" : "från gemensamt konto"} till ${doneTo ? doneTo.firstName : "gemensamt konto"}`,

  ecoYouOrName: (paidBy: number, userId: number, family: IFamilyMember[]) => `${paidBy === userId ? ("Du") : TranslateNew.getInstance().familyMemberName(paidBy, family)}`,
  ecoPurchaseSubtitle: (myPercentage: number, amount: number, currency: string) => `${myPercentage}% av ${amount} ${currency}.`,
  ecoExplainFromSharedAccountNormalPurchase: (myPercentage: number, myPartInSharedAccount: number, paidBy: number, userId: number, family: IFamilyMember[], amount: number) => `${baselanguage.ecoYouOrName(paidBy, userId, family)} betalade ${amount} från ert gemensamma konto. Då du skulle betala ${myPercentage}% av detta köp och du har tillskjutit ${myPartInSharedAccount}% av pengarna på det gemensamma kontot påverkar det inte balansen mellan er.`,
  ecoExplainFromSharedAccountNOTNormalPurchase: (myPercentage: number, myPartInSharedAccount: number, paidBy: number, userId: number, family: IFamilyMember[], amount: number, balance: number, currency: string) => `${baselanguage.ecoYouOrName(paidBy, userId, family)} betalade ${amount} från ert gemensamma konto. Då du skulle betala ${myPercentage}% av detta köp och du har tillskjutit ${myPartInSharedAccount}% av pengarna på det gemensamma kontot får du därför ${balance > 0 ? "tillbaka" : "betala"} ${Math.abs(balance)} ${currency} (${Math.abs(myPartInSharedAccount - myPercentage)}% av ${amount}).`,
  ecoExplainFromMyPrivateAccountPurchase: (myPercentage: number, amount: number, balance: number, currency: string, howMuchIShouldPay: number) => `Du betalade ${amount} ${currency} ur egen plånbok. Din del att betala är ${howMuchIShouldPay} ${currency} (${myPercentage}% av ${amount}). Du skall därför få tillbaka ${balance} ${currency} (${amount} - ${howMuchIShouldPay}).`,
  ecoExplainFromCoparentPrivateAccountPurchase: (paidBy: number, family: IFamilyMember[], myPercentage: number, amount: number, currency: string, howMuchIShouldPay: number) => `${TranslateNew.getInstance().familyMemberName(paidBy, family)} betalade ${amount} ${currency} ur egen plånbok. Din del att betala är ${howMuchIShouldPay} ${currency} (${myPercentage}% av ${amount}).`,

  ecoExplainTransfer: (to: number, from: number, family: IFamilyMember[], sum: number, currency: string) => `${TranslateNew.getInstance().familyMemberName(from, family)} förde över ${sum} ${currency} till ${TranslateNew.getInstance().familyMemberName(to, family)}.`,
  ecoExplainTransferSharedToShared: `En överföring från ett gemensamt konto till ett annat har ingen påverkan på balansen.`,
  ecoExplainTransferToShared: (otherParentId: number, from: number, fromPercentage: number, family: IFamilyMember[], sum: number, currency: string) => `${TranslateNew.getInstance().familyMemberName(from, family)} förde över ${sum} ${currency} till det gemensamma kontot. Då ${TranslateNew.getInstance().familyMemberName(from, family)} skall betala ${fromPercentage}% av kostnaderna skulle ${TranslateNew.getInstance().familyMemberName(otherParentId, family)} behöva ersätta ${TranslateNew.getInstance().familyMemberName(from, family)} med ${Math.floor((100 - fromPercentage) * sum) / 100} ${currency} (${(100 - fromPercentage)}% av ${sum}).`,
  ecoExplainTransferFromShared: (to: number, toPercentage: number, otherParentId: number, family: IFamilyMember[], sum: number, currency: string) => `${TranslateNew.getInstance().familyMemberName(to, family)} förde över ${sum} ${currency} från det gemensamma kontot till sitt privata konto. Då ${TranslateNew.getInstance().familyMemberName(to, family)} har fört över ${toPercentage}% av pengarna till det gemensamma kontot tillhör ${Math.floor((100 - toPercentage) * sum) / 100} ${currency} till ${TranslateNew.getInstance().familyMemberName(otherParentId, family)} (${(100 - toPercentage)}% av ${sum}).`,

  repeatSubtitle: (option: EcoRepeat): string => {
    switch (option) {
      case EcoRepeat.ONCE:
        return "Engångsköp";
      case EcoRepeat.WEEKLY:
        return "Återkommande veckovis";
      case EcoRepeat.MONTHLY:
        return "Återkommande månatligen";
      case EcoRepeat.QUARTERLY:
        return "Återkommande kvartalsvis";
      case EcoRepeat.YEARLY:
        return "Återkommande årsvis";
      case EcoRepeat.TERM:
        return "Återkommande terminsvis";
        default:
        return "Unknown";
    }
  },

  repeatOption: (option: string): string => {
    switch (option) {
      case EcoRepeat.ONCE:
        return "Engångsköp";
      case EcoRepeat.WEEKLY:
        return "Veckovis";
      case EcoRepeat.MONTHLY:
        return "Månadsvis";
      case EcoRepeat.QUARTERLY:
        return "Kvartalsvis";
      case EcoRepeat.YEARLY:
        return "Årsvis";
      case EcoRepeat.TERM:
        return "Terminsvis";
        default:
        return "Unknown";
    }
  },
  

  transferOption: (option: EcoTransferMethod): string => {
    switch (option) {
      case EcoTransferMethod.BANK:
        return "Bank";
      case EcoTransferMethod.CASH:
        return "Kontanter";
      case EcoTransferMethod.SWISH:
        return "Swish";
      case EcoTransferMethod.OTHER:
        return "Annat";
      case EcoTransferMethod.CASHAPP:
        return "CashApp";
      case EcoTransferMethod.PAYPAL:
        return "PayPal";
      case EcoTransferMethod.VENMO:
        return "Venmo";
      default:
        return "Unknown";
    }
  },

  repeatEventOption: (option: string): string => {
    switch (option) {
      case REPEATABLE.ONCE:
        return "En gång";
      case REPEATABLE.WEEKLY:
        return "Veckovis";
      case REPEATABLE.BI_WEEKLY:
        return "Varannan Vecka";
      default:
        return "Okänt";
    }
  },


  disputedTransactions: 'Ifrågasatta transaktioner',
  disputedTransactionsByMe: 'Ifrågasatt av mig',
  purchaseProposalReceived: 'Mottagna förslag',
  purchaseProposalSent: 'Skickade förslag',
  balanceThisMonth: 'Summa denna månad (',
  balancePrevious: 'Summa tidigare månader',
  totalBalance: 'Total Balans',
  totalBalanceGet: 'Du bör få',
  totalBalancePay: 'Du bör betala',
  totalBalanceGetSharedAlternative: (balance:string, sharedTransfer:string, coparentName:string) =>
    `Du bör få ${balance} eller ${coparentName} bör föra över ${sharedTransfer} till det gemensamma kontot`,
  totalBalancePaySharedAlternative: (balance:string, sharedTransfer:string) =>
    `Du bör betala ${balance} eller föra över ${sharedTransfer} till det gemensamma kontot`,
  upcomingPurchases: 'Att köpa',
  upcomingPurchasesNonUrgent: 'Att köpa nästa månad',
  agreementSeenBy: 'Sett av',
  repeat: 'Upprepas',
  rejectPendingAgreement: (agreement: string) => `Ändringen för ${agreement} nekades.`,
  rejectAgreement: (agreement: string) => `Förslaget ${agreement} nekades.`,
  deletePendingAgreement: (agreement: string) => `Ändringen för ${agreement} raderades.`,
  deleteAgreement: (agreement: string) => `Förslaget ${agreement} raderades.`,
  unseenPurchase: (purchase: string) => `Osett köp ${purchase}.`,
  deletedPurchase: (purchase: string) => `Raderat köp ${purchase}.`,
  unseenTransfer: (purchase: string) => `Osedd överföring ${purchase}.`,
  deletedTransfer: (purchase: string) => `Raderad överföring ${purchase}.`,

  // economy help 
  ecoSuggHelp1: 'Här kan göra förslag på inköp eller lägga upp återkommande kostnader som skall delas.',
  ecoSuggHelp2: 'Lägg in vem som är ansvarig för påminnelser.',
  ecoSuggHelp3: 'Bara föräldrar ser Ekonomidelen.',

  ecoDoneHelp1: 'Här hamnar köp och överföringar. Använd Ai för att fota kvitton eller lägg in manuellt. Bara föräldrar ser Ekonomidelen.',
  ecoRememberMark: "Glöm inte att gå tillbaka till appen och markera överföringen som genomförd när du är klar.",

  // Cash App
  ecoCashAppSendMoney: "Skicka pengar via Cash App",
  ecoCashAppCashTagOne: "$Cashtag",
  ecoCashAppCashTagTwo: "Mottagarens $Cashtag",
  ecoCashAppAmount: "Belopp",


  // Venmo
  ecoVenmoSendMoney: "Skicka pengar via Venmo",
  ecoVenmoOne: "Venmo",
  ecoVenmoRecieverInfo: "Mottagarens Venmo",
  ecoVenmoPlaceholder: "E-post, telefonnummer eller användarnamn",
  ecoVenmoReciever: "Mottagare",
  ecoVenmoNote: "Payment note",
  ecoVenmoVisibility: "Synlighet",
  ecoVenmoPrivate: "Privat",
  ecoVenmoPublic: "Publikt",
  ecoVenmoFriends: "Vänner",

  // paypal

  ecoPayPalSendMoney: "Skicka pengar via PayPal",
  ecoPayPalName: "Paypal",
  ecoPayPalAmount: "Belopp",



  

  // onboarding controller

  onbBtnChooseLater: "Vi har inget schema",
  onbBtnMaybeLater: "Kanske senare",
  onBCreateSchedule : "OK Skapa ett schema",

  onbNotiTitle: "Missa inget viktigt!",
  onbNotiText: "Med notiser så har du alltid koll på byten, packlistan, aktiviteter och mycket mer.",
  onbNotiBtnYes: "Tillåt",
  notificationPermissionSettingsMessage: "Notiser är avstängda. Aktivera dem i Android-inställningarna för att få påminnelser.",

  onbCoparentTitle: "Vad heter medföräldern?",
  onbExistingAccount: "Befintligt konto",
  onbCoparentText: "Inga meddelanden skickas till den andra föräldern nu.",

  onbChildTitle: "Vad heter era gemensamma barn?",

  onbSyncTitle: "Synka? Ja!",
  onbSyncText: "Synkar du VV-appen med din digitala kalender håller du snabbt och enkelt koll på allt - var du än är!",
  onbSyncBtnAgree: "Synka till min kalender",
  onbSyncBtnTextDone: "Synkat! nästa steg",

  onbStartFree : "Starta gratisperiod",
  onbStartFreeAfter : "Sen ",

  onbSubscriptionTitle: "Början på ett starkt team runt barnen",
  onbSubscibeBeneficiary: (days: number, benefactor:string) => <span>{`Du har fått en gratisperiod om ${days} dagar av `}<b>{benefactor}</b>{` och behöver därför inte starta någon prenumeration än.`}</span>,
  
  onboardindCompletedTitle: "Nu kör vi!",
  onboardindCompletedContent: <>
    Ett tips är att lägga in veckans akitiviteter i Kalendern.<br/><br/>
    Där hittar du också Packlistan, ett fantastiskt verktyg för att få koll!
  </>,
  onboardingCompletedButton: "till översikten",

  // onboardingSteps

  onbScheduleShareText: (name: string | undefined) => <>Tillsammans med aktiviteter, packlistan och delade uppgifter kommer samarbetet flyta på smidigare än innan. Det är i alla fall vad 90% av våra användare säger!</>,

  onbScheduleCreated: "Schemat klart!",
  onbScheduleShare: "Ok ",


  // Subscription
  subscriptionTitle: "Din provperiod",
  subscriptionSubTitleMonth: (daysFree: number, monthCost: string) => 
    daysFree > 0 
      ? <>{daysFree + " dagar gratis, "}<wbr/>{"sen " + monthCost + " per månad"}</>
      : <>{"Appen kostar "+monthCost + " per månad."}</>,
  subscriptionSubTitleYear: (daysFree: number, monthCost: string, annualCost: string):string => 
    "Första ",
  subscriptionBuy: (daysFree: number):string => daysFree > 0 ? "Starta gratis provperiod" : "Starta prenumeration",
  subscriptionInvitedFree: "Appen är gratis för alla du bjuder in.",
  subscriptionStepOne: "Lås upp alla funktioner och börja bygga ett starkt föräldrateam.",
  subscriptionStepTitle: (daysOfTrial: number): string => `Om ${daysOfTrial} dagar`,
  subscriptionStepTwo: "Du får en påminnelse när provperioden är på väg att ta slut.",
  subscriptionStepThree: "Prenumerationen startar. Avsluta när som helst innan dess.",

  subscriptionWeb: "Du behöver starta en prenumeration i appen, du har sedan tillgång till webb-versionen.",
  subscriptionStoreUnavailable: (storeName: string): string =>
    `Appen kunde inte ansluta till ${storeName}, så det går inte att starta en prenumeration just nu. Kontrollera din internetanslutning och starta om appen.`,
  subscriptionPurchaseFailedTitle: "Prenumerationen kunde inte startas",
  subscriptionPurchasesRestricted: "Köp inom appar är avstängda på den här iPhonen. Öppna Inställningar → Skärmtid → Innehålls- och integritetsbegränsningar och tillåt köp inom appar. Om telefonen hanteras av till exempel en arbetsgivare kan du behöva be dem om det.",
  subscriptionAppStoreFailed: "App Store kunde inte slutföra köpet. Kontrollera att ditt Apple-konto har en betalningsmetod som fungerar (Inställningar → ditt namn) och försök igen.",
  subscriptionGooglePlayFailed: "Google Play kunde inte starta köpet. Kontrollera att Play Butik är uppdaterad, att du är inloggad med ditt Google-konto och att din betalningsmetod fungerar (Play Butik → din profilbild → Betalningar och prenumerationer). Försök sedan igen.",
  subscriptionPurchaseFailed: "Köpet kunde inte genomföras. Försök igen.",
  subscriptionContactSupport: "Fungerar det fortfarande inte? Mejla oss så hjälper vi dig:",
  subscriptionSupportEmail: "hello@varannanvecka.app",

  // moment locale
  momentFromNow: (time:number):string => {
    const diff = Math.floor((time - Date.now()) / 1000); // positive if future, negative if past
    const absDiff = Math.abs(diff);

    if (absDiff < 60) return diff >= 0 ? "om ett ögonblick" : "nyss";
    if (absDiff < 3600) {
      const mins = Math.floor(absDiff / 60);
      return diff >= 0 ? `om ${mins} min` : `${mins} min sedan`;
    }
    if (absDiff < 86400) {
      const hours = Math.floor(absDiff / 3600);
      return diff >= 0 ? `om ${hours} tim` : `${hours} tim sedan`;
    }
    const days = Math.floor(absDiff / 86400);
    return diff >= 0 ? `om ${days} dagar` : `${days} dagar sedan`;
  },

  momentNewEvent: (time:number):string => {
    const d=new Date(time);
    const m=["jan","feb","mar","apr","maj","jun","jul","aug","sep","okt","nov","dec"];
    return `${m[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
  },

  // Privacy Policy
  privacyPolicyShort: 'Användarvillkor & integritetspolicy',
  privacyPolicyTitle: 'Varannan veckas integritetspolicy',
  privacyPolicyContent: <>
    <h3>Vi bryr oss om din integritet ❤️!</h3>
    <h3>1. Allmänt</h3>
    <p>
      Vi på Happy Parents AB ("Happy Parents", "Varannan Vecka" eller "vi") är mycket glada för ditt intresse att
      använda vår
      tjänst Varannan Vecka (”Tjänsten”). Dataskydd och säkerheten för dina uppgifter är av högsta prioritet för
      oss.
      Denna integritets- och cookiepolicy förklarar vilka uppgifter vi samlar in om dig och hur de behandlas och
      delas, åtgärderna
      vi har tagit för att hålla din data säker och hur vi använder cookies. Vi beskriver även vilka rättigheter
      du har gällande din
      personlig information.
    </p>
    <p>
      När du använder eller registrerar dig på varannanvecka.app, inklusive dess associerade webbplatser
      (gemensamt "Webbplatsen"), eller på annat sätt
      interagerar med oss, till exempel genom Tjänsten, bekräftar du att du förstår att vi samlar in, behåller och
      använder
      dina personuppgifter i enlighet med denna integritetspolicy.
    </p>
    <p>
      <strong>
        En användares namn, e-post, profilbild, könsidentitet, ålder eller annan personlig information kommer
        aldrig att visas
        offentligt för andra än för användarens "utvidgade familj" (de som bjudits in till tjänsten för att
        samarbeta tillsammans).
      </strong>
    </p>

    <h3>2. Vilka vi är</h3>
    <p>
      Vi är Happy Parents AB, organisationsnr. 559197-1717, Alströmmergatan 22, 112 47 Stockholm. Du når oss via
      telefon på +46 (0)707 61 72 92 eller per e-post på hello@varannanvecka.app. Vi är personuppgiftsansvarig för
      behandlingen
      av dina personuppgifter.
    </p>
    <p>
      Vi litar på att denna integritetspolicy svarar på dina frågor om vår insamling, användning, skydd och
      avslöjande av din
      personlig information. Om du har ytterligare frågor, vänligen kontakta oss på adressen, e-postadressen eller
      telefonnummer
      som anges ovan.
    </p>

    <h3>3. Tillägg</h3>
    <p>
      Vi kan komma att ändra denna integritetspolicy från tid till annan. Om vi gör det kommer den ändrade
      integritetspolicyn att träda i kraft när
      vi publicerar det på webbplatsen. Om vi gör betydande ändringar kommer vi att informera dig utifrån vad som
      är lämpligt angående
      omständigheterna, till exempel genom ett meddelande via e-post eller som ett meddelande i vårt system.
      Senaste datum för ändring
      står längst ner i Integritetspolicyn.
    </p>
    <p>
      Om någon ändring gör integritetspolicyn mindre skyddande för dina personuppgifter, kommer en sådan ändring
      inte att gälla för data
      vi samlade in om dig innan ändringen gjordes. Ändringen kommer dock att gälla för sådana uppgifter om du
      tillhandahåller
      ditt samtycke till den nya versionen av integritetspolicyn eller om du tillhandahåller ny information eller
      upprepar samma information
      efter det att ändringen trätt i kraft.
    </p>

    <h3>4. Samling</h3>

    <h4>4.1 Vilken information vi samlar in</h4>
    <p>
      Vi samlar in de personuppgifter som har tillhandahållits av dig eller samlats in på webbplatsen genom vår
      användning av cookies. De
      personuppgifter vi behandlar består av följande:
    </p>
    <ul>
      <li>Registrering</li>
    </ul>
    <p>
      När du registrerar dig på Varannan Vecka ber vi dig att ange din e-postadress och ditt lösenord, eller
      registrera dig med hjälp av en tredje part
      registrering som Facebook eller Google. I så fall samlar vi in e-postadressen och namnet som tillhandahålls
      av den tjänsten. Vi kan verifiera
      din registrering genom en andra faktor autentisering, till exempel via ditt mobiltelefonnummer.
    </p>
    <ul>
      <li>Användare</li>
    </ul>
    <p>
      När du skapar din profil ber vi dig om olika typer av personuppgifter om vem du är och din familj. Vi
      lagra även platsen baserat på din IP för att ta reda på vilka helgdagar och semestrar som gäller för ditt
      barns skola.
    </p>
    <ul>
      <li>Laddad upp och data skapade av dig</li>
    </ul>
    <p>Vi samlar in data från dig när du anger eller laddar upp data via formulär på vår webbplats, privata
      chattmeddelanden/bilagor.</p>
    <ul>
      <li>Information från andra</li>
    </ul>
    <p>
      Andra användare kan bjuda in dig till systemet både som förälder eller som barn eller annan familjemedlem.
      Vi samlar in
      lämnade uppgifter, inklusive namn och e-post.
    </p>
    <ul>
      <li>Insamling av allmänna och statistiska uppgifter</li>
    </ul>
    <ul>
      <li>Loggar</li>
    </ul>
    <h4>4.2 Hur vi samlar in din information</h4>
    <p>
      Vi samlar in dina personuppgifter direkt från dig i samband med ditt besök eller registrering på webbplatsen
      eller när
      du använder vår app.
    </p>
    <p>
      Vi kan också samla in dina uppgifter, i den mån du har gett ditt samtycke till det och/eller begärt det,
      från våra partners eller
      andra tredje parter, till exempel information som du har lämnat vid registrering via Google eller Facebook.
    </p>

    <p>
      Vi kan komma att komplettera information som du har lämnat till oss med information från andra källor, såsom
      information
      som bekräftar din identitet och profilinformation. Vi gör detta för att säkerställa riktigheten av den
      information vi är
      insamling och för att kunna ge bättre service.
    </p>

    <p>
      Vi loggar och samlar in användningsdata när du besöker eller på annat sätt använder vår tjänst, inklusive
      vår webbplats, app och plattform
      teknik (t.ex. våra plugins utanför webbplatsen), till exempel när du visar eller klickar på innehåll eller
      tillhandahåller information. Vi använder
      inloggningar, cookies, enhetsinformation och internetprotokolladresser för att identifiera dig och logga din
      användning.
    </p>

    <p>
      När du loggar in kommer vi också att skapa flera cookies för att spara din inloggningsinformation och dina
      skärmvisningsval.
      Inloggningscookies varar i två dagar och skärmalternativcookies varar i ett år. Om du väljer "Kom ihåg mig",
      din inloggning
      kommer att pågå i två veckor. Om du loggar ut från ditt konto kommer inloggningscookies att tas bort.
    </p>

    <p>Om du redigerar eller publicerar en artikel sparas ytterligare en cookie i din webbläsare. Denna cookie
      innehåller ingen personlig
      data och anger helt enkelt post-ID för artikeln du just redigerade. Den upphör att gälla efter 1 dag.</p>

    <h4>4.3 Videosamtal och inspelningar</h4>

    <p>
      Videosamtal som görs i appen spelas in. Både bild och ljud spelas in, för samtliga deltagare, under hela
      samtalet. Alla som deltar får information om att samtalet spelas in innan det börjar - både på skärmen där
      samtalet rings upp och på skärmen där det besvaras. Vill du inte bli inspelad ska du inte ringa upp eller
      svara på samtalet.
    </p>

    <p>
      Inspelningen sparas som en videofil och görs tillgänglig för deltagarna i samtalet via en länk i den chatt
      som samtalet hör till. Den som har tillgång till chatten kan öppna filen. Vi publicerar inte inspelningar och
      delar dem inte med någon tredje part utöver de tjänsteleverantörer vi använder för att genomföra samtalen och
      lagra filerna, enligt vad som beskrivs i punkt 6.
    </p>

    <p>
      Inspelningar lagras enligt samma regler som annat innehåll i dina chattar, se punkt 8. Du kan när som helst
      begära att vi raderar en inspelning, och du har de rättigheter som beskrivs i punkt 9 även i fråga om
      inspelningar.
    </p>

    <h3>5. Behandlingsändamål</h3>

    <p>
      Vår tjänst är ett samarbetsverktyg och syftet med informationsinsamlingen är att hjälpa dig att lättare
      skapa
      innehåll som hjälper dig att samarbeta kring dina barn och deras välbefinnande.
    </p>

    <p>
      Observera att viss data kan användas även utan ditt samtycke, till exempel om vi behöver uppgifterna för att
      träna AI
      modeller. Vi försöker alltid att anonymisera personuppgifter om vi gör det. Vi kommer aldrig att sälja dina
      personuppgifter till andra parter. Vi
      behandla dina personuppgifter för de ändamål som anges i punkterna 5.1-5.4 nedan.
    </p>

    <h4>5.1 Tillhandahålla våra tjänster</h4>

    <p>Om du väljer att registrera dig hos oss är vår huvudsakliga användning av data att använda den för att hjälpa
      till att samarbeta med andra medlemmar i din
      utökad familj.</p>

    <p>
      Vi använder dina personuppgifter som kan behövas för att tillhandahålla tjänsten, t.ex. för att administrera
      ditt konto, för att kommunicera
      med dig, för faktureringsändamål och för att ge support.
    </p>

    <p>
      Vi kan ibland analysera text och bilder givna av dig för att förbättra upplevelsen för dig och din utökade familj med en förbättrad upplevelse.
    </p>

    <h4>5.2 Förbättra våra tjänster och dataanalys</h4>

    <p>
      Vi kan komma att använda dina uppgifter för att förbättra våra tjänster och träna våra datamodeller. Till
      exempel att träna AI för att identifiera missbruk
      språk. Vi försöker alltid anonymisera information innan vi använder den för att träna modeller.
    </p>

    <p>
      Vi aggregerar och anonymiserar data (t.ex. användning av olika schemainställningar) för att ge insikter.
      Denna anonymiserade data
      kan spridas utanför Happy Parents.
    </p>

    <p>
      Vi kommer även att behandla dina personuppgifter för att ta fram statistik om hur du använder våra tjänster.
      Vi kan göra detta genom att t.ex.
      utföra kundnöjdhetsundersökningar och marknadsundersökningar eller genom att analysera din användning av
      webbplatsen. Vi använder din
      information för att göra tjänsterna mer användarvänliga, t.ex. genom att fixa buggar, ändra gränssnittet så
      att du enkelt
      nå den information du söker, eller framhäva populära funktioner. Denna behandling är baserad på vårt
      intresse att
      kontinuerligt förbättra Tjänsten och tillhandahålla och utveckla nya tjänster samt att utföra ytterligare
      anonymiserad dataanalys
      och använda.
    </p>

    <h4>5.3 Förhindra missbruk</h4>

    <p>
      Dina personuppgifter kan också användas för att förhindra missbruk av våra tjänster eller för att förhindra
      eller utreda brott. Missbruk avser
      till bland annat bedrägeri, skicka skräppost, trakasserier, försök till obehörig inloggning till
      användarkonton och annat
      åtgärder som strider mot våra villkor eller lag. Vi kan också använda dina uppgifter för att undersöka och
      försvara
      oss mot alla juridiska anspråk från användare eller tredje part. Denna behandling är baserad på vårt
      intresse att undvika missbruk
      av webbplatsen eller tjänsterna och för att försvara oss mot rättsliga anspråk.
    </p>

    <h4>5.4 Direktmarknadsföring och marknadsföring av tjänsten</h4>

    <p>
      Vi använder dina personuppgifter för att skicka nyhetsbrev, erbjudanden och relevant information om våra
      tjänster. Marknadsföringen
      material kan skickas till dig via post, SMS eller e-post. Du kan också få erbjudanden från någon av våra
      partners. Sådana erbjudanden
      görs av oss via webbplatsen och inte direkt av våra partners. Denna behandling är baserad på ditt
      förhandsgodkännande.
    </p>

    <h3>6. Hur vi delar dina personuppgifter</h3>

    <h4>6.1 Varannan Vecka delar inte din personliga information med någon tredje part förutom enligt beskrivningen
      nedan.</h4>

    <ul>
      <li>
        Tjänsteleverantörer: Varannan Vecka kan använda tredje part för att hantera en eller flera aspekter av
        vår affärsverksamhet,
        inklusive behandling eller hantering av personuppgifter. Vi kan komma att dela personlig information med
        sådan tredje
        parter att utföra tjänster för vår räkning såsom chatt- och meddelandetjänster, bearbeta betalningar,
        skicka marknadsföring
        kommunikation, utföra analys eller forskning, verifiera och validera information som du har lämnat till
        oss,
        och tillhandahålla kundsupporttjänster.
      </li>
      <li>
        Försäljning eller överföring av verksamhet eller tillgångar: All information vi har om dig kan överföras
        eller avslöjas till en
        köpare eller presumtiv köpare i händelse av en försäljning, överlåtelse eller annan överlåtelse av hela
        eller en del av vår
        verksamhet eller tillgångar. Skulle en sådan överföring inträffa kommer vi att vidta rimliga
        ansträngningar för att säkerställa att mottagaren använder
        din information på ett sätt som överensstämmer med denna integritetspolicy.
      </li>
      <li>
        Varannan Vecka kan också komma att lämna ut din information om vi är skyldiga att göra det enligt lag
        eller för att följa rättsliga krav
        (t.ex. avslöjandefrågor, domstolsbeslut, rättsliga åtgärder eller liknande) eller när det är nödvändigt
        att upptäcka, förhindra och
        ta itu med bedrägeri och annan kriminell aktivitet, för att skydda oss själva, dig och andra användare,
        inklusive som en del av en förfrågan
        om vi i god tro anser att en sådan åtgärd krävs enligt tillämplig lag. Ovanstående kan innefatta att
        svara juridiskt
        förfrågningar från jurisdiktioner utanför EU/EES, där vi i god tro anser att svaret krävs enligt lagen i
        relevant jurisdiktion, påverkar användare i denna jurisdiktion, och är i enlighet med internationellt
        erkänd
        standarder.
      </li>
    </ul>

    <h4>6.2 Anonymiserad och aggregerad data kan göras tillgänglig utan Användarnas uttryckliga medgivande (som
      statistik).</h4>

    <p>
      Vi kan således komma att publicera anonym och aggregerad information om användningen av Varannan Vecka eller
      andra slutsatser som kan
      härledas från användningen av Varannan Vecka.
    </p>

    <h3>7. Hur vi skyddar dina uppgifter</h3>

    <ol type="1">
      <li>
        Filen som innehåller din personliga information kommer att lagras på våra servrar och kommer endast att
        vara tillgänglig för vår
        anställda och de av våra agenter och tjänsteleverantörer som behöver det under sina arbetsuppgifter. Vi
        underhåller
        lämpliga skyddsåtgärder och aktuella säkerhetsstandarder för att skydda din personliga information mot
        obehöriga
        åtkomst, avslöjande eller missbruk. Till exempel lagras elektroniska register i säkra servrar med
        begränsad åtkomst och
        elektronisk data lagras bakom säker krypteringsåtkomst. Vi använder tekniska verktyg som brandväggar och
        lösenord,
        och vi ser till att våra anställda är utbildade i vikten av att upprätthålla säkerheten och
        konfidentialitet
        personuppgifter vi behandlar.
      </li>
      <li>
        Vår webbplats använder krypteringsteknik, såsom Secure Sockets Layer, ("SSL") för att skydda din
        personliga information
        under dataöverföring. SSL krypterar beställningsinformation som ditt namn, adress och
        betalningsinformation. Vår
        Webbplatsen använder ett SSL-certifikat från GoDaddy för att bekräfta att vi följer säkerhetsprotokollen
        i enlighet med detta
        med industristandarder.
      </li>
      <li>
        När du registrerar dig som användare och skapar ett onlinekonto på vår webbplats kommer du att bli
        ombedd att välja en personlig
        Lösenord. För att maximera din skyddsnivå bör du välja ett starkt personligt lösenord, vilket innebär
        att du
        bör innehålla minst 6 tecken. Du är ensam ansvarig för att upprätthålla sekretessen för ditt lösenord
        och ev
        Kontoinformation. Varannan Vecka kommer aldrig att skicka en oönskad kommunikation som ber dig om ditt
        lösenord eller
        begär att du uppdaterar dina kontouppgifter.
      </li>
    </ol>

    <h3>8. Lagringstid</h3>

    <ol type="1">
      <li>
        Vi behåller i allmänhet dina personuppgifter så länge de är nödvändiga för de syften som de samlades in
        för eller på annat sätt
        krävs eller godkänts av tillämplig lag. Detta innebär bland annat att så länge våra användare vill vara
        registrerade på vår
        webbplats kommer vi att lagra uppgifterna.
      </li>
      <li>Det är upp till dig att ta bort ditt konto om du vill, och detta kan göras via inställningarna för ditt
        konto. Efter
        ett konto har raderats sparar vi uppgifterna i upp till 12 månader.
      </li>
      <li>Aggregerad och anonymiserad data där användaren kanske inte kan identifieras kan lagras på obestämd
        tid.
      </li>
      <li>Chattar och andra gemensamt skapade objekt (som delade scheman) kommer också att lagras i den andra
        personens inkorg som
        så länge deras data inte raderas (t.ex. raderar användaren sitt konto plus ytterligare 12 månader).
      </li>
      <li>Loggar och statistiska data kan lagras i upp till 36 månader.</li>
    </ol>

    <h3>9. Dina rättigheter</h3>

    <ol type="1">
      <li>
        Att registrera ett konto hos Varannan Vecka är frivilligt som Användare; du har alltid möjlighet att ta
        bort eller korrigera
        informationen vi har om dig. Du kan göra detta på din personliga sida på Webbplatsen eller i Tjänsten.
        Vänligen notera,
        dock att vi kan fortsätta att behandla dina personuppgifter i den utsträckning det är nödvändigt för
        utförandet av vår
        avtal med dig eller om det finns någon annan rättslig grund än samtycke för behandling av uppgifterna.
      </li>
      <li>
        I enlighet med gällande personuppgiftslagstiftning har du rätt att få information om vilka
        personuppgifter vi har
        behandlas om dig, oavsett hur informationen samlats in. Om du vill ha sådan information, vänligen skicka
        in
        en skriftlig begäran till oss på kontaktinformationen i klausul 2.
      </li>
      <li>
        Om dina personuppgifter behandlas i strid med gällande personuppgiftslagstiftning har du rätt att begära
        det
        dina personuppgifter korrigeras, blockeras eller raderas. Du har också rätt att begära att dina
        uppgifter är
        överföras till annan tjänsteleverantör (s.k. dataportabilitet).
      </li>
      <li>Dina personuppgifter kommer inte att behandlas för ändamål relaterade till direktmarknadsföring eller
        profilering om du motsätter dig sådant
        bearbetning. Du har när som helst rätt att återkalla ett givet samtycke för behandling av
        personuppgifter. Sådan
        uttag kan begränsas till att endast omfatta en del av behandlingen, t.ex. den del som är kopplad till
        ditt medlemskap hos oss
        eller direktmarknadsföring. I varje nyhetsbrev eller marknadsföringsmeddelande finns en länk som du kan
        använda till
        säga upp.
      </li>
      <li>
        Om du anser att vi har behandlat dina personuppgifter i strid med gällande personuppgiftslagstiftning är
        du det
        berättigad att framföra klagomål till Datainspektionen (Sw. Integritetsmyndigheten), som kan
        nås på Integritetsmyndigheten@itegritetsmyndigheten.se.
      </li>
    </ol>

    <h3>10. Överföring av personuppgifter</h3>

    <p>
      Om du har ett konto på denna sida eller har lämnat kommentarer kan du begära att få en exporterad fil av den
      personliga
      uppgifter vi har om dig, inklusive all information du har lämnat till oss. Du kan också begära att vi
      raderar eventuella personuppgifter
      vi håller om dig. Detta inkluderar inte några uppgifter som vi är skyldiga att behålla för administrativa,
      juridiska eller säkerhet
      syften.
    </p>
  </>,

  helpSchedule : "Vad vill du göra?",

  helpScheuleIntoTopic: "Jag är ny och behöver en intro",
  helpScheduleQuickTopic: "Jag vill ändra enstaka byten",
  helpScheduleTemplateTopic: "Jag vill planera ett schema för flera dagar",
  helpScheduleTempPlaceTopic: "Jag vill ändra tid/plats för många byten",
  helpScheduleMultiTopic: "Jag vill ha olika scheman för olika barn",

  calendarView : "Kalendervy",

  helpScheuleInto : (scheduleName:string, scheduleStatus:string) => <>
    <p>Boendeschema är för att planera vem som har ansvar för barnet. Att göra ändringar i boendeschemat påverkar inte andra aktiviteter i schemat.</p>
    <p>Boendeschema kan vara <b>privata</b>, <b>delade</b> eller <b>gällande</b>.</p>
    <p>Privata scheman syns bara för dig och kan ändras fritt av dig.</p>
    <p>Delade scheman går att inspektera av alla men visas inte i kalendern per automatik. Ändringar måste godkännas av den andre medföräldern och skickas som förslag. Bara föräldrar kan skapa, se och besvara förslag.</p>
    <p>Gällande scheman visas i kalendervyn.</p>
    <p>Detta schema ({scheduleName}) är <b>{scheduleStatus}</b></p>
    <p>För att dela/göra gällande går du ur ändringsvyn och klickar menyn uppe till höger.</p>
  </>,
  helpScheduleVeryQuick: "Klicka och dra i schemat för att ändra. Under skiftnyckeln finns många verktyg!",
  helpScheduleQuick : <p>Klicka och dra på byten och dagar i schemat du vill ändra. När du är nöjd klickar du på skicka!</p>,
  helpScheduleTemplate : <p>Om du vill planera ett schema för flera dagar klicka på verktyg nere i högra hörnet och sedan på <b>Använd mall</b>. </p>,
  helpScheduleTempPlace : <>
    <p>För att ändra klockslag och plats för flera dagar så klicka på verktyg nere i högra hörnet. Sedan på <b>Ändra tid/plats</b>.</p>
    <p>Alternativt om du vill ändra vilka dagar som byten sker så så klicka <b>Använd mall</b>.</p>
  </>,
  helpScheduleMulti : <>
    <p>Klicka på verktyg nere i högra hörnet och sedan Barn. Ändra så att denna kalender bara gäller ett av barnen och klicka på skicka. Sedan i kalendervyn (gå ur ändringsvyn) så väljer du boendeschema i menyn uppe till höger och "skapa nytt".</p>
    <p>Glöm inte att både dela och sätta som gällande på det nya schemat!</p>
  </>,
};

const engelska: (typeof baselanguage) = {

  // General
  close: 'Close',
  clear: 'Clear',
  yes: 'Yes',
  no:'No',
  agree: 'Agree',
  deny: 'Deny',
  sirname: "Last name",
  name: "Name",
  continue: "Continue",
  connecting: "Connecting",
  skip: "Skip",
  cancel: "Cancel",
  here: "here",
  missing: "Missing",
  examples: "Examples",
  discard:"Discard",
  remove: "Remove",
  back: "Back",
  update: 'Update',
  edit: 'Edit',
  copy: 'Copy',
  copyToClipboard: 'Copy to clipboard',
  error: "ERROR",
  unknown: "Unknown",
  private: 'Private',
  agreed: "Agreed",
  shared: "Shared",
  delete: 'Delete',
  download: 'Download',
  deleted: "Deleted",
  waiting: "Waiting",
  createNew: "Create New",
  updateExisting: "Update existing",
  send: "Send",
  okay: "OK",
  help:"Help",
  OK: "OK",
  great: "Great",
  approve: "Approve",
  question: "Question",
  from: "From",

  to: "To",
  sum: "Sum",
  explain: "Explain",
  expand:"Expand",
  collapse:"Collapse",
  for: "Articles for",
  noone: "no one",

  youSub: "You",
  thanks: "Thanks",
  rateAppTitle: "Got a moment?",
  rateAppText: "Your rating helps us make the app better.",
  rateAppLater: "Not now",
  rateAppSubmit: "Submit",
  rateAppStarLabel: (rating:number): string => `${rating} of 5`,
  before: "Before",
  unsub: "Unsubscribe",
  pay: "Pay",
  search: "Search",
  showMore: "Show more",
  list: "List",
  all: "All",

  done: "Done!",
  fail:"Failed",
  working: "Working",
  add: "Add",
  activity: 'Event',
  tryAgain: 'Try again',
  today: 'Today',
  empty: 'Empty',
  weekLabel: 'Week',
  sent: 'Sent!',
  camera : "Camera",
  library : "Library",
  analyzing : "Analyzing",
  libraryLabel: "Library",
  uploadImage: "Upload image",
  prompt: "Prompt",
  sort: "Sort",
  loading: "Loading...",
  loginTakingLonger: "Logging in is taking much longer than normal. We recommend tapping the Back button at the bottom.",
  readMore: 'read more',
  invert: 'Switch days',
  adjustDay: 'Move exchange days',

  archive: 'Archive',
  include: "Include",
  import: 'Import',
  suggestCange: 'Suggest',
  boughtBy: "Bought by",
  at: "at",
  housing: "Housing",
  now: "Now",
  hoursShort: "h",
  icon: "Icon" ,
  generate: "Generate",
  details: "Details",

  verifying: "Verifying...",
  invite: 'Invite',
  emailOnly: 'Email only',

  other: 'Other',

  selectWhatToExport: 'Select what to export',
  updateAvailable: 'A new version is available',

  dueDate: 'Due date',
  addDueDate: 'Add deadline',
  addTodo: "Add Todo",
  editTodo: "Edit Todo",
  addTodoThing: "Add",
  addListTodo: "Add Item",
  varannanVecka: 'Coparenting',
  

  btnUseAnotherEmail: 'Use another email',
  finish: "Finish",
  uConfirm: 'Are you sure?',
  iConfirm: "Yes, I'm sure",
  deleteTodoInfo: "If you delete this now, then it won't be automatically renewed until the next handover",
  exitHelper: 'Exit helper',
  handovers: "Handovers",

  erased: "Deleted",
  erase: "Erase",
  undo: "Undo",
  price: "Price",
  // todo
  title: 'Title',
  submit: "Submit",
  noThanks: "No thanks",
  show: "Show",
  scheduleAiEditPreviewUpdated: "Done! The preview has been updated.",
  scheduleAiEditPlaceholder: "Describe the changes you want to make in detail",
  scheduleAiEditUserLabel: "You",
  scheduleAiEditAssistantLabel: "Schedule assistant",
  scheduleAiEditThinkingLabel: "Thinking...",
  scheduleAiEditIntro: "Tell me what you want to change in the schedule, and I will prepare a preview you can review.",
  scheduleAiFeedbackTitle: "Did the AI not get it right?",
  scheduleAiFeedbackText: "Please explain what you tried to do so we can improve the AI.",
  scheduleAiFeedbackPlaceholder: "Explain what you tried to change",
  scheduleAiFeedbackSupportUnavailable: "The support chat is not available right now.",
  scheduleAiEditThinkingMessages: [
    "Reviewing the current schedule structure...",
    "Comparing your request with the existing rotation...",
    "Mapping required adjustments...",
    "Checking how this affects pattern...",
    "Looking for the smallest valid schedule change...",
    "Validating the changes are within bounds...",
    "Checking timezones and daylight saving time...",
    "Rebuilding the preview from the latest instructions...",
    "Verifying that the updated schedule is consistent...",
    "Aligning the proposed changes with the current entries...",
    "Evaluating edge cases around handovers...",
    "Translating your request into concrete schedule blocks...",
    "Checking whether the change repeats over time...",
    "Refining the preview to keep the pattern readable...",
    "Validating that the schedule remains continuous...",
    "Recalculating the affected dates and intervals...",
    "Looking for conflicts in the generated preview...",
    "Organizing the updated custody flow...",
    "Finalizing a preview that matches your request...",
    "Preparing the schedule draft for review...",
  ],
  inviteF2ReadMoreLink: "/app/knowledge/7084",
  change: "Change",
  color: "Color",

  activityLog: "Activity Log",
  




  
  // countries
  sweden: "Sweden",
  norway: "Norway",
  finland: "Finland",
  denmark: "Denmark",
  spain: "Spain",
  switzerland: "Switzerland",
  france: "France",
  germany: "Germany",
  belgium: "Belgium",
  nl: "Netherlands",
  uk: "United Kingdom",
  us: "USA",
  ca: "Canada",
  italy: "Italy",
  austria: "Austria",
  poland: "Poland",
  ireland: "Ireland",
  portugal: "Portugal",
  greece: "Greece",
  iceland: "Iceland",
  estonia: "Estonia",
  latvia: "Latvia",
  lithuania: "Lithuania",
  luxembourg: "Luxembourg",
  cyprus: "Cyprus",
  czechia: "Czechia",
  malta: "Malta",
  australia: "Australia",
  newzealand: "New Zealand",


  // Sex
  sex: "Sex",
  girl: "Girl",
  woman: "Woman",
  boy: "Boy",
  man: "Man",



  month: "Month",
  split: "Split",

  week: (week: number) => `Week ${week}`,
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",

  mon: "Mon",
  tue: "Tues",
  wed: "Wed",
  thu: "Thurs",
  fri: "Fri",
  sat: "Sat",
  sun: "Sun",



  january: "January",
  february: "February",
  march: "March",
  april: "April",
  may: "May",
  june: "June",
  july: "July",
  august: "August",
  september: "September",
  october: "October",
  november: "November",
  december: "December",

  januaryShort: "Jan",
  februaryShort: "Feb",
  marchShort: "Mar",
  aprilShort: "Apr",
  mayShort: "May",
  juneShort: "June",
  julyShort: "July",
  augustShort: "Aug",
  septemberShort: "Sept",
  octoberShort: "Oct",
  novemberShort: "Nov",
  decemberShort: "Dec",

  getWeekName: (weekNum: number) => {
    return "w. " + weekNum;
  },

  getQuarterName: (date: Date) => {
    if (date.getMonth() < 3) {
      return ("Q1 " + date.getFullYear());
    } else if (date.getMonth() < 6) {
      return ("Q2 " + date.getFullYear());
    } else if (date.getMonth() < 9) {
      return ("Q3 " + date.getFullYear());
    } else {
      return ("Q4 " + date.getFullYear());
    }
  },

  getTermName: (date: Date) => {
    if (date.getMonth() < 6) {
      return ("Spring " + date.getFullYear());
    } else {
      return ("Fall " + date.getFullYear());
    }
  },

  getMonthName: (monthNumber: number) => {
    switch (monthNumber) {
      case 0:
        return engelska.january;
      case 1:
        return engelska.february;
      case 2:
        return engelska.march;
      case 3:
        return engelska.april;
      case 4:
        return engelska.may;
      case 5:
        return engelska.june;
      case 6:
        return engelska.july;
      case 7:
        return engelska.august;
      case 8:
        return engelska.september;
      case 9:
        return engelska.october;
      case 10:
        return engelska.november;
      case 11:
        return engelska.december;
      default:
        return "Unknown";

    }
  },

  getMonthNameShort: (monthNumber: number) => {
    switch (monthNumber) {
      case 0:
        return engelska.januaryShort;
      case 1:
        return engelska.februaryShort;
      case 2:
        return engelska.marchShort;
      case 3:
        return engelska.aprilShort;
      case 4:
        return engelska.mayShort;
      case 5:
        return engelska.juneShort;
      case 6:
        return engelska.julyShort;
      case 7:
        return engelska.augustShort;
      case 8:
        return engelska.septemberShort;
      case 9:
        return engelska.octoberShort;
      case 10:
        return engelska.novemberShort;
      case 11:
        return engelska.decemberShort;
      default:
        return "Unknown";

    }
  },

  dateEnding: (date: number) => {
    let dateEnd = "th";
    if (date === 1) {
      dateEnd = "st";
    } else if (date === 2) {
      dateEnd = "nd";
    } else if (date === 3) {
      dateEnd = "rd";
    } else if (date === 21) {
      dateEnd = "st";
    } else if (date === 22) {
      dateEnd = "nd";
    } else if (date === 23) {
      dateEnd = "rd";
    } else if (date === 31) {
      dateEnd = "st";
    }
    return dateEnd;
  },

  dateMonthOrder: (date: Date) => {
    return (engelska.getMonthName(date.getMonth()) + ' '
      + date.getDate() + engelska.dateEnding(date.getDate()));
  },

  getWeekdayName: (weekdayNumber: number) => {
    switch (weekdayNumber) {
      case 0:
        return engelska.sunday;
      case 1:
        return engelska.monday;
      case 2:
        return engelska.tuesday;
      case 3:
        return engelska.wednesday;
      case 4:
        return engelska.thursday;
      case 5:
        return engelska.friday;
      case 6:
        return engelska.saturday;
      default:
        return "Unknown";

    }
  },

  getWeekdayNameShort: (weekdayNumber: number) => {
    switch (weekdayNumber) {
      case 0:
        return engelska.sun;
      case 1:
        return engelska.mon;
      case 2:
        return engelska.tue;
      case 3:
        return engelska.wed;
      case 4:
        return engelska.thu;
      case 5:
        return engelska.fri;
      case 6:
        return engelska.sat;
      default:
        return "Unknown";

    }
  },

  dateOfBirth: 'Year born',
  save: 'Save',
  uploading:'Uploading',
  publish: 'Publish',
  school: 'School',
  schoolAge: (age:number, school:SCHOOL_TYPES|undefined):string => isPreschool(school, age) ? "Preschool" : "School",
  sendInvite: 'Send Invite',

  importSchool : 'School',
  importSchoolRegion : 'School district',
  importSchoolCountry : 'Country',
  importSchoolExample : 'William Ward Elementary',
  importSchoolregionExample : 'New Rochelle',
  importSchoolChildren: 'Children at this school',
  doNotClearPreviousSchoolImport: 'Keep previously imported school holidays',

  // Header
  headerScheduleVisibleForYou: "Visible only to you",






  
  // Infobank

  tabChild: "Child Info",
  tabImages: "Images",

  // externalCal
  externalCalImportViaUrl: "Import using a link",
  externalCalImportedCalendar: "Imported calendars",
  externalCalName: "Calendar name",
  externalCalCalendarPerson: "Applies to:",
  externalCalCalendarShare: "Shared with:",

  externalCalUrlError: "The URL is not valid or accessible.",
  externalCalEmptyError: "No events were found in the ICS file.",
  externalCalHowItWorks: "Events are fetched from the link as read only.",
  externalCalAdd: "Add calendar",
  externalCalEmptyTitle: "Every event in one place",
  externalCalEmptyDescription: "Add a calendar using a subscription link, for example from school, your team or Google Calendar.",
  externalCalSource: "Source",
  externalCalPerson: "Events for",
  externalCalNoPerson: "No specific person",
  externalCalVisibleTo: "Visible to",
  externalCalOnlyYou: "Only you",
  externalCalYou: "You",
  externalCalMember: "Family member",
  externalCalMine: "Added by you",
  externalCalSharedBy: (name: string) => `Shared by ${name}`,
  externalCalManage: "Manage",
  externalCalDetails: "View details",
  externalCalEdit: "Manage calendar",
  externalCalBackToList: "Back to calendars",
  externalCalStepLink: "Calendar link",
  externalCalStepDetails: "Name and sharing",
  externalCalLinkTitle: "Start with a calendar link",
  externalCalLinkDescription: "Copy the subscription link from the calendar you want to add and paste it here.",
  externalCalLinkLabel: "Calendar link",
  externalCalLinkHint: "Use an iCal/ICS link.",
  externalCalFindLink: "Where do I find the calendar link?",
  externalCalGoogleHelp: "Open Google Calendar on the web. Choose the calendar’s Settings and sharing → Integrate calendar → Secret address in iCal format.",
  externalCalAppleHelp: "Open calendar sharing in Apple Calendar or iCloud. If you choose Public Calendar, you can copy the link. Anyone with that link can read the calendar.",
  externalCalOutlookHelp: "Open Outlook on the web: Settings → Calendar → Shared calendars → Publish a calendar. Copy the ICS link if publishing is available.",
  externalCalOtherHelp: "Look for “Subscribe”, “iCal” or “Export calendar” on your school or team’s website. Copy the link.",
  externalCalOtherProvider: "School or club",
  externalCalCheckLink: "Check link and continue",
  externalCalChecking: "Checking the link…",
  externalCalInvalidLink: "Enter a calendar link starting with https://, http:// or webcal://.",
  externalCalCannotRead: "The calendar could not be read. Check that you copied an iCal/ICS link that can be opened without signing in, then try again.",
  externalCalConnected: (count: number) => `Link verified · ${count} ${count === 1 ? "event found" : "events found"}`,
  externalCalConnectedEmpty: "The link works. The calendar is empty right now, but you can still add it.",
  externalCalNameHint: "For example, “School” or “Basketball”.",
  externalCalNameRequired: "Give the calendar a name.",
  externalCalPersonHint: "Whose events are these? Their picture appears beside the events. This choice does not change who can see the calendar.",
  externalCalSharingTitle: "Who can see the calendar?",
  externalCalSharingHint: "Only you can see the calendar to begin with. Select the family members who should also see the events.",
  externalCalAlwaysVisible: "You · always have access",
  externalCalReadOnly: (name: string) => `${name} shared this calendar with you and manages its link and sharing.`,
  externalCalRemove: "Remove calendar",
  externalCalLeave: "Stop showing for me",
  externalCalRemoveTitle: (name: string) => `Remove “${name}”?`,
  externalCalRemoveDescription: "The calendar and its events will stop appearing here for you and everyone you shared it with. The original calendar is unaffected.",
  externalCalLeaveDescription: "The calendar will stop appearing for you. It remains available to the person who shared it and others with access.",




  // Kalender 2
  calGuideMe : "Help",
  calCounterSuggestion : "Make a counter suggestion",
  calUpdateSuggestion : "You can alter the suggestion",

  calInspect : "Review",

  calQuickChangeResponsibility: "Change responsibility",


  calExistingSuggestion : "There is already an unanswered suggestion. We recommend that you update this suggestion with more changes.",

  calNewSuggestion : "New change request",

  calSchedules : "Schedule planner",

  calNewEvent : "New Event",
  calActivity: "Previous event",

  calSuggWaiting : "New suggestions",


  calHelpWhereSentSuggestion : "Here are your sent suggestions",
  calHelpBiggerChanges : "Swap responsibility here",

  calHelpClickEdit : "Click or drag days to swap",
  calHelpWrenchTools : "Tools for repeating changes",


  calChangeSchedule : "Change parenting schedule",
  calChangeScheduleName : (scheduleName:string) =>"Change "+scheduleName,

  calAiTooLongError     : "too long",
  calAiBadDatesError    : "start must be before end",
  calAiTooLong2Error    : "please choose a shorter period",
  calAiLimit            : "limit changes to",

  calHelpPlaceHolder : "Enter prompt or click one of the examples prompts below for help.",

  calExample1Short : "Two week...",
  calExample2Short : "Change handovers...",
  calExample3Short : "Add a day visit...",

  calExample1 : (nextMonday:string) => "Change the schedule so that the children are with each parent for two weeks. The handovers to be on Mondays and should be at the house of the parent picking up at 6PM. The first handover should be "+nextMonday,
  calExample2 : "Change all the handovers when I take over to be at 6PM at my house",
  calExample3 : (coparent:string) => "Add a day visit with me between 3PM and 6PM on Wednesdays when the children are with "+coparent+". I pick up at school and drop them off at "+coparent,


  calEventCantSee : "Can't see this event",
  calEventCreator : "Created this activity. ",
  calEventNotSeen : "Has not seen this activity yet. ",
  calEventNoAccount : "If invited. ",
  calMoreOptions : "More options",
  calTitleMustBeSet : "Title must be set",
  calEventOverlap : (count:number) => count === 1
    ? "Existing event:"
    : `${count} existing events:`,
  calHasCheckmark : "Add a checkbox to event",
  calCompletedBy : (name:string) => `, ticked by ${name}`,
  calImage : "Image",
  calFile : "File",

  calPlaceMissing :"Location is missing (not required)",
  calEndMustBeAfterStart : "End date and time must be after start date and time.",

  calTakesOver : (name:string) => `${name} takes responsibility`,
  calTakesOverFor : (names:string) => `for ${names}`,
  calResponsibilityFromSchool: (school:SCHOOL_TYPES|undefined, age:number):string =>
    isPreschool(school, age) ? "when preschool ends" : "when school ends",
  calResponsibilityUntilSchool: (school:SCHOOL_TYPES|undefined, age:number):string =>
    isPreschool(school, age) ? "when preschool starts" : "when school starts",

  calContinueStart : (name:string, date:string) => `${name} continues to take responsibility from the handover ${date}`,
  calContinueEnd : (name:string, date:string) => `${name} continues to take responsibility until the handover ${date}`,

  calEventYourNotifications : "Notifications",
  calEventOthersNotificationsShow : "Others notifications",



  calReminderName: (minutes:number): string => {
    switch (minutes) {
      case 0:
        return engelska.calReminder0Min;
      case 5:
        return engelska.calReminder5Min;
      case 10:
        return engelska.calReminder10Min;
      case 15:
        return engelska.calReminder15Min;
      case 30:
        return engelska.calReminder30Min;
      case 60:
        return engelska.calReminder60Min;
      case 120:
        return engelska.calReminder120Min;
      case 720:
        return engelska.calReminder12H;
      case 1440:
        return engelska.calReminder1Day;
      case 2880:
        return engelska.calReminder2Day;
      default:
        return "Unknown";
    }
  },

  calReminder0Min   : "At activity start",
  calReminder5Min   : "5 minutes in advance",
  calReminder10Min  : "10 minutes in advance",
  calReminder15Min  : "15 minutes in advance",
  calReminder30Min  : "30 minutes in advance",
  calReminder60Min  : "1 hour in advance",
  calReminder120Min : "2 hours in advance",
  calReminder12H    : "12 hours in advance",
  calReminder1Day   : "1 day in advance",
  calReminder2Day   : "2 days in advance",

  calWeekPlanning : "Week planner",

  calPackingList :"Packing list",
 
  calDayvisit: "Dayvisit",
  calDayvisitAt: "Dayvisit at",
  calDayvisitOnDay : (name: string, day: string) => `${name} on a ${day}`,
  calDayvisitToFrom : (from: string, to: string) => `From ${from} to ${to}`,

  calEventUpdateAll : "Update all?",
  calEventEraseAll : "Erase all?",
  calEventOnlyThis : "Only this one",
  calEventConfirmEraseAll : "Erase all",
  calEventConfirmEraseFollowing : "Erase this and all following",
  calEventConfirmUpdateAll : "Update all",
  calEventAll : "All",

  calConfirmReply : "Confirm choice",
  calConfirmDecline : "Do you want to decline the suggestion?",
  calConfirmDelete : "Do you want to delete the suggestion?",
  calConfirmNew : <span>Are you sure you want to make a new suggestion when there is already one waiting for a response? <br /><br/>If you make several suggestions for the same day, only one can be accepted.</span>,
  calConfirmNewEditExisting : "Adjust existing",
  calConfirmNewMakeNew : "Make a new suggestion",
  calShowNewSchedule : "Do you want to show the new schedule?",
  calShareNewSchedule : "Do you want to share the new schedule?",

  calQuickChangeFor:(kids:string) => `Change the handover for ${kids}`,
  calQuickChangeDayvisitFor:(kids:string) => `Change ${kids}s dayvisit`,

  calShowAs : (s:"TEXT"|"IMAGE") => <><span>Show as:</span><span style={{fontWeight:(s==="TEXT"?700:400)}}>text</span><span>/</span><span style={{fontWeight:(s==="IMAGE"?700:400)}}>image</span></>,
  calTakesResponsibility : "takes on the responsibility in the period:",
  calHandoverChangeWas : (from:string, to:string) => `The handover from ${from} to ${to} that was on`,
  calChangeDate : (date:Date) => engelska.dateMonthOrder(date),
  calHandoverChangeTime : (date:Date, timeAndPlace:string) => `${engelska.calChangeDate(date)} ${timeAndPlace}`,
  calHandoverChangeTo : "is changed to",
  calDayVisitAdded : "New day visit with",
  calDayVisitChanged : "Changed day visit with",
  calDayVisitRemoved : "Removed day visit with",
  calDayVisitDay : (date:Date) => `${engelska.getWeekdayName(date.getDay())}, ${engelska.calChangeDate(date)}`,
  calDayVisitSchool : (school:SCHOOL_TYPES|undefined, age:number):string => isPreschool(school, age) ? "Preschool" : "School",
  calDayVisitNoLocation : "Unspecified location",

  calInvert : "Switch entire schedule",
  calChanges : "Changes",
  calNext : "Next",
  calOriginal: "Current Schedule",
  calScheduleSuggestion : "Suggestion",
  calChange : (change:number, of:number) => `Change ${change}/${of}`,
  calKidChange : (from:string, to:string) => `This schedule is now for ${to} instead of ${from}`,
  calPickDateRange :"Pick date range",




  calPickDateAllDays :"Pick only certain days of week",
  calDaysMarked : (days:number) => `${days} marked days`,
  
  
  calWizardStart : "Start date",
  calWizardEnd : "End date",
  calWizardRepeat: "After how many days do the schedule repeat?",
  calWizardError : <span>In order to create a schedule according to a template, you must select a continuous period of at least 10 days.</span>,
  calWizardCustomExplain : "In the next step, you can make a custom schedule. For example for those who work shifts.",
  calWizardEven : "You can move the exchange days in the next step.",
  calWizardUneven : "You can change and move who has which days in the next step.",
  calWizardShift : "Shift exchange days forward or backward",
  calWizardWhereSleeps : "Select where the child sleeps",
  calWizardWhereSleepsTip : "Tip: look above as the schedule updates as you click",
  calClickDaysToSwap : "Click days to set who has responsibility!",

  calSelectAll : (day:string) => `Select all ${day}s?`,
  calSelectEveryOther : (day:string) => `Select every other ${day}?`,

  calParents: "Parents",
  calForKids: "This schedule is for",

  calEntireSched : "Modifies entire schedule",


  calSleepsAt: (name:string) => `${name} has responsibility`,
  calChangeTimePlace: "Change time & place",
  calChildren : "Children",
  calAddVisit : "Add day visits",
  calShiftDays : "Shift/invert all days",
  calMakeChangesFromDate : "Make changes from date",
  calWizard : "Template",
  calAi : "Prompt changes using AI",
  calClearDays : "Clear days",


  calTimePlaceHelp:<span>Click on the days <b>with handovers</b> that you want to change.</span>,
  calDayvisitHelp:<span>Click the days you want to add day visits on.</span>,
  calDayvisitTooShort : "The day visit must be at least 15 minutes long.",

  calEraseChange : (name:string) => `Delete this schedule (${name}).`,

  calErrorApplySuggestion : "The suggestion could not be shown because the days this suggestion is for has already been changed by another suggestion.",
  calErrorSuggestionNotFound : "The suggestion could not be shown as it has already been replied to or has been erased by the creator.",
  calErrorDeleteSuggestion : "Delete suggestion",

  calChatSuggestionTopic : (id:number) => `Suggestion ${id}`,

  calInfo : "Information",
  calSuggestionAccepted : "The suggestion was accepted!",
  calSuggestionDeleted : "The suggestion was deleted!",
  calSuggestionRejected : "The suggestion was declined!",

  calMessage : "Message",
  calAddMessage : "If you want to add a message, write it here.",

  calExchangeNoHandoverDays : "The days you have selected do not result in any need to enter location for new handovers.",

  calWhenExchange : "When the handover takes place",
  calHandoverToFrom : (from: string, to: string) => `From ${from} to ${to}`,
  calDayvistAt : (at: string) => `At ${at}`,

  calOccurences : (days:number) => ((days === 1)?`${days} occurence`:`${days} occurences`),
  calHandoverAtSchool : (school:SCHOOL_TYPES|undefined, age:number):string =>
    isPreschool(school, age) ? "Handover takes place at Preschool" : "Handover takes place at School",

  calPrivate : "Private",
  calShared : "Shared",
  calActive : "Active",

  calParentingSchedules : "Custody schedule",
  calOldSuggestions : "Old suggestions",
  calSchoolSetting : "Preschool or school",
  calSchoolCalculatedOnAge : "Based on the children's age",
  calSchoolPreschool : "Preschool",
  calSchoolSchool : "School",
  calDeleteSchedules : "Delete Schedule",
  calDeleteSuggestion : "Delete suggestion",
  calAdjustSuggestion : "Adjust suggestion",
  calMustBeShared : "The schedule must be shared with you",
  calShareSchedule : "Share Schedule",
  calMakeActive : "Select as current",
  calMakeInactive : "Stop using schedule",
  calMakeSuggestion : "Change some days",
  calMakeSuggestionGuide : "Edit",
 
  calMakeNew : "Create new schedule",
  calMakeNewWarningTitle : "Do you really want to create another schedule?",
  calMakeNewWarning : <span>This is probably not what you want. An additional schedule is for when you have several children who follow different schedules.<br/><br/>Do you want to change the schedule you already have? Click <b>New change request</b> in the top left corner, then the red wrench button, and choose <b>Template</b>.</span>,
  calMakeNewWarningContinue : "Create anyway",

  calSuggestionAwaitReply : "Awaiting reply",
  calSuggestionAwaitReplyFYou : "Awaiting a reply from you",
  calSuggestionFrom : (name:string, date:string) => `Suggestion from ${name} ${date}`,
  calSuggestionSubAccepted : (name:string, date:string) => `Accepted by ${name} ${date}`,
  calSuggestionSubRejected : (name:string, date:string) => `Rejected by ${name} ${date}`,
  calSuggestionSubDeleted : (name:string, date:string) => `Deleted by ${name} ${date}`,
  calSuggestionStatusAccepted : (name:string, date:string) => <><b>Accepted</b> by {name} {date}</>,
  calSuggestionStatusRejected : (name:string, date:string) => <><b>Rejected</b> by {name} {date}</>,
  calSuggestionStatusDeleted : (name:string, date:string) => <><b>Deleted</b> by {name} {date}</>,
  calSuggestionErase : `Suggestion to delete schedule`,
  calStopUsing : "Click to stop using",

  calGuideTopic : "Do you want to use a guide?",
  calGuideWhatGuide : "If you want to change schedule type or plan a new period, we recommend the Guide.",
  calGuideWhatTool : "For other changes we recommend Tools.",
  calGuideUseGuide : "Guide",
  calGuideUseTool : "Tools",



  // do not remove these they are the names for the sidebar panel
  settings: "Settings",
 
 // sidebar panel end

  selectCalendarShow: "Select calendar to show",
  recentEvents: "Recent events",
  deletedAccount: "Deleted Account",
  support: "Support",


  // Todo
  todoYours: (date: string) => `You did this ${date}`,
  todoNotYours: (name: string, date: string) => `${name} did this ${date}`,

  todoSeenBy: "Seen by: ",
  packingSeenByAll: "Everything has been seen by:",
  packingUnseenNotice: "You have unseen things in this list, scroll down to see",
  packingGeneral: "General",
  packingTaggedChild: "Whose item",
  todoTitleMin: (min: number) => `Write at least ${min} characters`,
  sharedNoteUnseen: "unseen",
  notShared : "Not published",
  todoSeenPrivate: (calendar:string) => `From calendar ${calendar}. Only visible for you`,
  calUrlImp:  (shared?:boolean):string => shared?`Imported by URL. Can't be modified`:`Imported by URL. Can't be modified. Visible only to you (possible to change under import)`,
  calUrlInternal: (shared?:boolean):string => shared?`Switch group to modify`:`Switch group to modify. Visible only to you (possible to change under import)`,

  todoNextHandover: "See next exchange",

  timePickerFullDay: "All day",

  todoList: "TO-DO",
  todoAssigned: "Responsible",
  todoResponsibleForCheckingOff: "Responsible for checking off",
  todoUnassigned: "Unassigned",
  todoUnseen: "unseen",
  todoDue: (date: string) => `Due ${date}`,
  todoMarkComplete: (title: string) => `Mark complete: ${title}`,
  todoMarkIncomplete: (title: string) => `Mark incomplete: ${title}`,
  todoHide: "Hide",
  todoCompletedBy: (date: string | undefined, name: string) => `✔️ ${date ? date + " " : ""}by ${name}`,
  todoCalendarInfo: "Calendar activities with a checkbox, 3 days ago to 7 days ahead.",
  todoCalendarNoPeople: "No one selected",
  todoVisibleTooltip: "Visible for",
  todoRenewalDropOff: "The person handing off",
  todoRenewalPickUp: "The person picking up",
  todoRenewalStatic: "Always the same",
  todoRenewalOnce: "No renewal",

  todoRenewNo: "No repeat",
  todoRenewHandover: "Repeated next handover",

  // Next Handover
  handoverLocation: "Location: ",

  nextHandoverTitle: (names: string) => `Next exchange for ${names}:`,
  noDataForNextHandover: "No data for the next exchange that you will do can be found",
  nextHandoverHasBeen: "This exchange has already happened.",
  handoverExchange: (childrenNames: string, parentPickingUp: string, parentDroppingOff: string, startDate: Date, atSchool: boolean, location?: string,
    school?: SCHOOL_TYPES, age?: number) => {
    const day = engelska.handoverDay(startDate);
    let timeAndPlace;
    if (atSchool) {
      timeAndPlace = isPreschool(school, age) ? "at preschool" : "at school";
    } else {
      timeAndPlace = engelska.handoverTimeAndPlace(startDate, location);
    }
    return `${parentDroppingOff} drops off and ${parentPickingUp} picks up ${childrenNames} ${day} ${timeAndPlace}.`;
  },
  handoverPickup: (atSchool: boolean, location?: string, school?: SCHOOL_TYPES, age?: number) => {
    if (atSchool) {
      return isPreschool(school, age) ? "Through preschool" : "Through school";
    } else {
      return location ? ("Location: "+location) : "Location not set";
    }
  },
  handoverDropoff: (atSchool: boolean, location?: string, school?: SCHOOL_TYPES, age?: number) => {
    if (atSchool) {
      return isPreschool(school, age) ? "Through preschool" : "Through school";
    } else {
      return location ? ("Location: "+location) : "Location not set";
    }
  },
  handoverDayAndTime: (startDate: Date) =>
    `${engelska.handoverDay(startDate)} at ${TranslateNew.getInstance().formatTime(startDate)}`,

  handoverDay: (startDate: Date) => {
    if (isSameDay(startDate, new Date())) {
      return "Today";
    } else if (isSameDay(startDate, addDays(new Date(), 1))) {
      return "Tomorrow";
    } else {
      return engelska.getWeekdayName(startDate.getDay()) + ", "
        + engelska.getMonthName(startDate.getMonth()) + " " + startDate.getDate();
    }
  },
  handoverTimeAndPlace: (startDate: Date, location?: string) => {
    let timeAndPlace = "at " + TranslateNew.getInstance().formatTime(startDate);
    if (location) {
      timeAndPlace = timeAndPlace + " at " + location;
    } else {
      timeAndPlace = timeAndPlace + " at unspecified location";
    }
    return timeAndPlace;
  },
  // Labels
  labelLocation: "Location",

  labelDescription: "Description",
  labelMessageOptional: "Message (optional)",
  labelDisplay: (label: string) => `Display ${label}`,
  labelEmail: "Email",
  labelUsername: "Username",
  labelPassword: "Password",

  labelSchoolStartEnd: (school:SCHOOL_TYPES|undefined, age:number):string =>
    isPreschool(school, age) ? "Preschool start/end" : "School start/end",
  labelParentsHome: (parent: string) => `at ${parent}'s`,
  labelUnspecified: "Unspecified",
  labelTodos: "Todos",
  labelEvents: "Events",
  labelSchoolBreaks: "School Breaks",
  labelFirstName: "Firstname",
  labelSirName: "Last name",
  labelDateOfBirth: 'Year born',
  labelTitle: "Title",
  labelMessage: "Message...",
  signupTermsNoticeStart: "By creating an account you agree to the ",
  termsOfUseLinkText: "Terms of Use",
  signupTermsNoticeMiddle: " and acknowledge the ",
  privacyPolicyLinkText: "Privacy Policy",
  termsOfUseUrl: "https://www.co-parenting.app/terms-of-use/",
  privacyPolicyUrl: "https://www.co-parenting.app/privacy-policy/",
  labelInviteToken: "I am invited by a parent and have a code",
  copiedToClipboard: "Copied to clipboard",

  // Placeholders
  placeholderInviteToken: 'Enter the code here',

  // Experts

  labelPhone: "Phone number",
  inviteChooseContact: "Choose from contacts",
  inviteOpeningContacts: "Opening contacts…",
  inviteChooseContactPhone: "Choose phone number",
  inviteContactNoPhone: "This contact has no phone number. Choose another contact or enter the number manually.",
  inviteContactInvalidPhone: "Couldn’t fill in this number. Check the country code and enter the number manually.",
  inviteContactError: "Couldn’t open contacts. Try again or enter the number manually.",
  inviteSmsConsent: "I confirm this person has agreed to receive a one-time SMS invitation from Co-parenting.",

  // Validation

  getPhoneValidationMessage(countryCode: string): string {
    const errorMessagesMap: { [key: string]: string } = {
      "+46": "The format should be: 707123456",
      "+358": "The format should be: 401234567",
      "+47": "The format should be: 41234567",
      "+45": "The format should be: 20123456",
      "+34": "The format should be: 612345678",
      "+41": "The format should be: 791234567",
      "+49": "The format should be: 15123456789",
      "+33": "The format should be: 612345678",
      "+32": "The format should be: 471234567",
      "+31": "The format should be: 612345678",
      "+44": "The format should be: 7123456789",
      "+1":  "The format should be: 2125551234",

      "+354": "The format should be: 6123456",
      "+372": "The format should be: 51234567",
      "+371": "The format should be: 21234567",
      "+370": "The format should be: 61234567",
      "+353": "The format should be: 851234567",
      "+352": "The format should be: 62123456",
      "+43":  "The format should be: 6641234567",
      "+423": "The format should be: 6612345",
      "+377": "The format should be: 61234567",
      "+376": "The format should be: 312345",
      "+378": "The format should be: 666123456",
      "+39":  "The format should be: 3123456789",
      "+350": "The format should be: 57123456",
      "+351": "The format should be: 912345678",
      "+356": "The format should be: 99123456",
      "+30":  "The format should be: 6912345678",
      "+357": "The format should be: 96123456",
      "+48":  "The format should be: 512345678",
      "+420": "The format should be: 601234567",
      "+421": "The format should be: 901234567",
      "+36":  "The format should be: 201234567",
      "+386": "The format should be: 31234567",
      "+385": "The format should be: 912345678",
      "+387": "The format should be: 61123456",
      "+381": "The format should be: 611234567",
      "+382": "The format should be: 67123456",
      "+389": "The format should be: 71234567",
      "+355": "The format should be: 671234567",
      "+383": "The format should be: 43123456",
      "+359": "The format should be: 881234567",
      "+40":  "The format should be: 712345678",
      "+373": "The format should be: 62123456",
      "+380": "The format should be: 671234567",
      "+375": "The format should be: 291234567",
      "+7":   "The format should be: 9123456789",
      "+90":  "The format should be: 5012345678",
      "+995": "The format should be: 555123456",
      "+374": "The format should be: 77123456",
      "+994": "The format should be: 501234567",
      "+61":  "The format should be: 412345678",
      "+64":  "The format should be: 21234567",
      "+349": "The format should be: 612345678",
    };
    return errorMessagesMap[countryCode] || "Invalid phone number format.";
  },

  validationEmailNotValid: "Email is not valid!",
  validationEmailRequired: "Email is required!",
  validationFirstNameInvalid: "Invalid firstname!",
  validationFirstNameRequired: "Name is required!",
  validationSirNameInvalid: "Invalid last name!",
  validationSirNameRequired: "Last name is required!",

  validationNewPasswordMin: (min: number) => `Minimum ${min} characters long`,

  validationPasswordRequired: "Password is required!",
  validationYearInvalid: "Invalid year",
  validationChildMin: (min: number) => `Must be at least ${min} child`,
  validationChildRequired: "Child is required!",

  validationInvitationCode: "Invalid Invitation Code Format",
  validationInvitationCodeRequired: "Invitation code is required",


  // Landing

  landingTitle: <span>Everything about the children in <i>one</i> place</span>,
  landingImNewCreateAccount: "Create account",
  landingUseBroswer: "Use browser version",

  // Select lang
  swedish: 'Swedish',
  english: 'English',
  swedishCompact: '🇸🇪',
  englishCompact: '🇬🇧',

  // Subscription and paywall
  subscription: 'Subscription',
  subscriptionPaywall: (style: React.CSSProperties) => 
    <ul style={style}>
      <li>You got the app for free with no strings attached.</li>
      <li>The app is free for everyone you invite.</li>
      <li>You're not committing to anything once the trial ends.</li>
    </ul>,

  // subscriptionFree: 'For free some more',
  // subscriptionPaywallFree: <span>The app is <b>free</b> to explore.<ul><li><b>Everyone</b> in the child's family has access to the app if <b>one</b> parent have a subscription.</li><li>The cost can be split between the parents.</li></ul></span>,
  subApple: 'Subscription via Apple',
  subAppleTest: 'Subscription via Apple Sandbox',
  subGoogle: 'Subscription via Google',
  subGoogleTest: 'Subscription via Google Sandbox',
  subWeb: 'Subscription via Web',
  subWebTest: 'Subscription via Web Sandbox',
  subPlan: 'Your plan',
  subFullAccess: 'Full access to the app.',
  subTimeLeft: 'Renews / Runs out:',
  subTimeOut: 'ran out',
  subByUser: (name: string) => `Paid by ${name}.`,
  subManage: "You do not have to pay anything when the trial ends. This subscription will not convert to a paid plan without your explicit consent.",
  subManageApp: "You cancel your subscription in the settings on your phone, not in this app.",

  initializing: "Initializing...",
  noPaymentYet: "Free for now",
  noPurchasePossible: "Subscription purchase not available.",
  subscriptionExists: "Done!",

  orderCancelled: "Order cancelled. ",
  sendingSubRequest: "Sending to server",
  orderPending: "Waiting for purchase to complete",
  validatingSub: "Validating subscription",
  subValidatingExisintg: "Validating existing subscription",
  savingSub: "Saving subscription",
  freeTrial:"-day free trial",
  cancelTrial:"Cancel before trial ends - no charge",

  // countries

  // campaign
  campaignTitle : "Prepaid link",
  campaignSpecialOffer : (benefactor:string) => `You have an offer from ${benefactor} who pays for your initial usage.`,
  campaignEnterEmail : "Enter your email and we apply the offer when you register using that email in the app.",

  campaignKommun : (benefactor:string)  => `Special offer for you in ${benefactor} municipality`,
  campaignKommun2 : (benefactor:string) => `If you live in ${benefactor} municipality you can use the app Varannan vecka free of charge for 1 year from the date you register. The offer applies to registrations until 31 Dec 2026.`,
  

  // Log in
  logInTitle: "Log in",
  logInButton: "Log in",
  useSavedPassword: "Use saved password",
  savedPasswordUnavailable: "No saved password could be retrieved. You can enter your email and password manually.",
  passwordSaveFailed: "You are signed in, but your password could not be saved to your phone’s password manager. You can try again next time you log in.",
  logInForgot: "Forgotten the password?",


  // Sign up
  signUpTitle: "Sign up",
  signUpInviteQuestion: "Have you been invited by another parent?",
  signUpJoinGroupButton: "Yes - join group",
  signUpStartNewGroupButton: "No - start new group",
  signUpButton: "Sign up",
  signUpEmailUsed: "There is already an account registered with that email.",
  signUpEmailUsedWithGuide: (<>
    <p>Seems like an account has already been created with that email.</p>
    <p>You can register the new account with another email or log in on your existing account and erase it under settings first.</p>
  </>),

  signUpHandoverTitle: "Adjust exchange days",
  importWeekendsFor: "Holidays and school vacations",
  importDaysOffFor: 'We add national holidays and school vacations for you!',

  importDaysArea: 'Municipal',
  signupCampaign: 'With special offer from',

  geoLocAuto: "Find my municipality",
  geoLocSearching: "Searching",
  geoLocNotSupported: "Geolocation not allowed",
  geoLocDone: "Geolocation done",
  geoLocUserDenied: "User denied",
  geoLocUnavail: "Geolocation unavailable",
  geoLocTimeOut: "Timed out",

  // calling
  calling : "Calling to..",
  calledBy : "is calling",
  called : (name:string) => `${name} called`,
  calledFor : (seconds:string) => " for "+seconds+"s before hanging up.",
  callRangFor : (seconds:string) => " for "+seconds+"s.",
  callDeclined : (name:string) => `${name} declined`,
  callAnswered : (name:string) => `${name} answered`,
  callRejected : (name:string) => `${name} rejected`,
  callNoAnswer : (name:string) => `${name} no answer`,
  callTechError : (name:string) => `${name} technical error`,
  callTechErrorSeconds : (name:string, seconds:string) => `${name} technical error after ${seconds} seconds`,
  callDuration : (duration:number) => `Call duration approx ${duration} minutes`,
  callsRecorded : "This video call is recorded and saved",
  callRecording : "The call is being recorded, it might take a few minutes until the video is available.",
  callNewFunctionality : "Calls is a new functionality under development. Please give feedback in the tech-support thread!",
  callTurnOff : "If you dont want to receive calls you can turn it off in ",
  videoOn: "Video is on",
  videoOff: "Video is off",

  callPermissionTitle : "Permissions needed",

  callPermission : <span>To make calls you need to give the app permission to use your microphone and camera. Try to <b>turn off and on the permission</b> in the settings.</span>,
  callPermissionBrowser : <span>To make calls you need to allow microphone and camera access in your browser. Check this site's permissions in your browser, then try the call again.</span>,

  longpressToDownload : "Long image press to download",

  // Sign up invite
  signUpInviteError: "No invite was found matching the code or it was already used! Double check that you entered it correctly.",
 
  // Messages
  chatSubject : "Topic",

  createChatNoTopic: 'Topic must be set',

  createChat: 'Create',
  createNewChat: "Create a new chat",
  editChat: "Edit chat",
  noMessagesYet: 'No messages yet 🤷',
  chatSeen: (names: string) => `Seen by ${names}`,
  chatReadBy: (readers: string) => `Read by ${readers}`,
  chatArchivedBy: (names: string) => `Archived by: ${names}`,
  chatSearch:"Search...",
  chatArchive: "Archive",
  chatCall: "Call",
  chatCallUnavailableSupport: "Calls are not available in support chats",
  chatCallUnavailableSignup: (names: string) => `${names}: not signed up`,
  chatCallUnavailableDisabled: (names: string) => `${names}: turned off calls`,
  chatUnarchive: "Unarchive",
  chatNameChange: "Edit",
  chatGenerateIcon: "Generate icon",
  chatGeneratingIcon: "Generating icon...",
  chatGenerateIconFailed: "Could not generate an icon. Please try again.",
  chatPolish: "Polish",
  chatPolishing: "Polishing...",
  chatPolishFailed: "Failed, try again",
  chatReply: "Reply",
  chatReplyTo: "Reply to:",
  chatReplyingTo: "Replying to:",
  chatReplyToEarlierMessage: "an earlier message",
  chatCancelReply: "Cancel reply",
  chatShowArchive: "Show Archive",
  chatHistorySaved: "Chat history sent to your email. It might take a few minutes.",
  chatCheckIn: "Share your location",
  chatCheckInTitle: "Share your location?",
  chatCheckInConfirm: "Your current location will be posted in this chat, so everyone in it can see where you are.",
  chatCheckInLocating: "Finding your location…",
  chatCheckInDeniedTitle: "Location access needed",
  chatCheckInDenied: "To share your location, the app needs permission to use it. Turn on location access for the app in the settings.",
  chatCheckInDeniedBrowser: "To share your location, your browser needs to allow it. Allow location for this site in your browser's settings, then try again.",
  chatCheckInUnavailable: "Your location could not be found. Check that location services are on and try again.",


  // Gif
  chatGifSearch: "Search for GIF",



  // ChildInfo
  vaccineDose : "Dose",
  vaccineDate : "Date",
  vaccineNextDose : "Next dose",
  vaccineAdd: "Add vaccination",
  vaccineNew: "New vaccination",
  vaccineEmpty: "No vaccinations added yet.",
  vaccineNamePlaceholder: "Vaccination name",
  vaccineDosesReceived: "Doses received",
  vaccineLastDose: "Latest dose date",
  vaccineSelectDate: "Select date",
  vaccineIncreaseDose: "Increase doses",
  vaccineDecreaseDose: "Decrease doses",
  vaccineRemoved: "Vaccination removed",
  vaccineNameRequired: "Enter the vaccination name.",
  vaccineDosesInvalid: "Enter a whole number, 0 or higher.",


  childInfoSocialNo: 'Social security num',
  childInfoPassNo: 'Passport num',
  childInfoPassLoc: 'Where is the passport?',
  childInfoClothing: 'Clothing size ',
  childInfoShoeSize: 'Shoe size ',
  childInfoMeds: 'Meds / allergy',
  childInfoAllergies: 'Other',
  childInfoInsurance: 'Insurance',
  childInfoVaccination: 'Vaccination',
  childInfoVaccinations: 'Vaccinations',
  childInfoPassHistory: 'History: Where is the passport?',
  childInfoNoData: 'No data yet',
  childInfoVaccSubline:(date:string, dose:number) => `${date ? date + ", " : ""}dose ${dose}`,

  // avatar
  avatarDrawn : 'Drawn avatar',
  avatarPhoto : 'Photo',


  // flow post
  flowPostNew: 'Share image',
  flowPostSddComment: 'Add a comment...',
  flowTip1 : 'Being generous and sharing pictures and other info builds strong parenting teams for the children.',
  flowTip2 : 'Tip: share your favourite picture of the children!',

  flowPostRecentActionImageUploaded: ` uploaded an image.`,


  sharedTaskHelper: "Add tasks with clear responsibility assignment and reminders!",

  // AI stuff
  aiOnboardingSlide1Title : <span>Let AI do the <span style={{color:secondaryColor}}>boring</span> stuff!</span>,
  aiOnboardingSlide1Text : "Whether it's a birthday invite, school event or this weeks homework, our AI extracts the info for you.",
  aiOnboardingSlide2Title : "How It Works",
  aiOnboardingSlide2Text : "Take a photo or select a screenshot.",
  aiOnboardingSlide3Title : "We analyze",
  aiOnboardingSlide3Text : "Our AI scans images for key details and creates new events for you to confirm.",
  aiOnboardingSlide4Title : <span>Works with <span style={{color:primaryColor}}>everything!</span></span>,
  aiOnboardingSlide4Text : "Birthday invites, dentist appointments, SMS, emails, school platforms, and even physical notes!",
  aiOnboardingSlide4Button : "Let's try it!",


  // shared notes
  sharedSharedAccounts: "Accounts",
  sharedSharedNotes: "Notes",
  sharedNoteVisible: 'Visible for',
  sharedNoteCreated: (title: string) => `created a list ${title}`,
  sharedNoteModified: (title: string) => `modified a list ${title}`,
  sharedNoteHelper: "Here you can easily share wish lists, shopping lists, or packing lists for the summer camp. \n\nTip: The AI can sort the items in the list. Create a private grocery shopping list give it a try!",
  sharedAccountHelper: "Do the child have some streaming services or PIN-codes? Write down the credentials and split the cost!",
  sharedNoteGeneratingIcon: "Generating icon",


  service: "Service",
  selectService: "Select service",
  otherStreamingService: "Other service",
  otherStreamingServiceDesc: "Streaming service",
  reorderNotes: "Re-order",
  promptSharedNote: "Prompt change",
  sharedNoteAddText: "Add Text",
  sharedNoteGenerateIcon: "Generate icon",
  sharedNoteCreate:"New list",
  sharedNoteEdit:"Edit list",

  // shared note AI
  sharedNoteExamplePromptTitle1: "Weeks menu",
  sharedNoteExamplePromptPrompt1: "Suggest a menu for the upcoming week. Use each day of the week as a heading. For each day, create two different easy-to-make meal options.",
  sharedNoteExamplePromptTitle2: "Packing List",
  sharedNoteExamplePromptPrompt2: "Create a packing list for a 12-year-old going to summer camp for 7 days. Include the quantity for each item. Make appropriate headings with emojis.",
  sharedNoteExamplePromptTitle3: "Summer Plans",
  sharedNoteExamplePromptPrompt3: "Suggest 20 summer activities to do with children ages 9 and 12. Group them under headings that include emojis.",
  sharedNoteExamplePromptTitle4: "Movies to Watch",
  sharedNoteExamplePromptPrompt4: "List 30 movies that are fun for a family with kids ages 9-12. Include the Rotten Tomatoes rating for each movie. Group them into appropriate categories.",
  sharedNoteExamplePromptTitle5: "Gift ideas",
  sharedNoteExamplePromptPrompt5: "Give 10 gift suggestions for a 9-year-old boy. Price around 20 USD.",
  sharedNoteExampleHandover:"Handover Note",

  sharedNoteExampleEditPromptTitle1: "Group the List",
  sharedNoteExampleEditPromptPrompt1: "Organize the list into appropriate groups with headings. If it's a shopping list, group items according to the stores different sections. Use emojis in the headings if suitable.",
  sharedNoteExampleEditPromptTitle2: "Create Shopping List",
  sharedNoteExampleEditPromptPrompt2: "Based on the contents of the list, make a shopping list of items I need. Keep the original list at the top with the same headings and create the shopping list underneath, grouped by different sections.",
  sharedNoteExampleEditPromptTitle3: "Handover Note",
  sharedNoteExampleEditPromptPrompt3: (coparentName:string, childrenNames:string) => "Based on my notes, write a friendly handover note to my coparent (" + coparentName + ") about how our children (" + childrenNames + ") have been during the period they were with me. Write it as a text, not as a list.",


  // Settings
  account: "Account",
  preferences: "Preferences",
  settingsChat: "Chat",
  changePassword: "Change Password",
  changeEmail: "Change Email",
  eraseAccount: "Erase Account",
  newPassword: "New Password",
  newEmail: "New Email",
  emailUpdated: "Email updated!",
  allowCalls: "Allow calls",
  notifyHandover: "Notifications: Handovers",
  notifyMorningSummary: "Notifications: Morning summary",
  muteListNotifications: "Notifications: List updates",
  emailMissedMessages: "Email me missed chat messages",
  messageScreening: "Message screening",
  messageScreeningNormal: "Normal",
  messageScreeningStrict: "Strict",
  messageScreeningVeryStrict: "Very strict",
  veryStrictScreeningTitle: "Turn on very strict screening?",
  veryStrictScreeningWarning: "Very strict screening may stop messages by mistake, even when they are not toxic. It applies to all participants in all chats.",
  veryStrictScreeningConfirm: "Yes, turn it on",
  disablePreviews: "Disable previews of my messages",
  chatPreviewHidden: (name: string) => `A message from ${name}`,
  autoApproveSuggestions: "Auto-approve suggestions",
  autoApproveSuggestionsTitle: "Auto-approve suggestions sent to you?",
  autoApproveSuggestionsWarning: "Suggestions the other parent sends you will be approved automatically, as if you had clicked Approve yourself right away. This only covers suggestions to you: the ones you send still need the other parent's approval.",
  autoApproveSuggestionsConfirm: "I understand, turn it on",
  settingsDownload: "Download",
  downloadScheduleChanges: "Download schedule changes",
  downloadEconomy: "Download economy",
  downloadTodos: "Download todos",
  todosExportEmailQueued: "Your todos PDF will be delivered to your email within a minute.",
  strictToxicFilterHelp: "How the AI filter works",
  enhancedVisibility: "Larger fonts",
  darkMode: "Dark mode",
  darkModeSameAsPhone: "Same as phone",
  darkModeAlwaysDark: "Always dark",
  darkModeAlwaysLight: "Always light",
  gmailSettingsHeading: "Email integration",
  gmailSettingsExplanation: "You can forward emails to Co-parenting (for example, school newsletters). We’ll interpret them and suggest activities to add to your calendar.",
  emailIntegrationActivate: "Activate",
  emailIntegrationActivating: "Activating…",
  emailIntegrationForwardTo: "Forward emails to",
  emailIntegrationCopied: "Copied!",
  emailIntegrationCopyError: "Couldn’t copy the address. Select it and copy it manually.",
  emailIntegrationAddContact: "Add to contacts",
  emailIntegrationOpeningContacts: "Preparing contact…",
  emailIntegrationContactName: "Co-parenting",
  emailIntegrationContactError: "Couldn’t prepare the contact. Try again or copy the address and create the contact manually.",
  emailIntegrationGmailHeading: "Gmail™ integration",
  emailIntegrationError: "We couldn’t load or activate your email address. Please try again.",
  emailIntegrationUnavailable: "Your email address is currently unavailable.",
  emailIntegrationActivationError: "We couldn’t activate your email address. Please try again.",
  gmailInstallAddon: "Install Gmail™ add-on",
  gmailInstallStepOne: "Install the add-on with your Google account.",
  gmailInstallStepTwo: "Open an email in Gmail™ and choose Co-parenting.",
  gmailInstallPlatforms: "One installation works in Gmail™ on computer, Android, and iPhone.",
  gmailConnectedDate: (date: string) => `connected ${date}`,
  gmailDisconnect: "Disconnect Gmail™",
  gmailDisconnectConfirmation: (email: string) => `Disconnect ${email}? Emails can no longer be added from this Gmail™ account.`,
  gmailConnectionStopped: "This connection stopped because the private email access was revoked.",
  gmailReconnect: "Reconnect in Gmail™",
  gmailReconnectInstructions: "Open an email in Gmail™, select Co-parenting, and tap Connect.",
  gmailSettingsOffline: "You appear to be offline. Check your connection and try again.",
  gmailSettingsUnauthorized: "Your session has expired. Sign in again to manage Gmail™.",
  gmailSettingsError: "We couldn’t load Gmail™ connections. Try again.",
  gmailDisconnectError: "We couldn’t disconnect Gmail™. Try again.",
  gmailDisconnecting: "Disconnecting…",
  gmailDisconnectRetry: "Try disconnecting again",
  gmailInstallationUnavailable: "The Gmail™ add-on installation link is not available here yet. If you have already installed the add-on, open an email in Gmail™, select Co-parenting, and tap Connect.",

  // Gmail add-on connection confirmation
  gmailConnectHeading: "Connect Gmail™",
  gmailConnectQuestion: (email: string, family: string) => `Connect ${email} to the ${family}?`,
  gmailConnectExplanation: "This lets you send an open email from Gmail™ to Co-parenting for event suggestions.",
  gmailChooseFamily: "Choose which family or calendar should receive suggestions.",
  gmailFamilyLegend: "Family or calendar",
  gmailConnectButton: "Connect",
  gmailCheckingLink: "Checking the connection link…",
  gmailConnectedHeading: "Gmail™ connected",
  gmailConnectedText: (email: string, family: string) => `${email} is connected to ${family}. Choose Return to Gmail™ to close this window and refresh the add-on. If the add-on still asks you to connect, click Refresh.`,
  gmailReturnToGmail: "Return to Gmail™",
  gmailCloseFallback: "If this window does not close automatically, close it and return to Gmail™.",
  gmailCancelledHeading: "Connection canceled",
  gmailCancelledText: "No changes were made. You can close this window and return to Gmail™.",
  gmailLinkExpired: "This connection link has expired. Return to Gmail™ and tap Connect again.",
  gmailAccountConflict: "This Gmail™ account is already connected. Disconnect it in Co-parenting settings first, then try again.",
  gmailNoAuthorizedFamilies: "You don’t have an authorized family yet. Create or join a family in Family settings, then return here and try again.",
  gmailOpenFamilySetup: "Open family setup",
  gmailOfflineError: "You appear to be offline. Check your connection and try again.",
  gmailServerError: "We couldn’t connect Gmail™ right now. Try again.",
  showLocalCal: "Show calendars from the phone",
  addChild: "Add a Child",
  addViewer: "Add an Adult",
  addParent: "Add a Parent",
  addUserName: (name:string) => "Are you sure you wan to add "+name+" as a member of this group?",
  addUser: "Add member",

  // COPPA - the invite is blocked from US time zones unless the child is provably 13
  coppaInviteBlockedTitle: "This invitation cannot be sent",
  coppaInviteBlockedLaw: "COPPA, the U.S. Children's Online Privacy Protection Act, protects children under the age of 13. A child under 13 therefore cannot be invited to an account of their own on this service.",
  coppaInviteBlockedNextStep: (name: string) => `${name} stays in the group and you can keep planning the schedule exactly as before. You can send an invitation once ${name} turns 13.`,
  coppaInviteBlockedUnknownAge: (name: string) => `There is no year of birth on record for ${name}, so we cannot establish that they are 13 or older. ${name} stays in the group and you can keep planning the schedule exactly as before.`,
  coppaInviteBlockedTheChild: "The child",

  addUserAsView: (name:string) => "+"+name+" as a member",
  extendedFamily: "Extended Family",
  logout: "Logout",
  createNewFamily: "Create one more group",
  newGroup:"New group",
  switchGroup: "Switch Group",
  deleteGroup: "Delete group",
  deleteGroupTitle: "Delete group?",
  deleteGroupWarning: (name: string) => `${name} will be removed from your account and you will switch to one of your other groups. This cannot be undone.`,
  deleteGroupFailed: "The group could not be deleted. Please try again.",
  groupDeleted: (name: string) => `${name} was deleted`,
  createNewFamilyInfo: "If you have children with another parent (separated or not) you can create another group and invite them to that group.",
    createNewFamilyInfo1: "After you create a new group, you can switch groups in the dropdown that appears.",
  createNewFamilyName: "Name of group",
  seperated: "Live apart",
  synchCal: "Export calendar",
  importExportCal: "Import / Export",
  missingTitle: "Missing title",

  role: (role: FamilyMemberType): string => {
    switch (role) {
      case FamilyMemberType.CHILD:
        return "Child";
      case FamilyMemberType.DELETED:
        return "Deleted";
      case FamilyMemberType.EXPERT:
        return "Expert";
      case FamilyMemberType.MODERATOR:
        return "Admin";
      case FamilyMemberType.PARENT:
        return "Parent";
      case FamilyMemberType.VIEWER:
        return "Important adult";
      default:
        return "Unknown";
    }
  },

  implement: "Under development",

  // erase account
  eraseAccountSure: "Are you sure you want to erase your account?",
  eraseAccountSurePt2: "Please notice that any active subscriptions you have bought are cancelled in the settings on your phone and not in this app.",
  eraseAccountYes: "ERASE my account",

  toxicSheetTitle: 'This message may come across as rude',
  toxicSheetInfo: (link: (text: string) => React.ReactNode) =>
    <>Messages like this are often harmful and can {link('affect your child negatively')}.</>,
  toxicSheetBlockedTitle: 'This message cannot be sent',
  toxicSheetBlockedInfo: (link: (text: string) => React.ReactNode) =>
    <>It is too hostile, and toxic communication between parents {link('affects children negatively')}.</>,
  toxicSheetArticleLink: 'https://www.co-parenting.app/article/how-toxic-messages-to-your-co-parent-affect-your-child/',
  toxicSheetAiSuggestion: 'AI suggestion:',
  toxicSheetNoSuggestion: 'The AI could not suggest another way to write this.',
  toxicSheetUseSuggestion: 'Use suggestion',
  toxicSheetEditMyself: 'Edit it myself',
  toxicSheetSendAnyway: 'Send anyway',
  toxicSheetDelete: 'Delete message',

  // Family Settings
  locationAndTimezone: "Holidays and time-zone",


  settingsUpdateFamilyMemberName: (name: string) => `Update ${name}`,
  settingsUserStatusInvited: (email: string, date: string) => `Has never logged in, invited ${email} ${date}`,
  settingUserStatusNotInvited: "Is not invited yet",
  settingUserStatusLastSeen: (date: string) => `Last seen ${date}`,
  settingUserStatusOnline: "Online",
  restoreAccount: "Restore account",
  restoreAccountDeletedHelper: "the user has deleted their account. You can send a restore link here.",
  restoreAccountInstructionsSent: "instructions on how to restore the account has been sent to the user",
  nudgeToLogIn: "Assist to log in",
  nudgeToLogInInstructionsSent: "Instructions how to log in has been sent to the user",
  limitedAccess: "Limited access",
  limitAccess: "Limit access",
  unlimitAccess: "Remove limit",
  limitAccessWarning: (name: string) => `${name} can still see everything shared, but can no longer send messages or create/modify anything. You can remove the limit at any time.`,
  deleteChildWarningTitle: "Do you really want to delete the child?",
  deleteChildWarning: (name: string) => `If you delete ${name} from the group, much of the functionality for the child disappears, such as custody schedules and child info.`,
  deleteChildWarningNotUser: "A child being in the group does not mean the child is a user of the app.",
  deleteChildWarningOnlyIf: "Only delete children that were added by mistake or that are not shared children.",
  settingsPickImage: "Pick image",
  settingsAdjustImage: "Adjust image",
  settingsColorChoice : "Colorchanges are only visible for you",

 

  // Cookie Banner

  // Settings export
  selectWhatToExportDetail: `Select if events, calendars and To-Dos should be exported.`,
  settingsExportCalendar: "Which schedules do you want to show?",

  settingsExportAppleDevice: "Your phone",
  settingsExportAppleGmail: "Google Calendar / Gmail",
  settingsExportOutlookOnline: "Outlook online, Hotmail, Live",
  settingsExportOutlook: "Program on the computer e.g. Outlook",
  settingsExportInfoLinkManuel: "For other calendars not listed above it is often possible to import a calendar. You should then import the following url:",
  settingsExportDelayInfo: "It may take some time for changes to be reflected in your calendar. Unfortunately, this is decided by your calendar and nothing we can control.",


  settingsImportComputer: "We can currently only sync calendars via the app on your phone, not via the web version.",
  settingsImportInfo: "No information is shared to other people in the group. If you want to share a calendar you must use the 'import calendar URL' in the menu",

  settingsSubscriptionsHeader : "Subscription",

  // Calendar
  calFullDay: "All day",
  calenderPublicHolidays: 'Public Holidays',

  // New calendar onboarding
  newCalendarChildrenTitle: "Exchange days",
  newCalendarChildrenMainText: "Add your exhange days by creating a schedule. You can always make a new or make changes to it later.",
  newCalendarSureCancel: "Are you sure? Much of the functionality (packinglist etc) requires there is a schedule set up. You can always change the schedule in the future if it changes.",
  newCalendarChildrenSubTitle: "The schedule is for",
  newCalendarStartDateTitle: "Choose start date for schedule",
  newCalendarEndDateTitle: "Choose end date for schedule",
  newCalendarTemplateTitle: "Templates",
  newCalendarTemplateCustomTitle: "Make your custom template",
  newCalendarTemplateCustomSubtitle: "Set what nights the child sleeps where.",
  newCalendarRepeat: "After how many weeks do the schedules repeat itself?",
  newCalendarTemplateSubTitle:<span>Pick the template that fit the best with your exhange days (as present or future)! <b>Scroll for more options.</b> . If no option matches your set-up, pick "Custom"</span>,
  newCalendarAdjustSubTitle: "Adjust exchange days earlier or later by pressing \"",
  newCalendarHandoverTitle: "Where and when is the exchange?",

  newCalendarWithParent: (parentName: string) => `With ${parentName}`,
  newCalendarWhereIsHandover: (parent: string, date: string) =>
    <>Choose the place and time when {parent} will take over the responsibility on {date}.</>,

  calendarTemplateName : (template : TemplateName):string => {
    if (template === TemplateName.ALTERNATING_WEEKS ) {return "Alternating Weeks";}
    else if (template === TemplateName.T3443 ) {return "3, 4, 4, 3";}
    else if (template === TemplateName.T223 ) {return "2, 2, 3";}
    else if (template === TemplateName.T255 ) {return "2, 2, 5, 5";}
    else if (template === TemplateName.T3NIGHTSPW ) {return "3 nights per week";}
    else if (template === TemplateName.T2NIGHTSNPW ) {return "2 nights per week";}
    else if (template === TemplateName.T6NIGHTS8NIGHTS ) {return "6 nights every other week";}
    else if (template === TemplateName.T5NIGHTS9NIGHTS ) {return "5 nights every other week";}
    else if (template === TemplateName.T4NIGHTS10NIGHTS ) {return "4 nights every other week";}
    else if (template === TemplateName.T3NIGHTS11NIGHTS ) {return "3 nights every other week";}
    else if (template === TemplateName.T2NIGHTS12NIGHTS ) {return "2 nights every other week";}
    else if (template === TemplateName.TDOUBLEWEEK ) {return "2 Week shifts";}
    else if (template === TemplateName.TTENELEVEN ) {return "10, 11, 11, 10";}
    else if (template === TemplateName.CUSTOM ) {return "Custom";}
    else {return "Okänt";}
  },

 

  // CalendarTemplates Error
  CalendarTemplatesErrorChildren: "Please, select at least one child",
  CalendarTemplatesErrorTemplate: "Please, select a template",
  CalendarTemplatesErrorHandover: "All cards must be filled with relevant data",

  // New calendar onboarding buttons
  newCalendarTwoParents: "To set up a schedule there has to be two parents and at least one child in the family. Add family members under settings.",
  newCalendar: "New schedule",


  // calendar status description


  // Event
  unseenEvent : "New event",
  eventYearly: "Yearly",
  eventMonthly: "Monthly",
  event4Weeks: "4 weeks",
  eventBiWeekly: "Bi-Weekly",
  eventDescriptionOptional: "Description (optional)",
  eventLastOccurence: "Last occurence",
  eventOccurences: "Occurences",
  eventReoccuring: "Reoccuring",
  eventStart: "Start",
  eventEnd: "End",

  eventWeekly: "Weekly",
  eventRecentActionUnknown: " Unknown Action",
  eventRecentActionAgreementResponded: (action: number) => ` responded to a future purchase #${action}`,
  eventRecentActionAgreementSuggested: (action: number) => ` suggested a new future purchase #${action}`,
  eventRecentActionFamilyCreated: " created this family",
  eventRecentActionFamilyMemberCreate: (action: string) => ` added ${action}`,
  eventRecentActionFamilyMemberDelete: (action: string) => ` deleted ${action}`,
  eventRecentActionFamilyMemberInvite: (action: string) => ` invited ${action}`,
  eventRecentActionFamilyMemberModify: (action: string) => ` modified ${action}`,
  eventRecentActionHolidaysScheduleUpdated: " updated Holidays",
  eventRecentActionScheduleShare: " updated a schedule",
  eventRecentActionSchooldaysScheduleUpdated: " updated Schooldays",
  eventRecentActionSuggestionAccepted: (action: number) => ` accepted schedule change #${action}`,
  eventRecentActionSuggestionCreated: (action: number) => ` suggested schedule change #${action}`,
  eventRecentActionSuggestionRejected: (action: number) => ` rejected schedule change #${action}`,
  eventRecentActionEventCreated: (action: string) => ` created event ${action}`,
  eventRecentActionEventGroupCreated: (action: string) => ` created event ${action}`,
  eventRecentActionEventModified: (action: string) => ` modified event ${action}`,
  eventRecentActionEventGroupModified: (action: string) => ` modified event ${action}`,
  eventRecentActionEventDeleted: (action: string) => ` deleted event ${action}`,
  eventRecentActionEventGroupDeleted: (action: string) => ` deleted event ${action}`,
  eventRecentActionTodoCreated: (action: string) => ` created task ${action}`,
  eventRecentActionTodoModified: (action: string) => ` modified task ${action}`,
  eventRecentActionTodoDeleted: (action: string) => ` completed task ${action}`,
  shareFutureEvents: "Share events?",
  shareEventWithImportantAdult: "Would you like to share existing event with ",
  // handover editor

  handoverLocationLabel: "Location",




  // schedule selector

  selectedAsActiveBy: (names: string) => `Set as active by ${names}`,
  selectedAsActiveByExluding: (names: string) => `, but not by ${names}`,
  scheduleUsingDifferent: "You are using different schedules!",
  scheduleUsingDifferentUses: " use: ",


  // schedule selector page
  scheduleNamePlaceholder: "Schedule name",
  renameSchedule: "Rename Schedule",
  calendarLayout: "Calendar Layout",
 
  scheduleShowWeeks: "Show weeks number",
  scheduleShowOnlyMyWeeks: "Show only my weeks",
  scheduleShowOnlyWeeksOf: (name:string) => `Show only ${name}'s weeks`,
  scheduleShowOnlyMyWeeksQuestion: "To make the overview clearer, do you want to show only your own weeks? (you can change it back in the menu if you want)",
  scheduleShowActivities : "Show activities",


  // Schedule
  schedulePickup: "Handover",


  handoverExplain1 : "The handover on ",
  handoverExplain2 : " happens ",


  schedulePickupSchool: (school:SCHOOL_TYPES|undefined, age:number):string =>
    isPreschool(school, age) ? "through preschool" : "through school",
  scheduleDropoffSchool: (school:SCHOOL_TYPES|undefined, age:number):string =>
    isPreschool(school, age) ? "through preschool" : "through school",


  scheduleShared: (name: string) => `${name} shared the schedule`,

  suggestionName: (id: number) => `Suggestion #${id}`,
  scheduleName: (id: number) => `Parenting schedule #${id}`,
  scheduleNameNew: (schedule: ISchedule | undefined) => schedule ? (schedule.name ? schedule.name : `Schedule #${schedule.id}`) : `Unknown Schedule`,

  
  // Password
  magicTokenTitle: "A link has been sent that will grant you access. Check your email!",
  magicTokenBody: "Enter the email you use to log in and we will send you a magic link",
  invalidMagicToken: "You have to use a VALID magic token!",
  submitMagicLink: "Send me the magic link",
  openApp: "Open mail-app",
  alreadyLoggedInTitle: "You are already logged in",
  alreadyLoggedInLinkBody: "You can't use this link because you are already logged in. Log out first in Settings.",


  // Economy
  economyDone: 'Bought',
  economyAgree: 'Planning',

  transfer: 'Transfer',
  purchase: 'Purchase',
  purchaseNew: 'New purchase',
  purchaseDone: 'Register completed purchase',
  purchaseDoneClosed: 'Closed purchase',
  purchaseEdit: 'Edit purchase',
  purchaseEditNotMine: 'Question purchase',
  purchaseRegardingTitle: (item: string) => `Regarding purchase ${item}`,
  agreementRegardingTitle: (item: string) => `Regarding planned purchase ${item}`,
  transferRegardingTitle: (sum: string, date: string) => `Regarding transfer of ${sum} on the ${date}`,
  purchaseEditSubtitle: (name: string) => `Registered by ${name}`,

  purchaseProposalNew: 'Purchase proposal',
  purchaseRecurringNew: 'Register planned purchase',
  purchaseProposalEdit: 'Edit Proposal',
  purchaseProposalClosed: 'Closed Propsal',
  purchaseProposalDeleted: 'Erased Proposal',

  purchaseTransferNew: 'Register Transfer',
  purchaseTransferEdit: 'Edit Transfer',
  purchaseTransferEditNotMine: 'Question Transfer',
  purchaseTransferDeleted: 'Deleted Transfer',

  purchaseTransferAccountShared: 'Shared account',

  confirmRepeatingDelete: "Delete recurring purchase",
  confirmRepeatingDeleteThis: "This purchase",
  confirmRepeatingDeleteThisOne: "Erase",
  confirmRepeatingDeleteFuture: "This and future purchases",

  agreementForWho: 'For',
  agreementNoPrice: 'unspecified',
  agreementPaysAll: (name: string) => `${name} pays all`,
  agreementMyPart: (andel: number) => `My share ${andel}%`,
  agreementEstimatePrice: 'Estimate price',
  agreementMyPartSet: 'My share',
  agreementCoparentPart: (name: string) => `${name}s share`,
  agreementSplitQuestion: 'How should the cost be split?',
  agreementResponsible: 'Responsible for purchase',
  agreementTooltipHelp: 'Click here when you want to book the cost after making the purchase.',

  agreGuideTitle : "Quick Guide",
  agreGuide : <span>You will get suggestions of expenses that are commonly shared. Write the total cost of the post. <br/><br/>You can always adjust or add price at a later time if you are unsure what it is right now.</span>,
  agreGuideDone : <span>Well done, youre done!</span>,
  agreGuideInsurance : (name:string) => "Insurance for "+name,
  agreGuideInsuranceDesc : (name:string) => "Insurance "+name,
  agreGuidePocketmoney : (name:string) => "Pocket money for "+name,
  agreGuidePocketmoneyDesc : (name:string) => "Pocket money "+name,
  agreGuidePhone : (name:string) => name+"s phone costs per month",
  agreGuidePhoneDesc : (name:string) => "Phone "+name,
  agreGuideKindergarten : (name:string) => "Kindergarten "+name,
  agreGuideKindergartenDesc : (name:string) => "Kindergarten "+name,
  agreGuideSchool : (name:string) => "School tuiton / after school fee per month "+name,
  agreGuideSchoolDesc : (name:string) => "Tuition "+name,
  agreGuideTransport : (name:string) => "Travelpass or travel expenses per month for "+name,
  agreGuideTransportDesc : (name:string) => "Travel expenses "+name,
  agreGuideActivity : (name:string) => "Extra curricular activitie for "+name+" (only add one if there are several)",
  agreGuideActivityMore : (name:string) => "Does "+name+" have more extra curricular activities?",
  agreGuideStream : (mult:boolean) => "Does "+(mult?"the kids":"your child")+" have any streaming service you want to share the cost for?",
  agreGuideStreamMore : "More streaming services?",

  ecoSuggestion : "Suggestion",
  ecoRecurring : "Recurring",


  ecoBalanceRegister: <>Register<br />transfer</>,
  ecoBalanceSettings: 'Economy settings',
  ecoExportEmailQueued: 'Your economy PDF will be delivered to your email within a minute.',
  ecoExportOffline: 'Connect to the internet and try again.',
  ecoBalancePaymentMethod: "Select Payment Method",
  ecoBalanceCurrency: 'Currency',
  ecoBalanceSplit: 'Standard split',
  ecoBalanceHistory: 'Show split history',

  ecoBalanceMonth: 'Balance month:',
  ecoBalanceTotalSpent: (month: string) => `Total spent ${month}:`,
  ecoNotIncluded: 'Not included',
  ecoDeletedByCreator: 'Deleted',
  ecoDeclinedToShare: "Doesn't want to share this cost",
  ecoRestore: 'Restore',

  ecoTransferBooking : 'Registration month',
  ecoTransferMethod: 'Transfer method',
  ecoPrivateAcc: 'Private account',
  ecoSharedAcc: 'Shared account',
  ecoPaidBy: 'Who paid for it?',

  ecoComeBack : "Come back and confirm the transfer when you're done",



  ecoRecentActionPurchaseCreated: (purchaseTitle: string) => `created a purchase ${purchaseTitle}`,
  ecoRecentActionPurchaseChanged: (purchaseTitle: string) => `changed a purchase ${purchaseTitle}`,
  ecoRecentActionNewTransferCreated: (sum: number, currency: string) => `registered a transfer of ${sum} ${currency}`,
  


  ecoTransferTitle: (doneTo: IFamilyMember | undefined, doneBy: IFamilyMember | undefined) => `Transfer ${doneBy ? "" : "from shared account"} to ${doneTo ? doneTo.firstName : "shared account"}`,

  ecoYouOrName: (paidBy: number, userId: number, family: IFamilyMember[]) => `${paidBy === userId ? "You" : TranslateNew.getInstance().familyMemberName(paidBy, family)}`,
  ecoPurchaseSubtitle: (myPercentage: number, amount: number, currency: string) => `${myPercentage}% of ${amount} ${currency}.`,
  ecoExplainFromSharedAccountNormalPurchase: (myPercentage: number, myPartInSharedAccount: number, paidBy: number, userId: number, family: IFamilyMember[], amount: number) => `${engelska.ecoYouOrName(paidBy, userId, family)} paid ${amount} from your shared account. Your part to pay of this purchase was ${myPercentage}%. As ${myPartInSharedAccount}% of the money on the shared account was put there by you, this purchase does not affect the balance between you and your coparent.`,
  ecoExplainFromSharedAccountNOTNormalPurchase: (myPercentage: number, myPartInSharedAccount: number, paidBy: number, userId: number, family: IFamilyMember[], amount: number, balance: number, currency: string) => `${engelska.ecoYouOrName(paidBy, userId, family)} paid ${amount} from your shared account. Your part to pay of this purchase was ${myPercentage}%. As ${myPartInSharedAccount}% of the money on the shared account was put there by you, You ${balance > 0 ? "will get reimbursed" : "have to pay"} ${Math.abs(balance)} ${currency} (${Math.abs(myPartInSharedAccount - myPercentage)}% of ${amount}).`,
  ecoExplainFromMyPrivateAccountPurchase: (myPercentage: number, amount: number, balance: number, currency: string, howMuchIShouldPay: number) => `You paid ${amount} ${currency} from your private account. Your share to pay is ${howMuchIShouldPay} ${currency} (${myPercentage}% of ${amount}). Hence you should be reimbursed for ${balance} ${currency} (${amount} - ${howMuchIShouldPay}).`,
  ecoExplainFromCoparentPrivateAccountPurchase: (paidBy: number, family: IFamilyMember[], myPercentage: number, amount: number, currency: string, howMuchIShouldPay: number) => `${TranslateNew.getInstance().familyMemberName(paidBy, family)} paid ${amount} ${currency} from their private account. Your share to pay is ${howMuchIShouldPay} ${currency} (${myPercentage}% of ${amount}).`,

  ecoExplainTransfer: (to: number, from: number, family: IFamilyMember[], sum: number, currency: string) => `${TranslateNew.getInstance().familyMemberName(from, family)} transferred ${sum} ${currency} to ${TranslateNew.getInstance().familyMemberName(to, family)}.`,
  ecoExplainTransferSharedToShared: `A transfer from one shared account to another shared account has no effect on the balance.`,
  ecoExplainTransferToShared: (otherParentId: number, from: number, fromPercentage: number, family: IFamilyMember[], sum: number, currency: string) => `${TranslateNew.getInstance().familyMemberName(from, family)} transferred ${sum} ${currency} to a shared account. As ${TranslateNew.getInstance().familyMemberName(from, family)} should pay ${fromPercentage}% of all the costs ${TranslateNew.getInstance().familyMemberName(otherParentId, family)} would have to reimburse ${TranslateNew.getInstance().familyMemberName(from, family)} with ${Math.floor((100 - fromPercentage) * sum) / 100} ${currency} (${(100 - fromPercentage)}% of ${sum}).`,
  ecoExplainTransferFromShared: (to: number, toPercentage: number, otherParentId: number, family: IFamilyMember[], sum: number, currency: string) => `${TranslateNew.getInstance().familyMemberName(to, family)} transferred ${sum} ${currency} from a shared account to a private one. As ${TranslateNew.getInstance().familyMemberName(to, family)} has transferred ${toPercentage}% of the money to the shared account, ${Math.floor((100 - toPercentage) * sum) / 100} ${currency} belongs to ${TranslateNew.getInstance().familyMemberName(otherParentId, family)} (${(100 - toPercentage)}% of ${sum}).`,


  repeatSubtitle: (option: string): string => {
    switch (option) {
      case EcoRepeat.ONCE:
        return "One time purchase";
      case EcoRepeat.WEEKLY:
        return "Repeating weekly";
      case EcoRepeat.MONTHLY:
        return "Repeating monthly";
      case EcoRepeat.QUARTERLY:
        return "Repeating quarterly";
      case EcoRepeat.YEARLY:
        return "Repeating annually";
      case EcoRepeat.TERM:
        return "Repeating per term";
        default:
        return "Unknown";
    }
  },

  repeatOption: (option: string): string => {
    switch (option) {
      case EcoRepeat.ONCE:
        return "No repeat";
      case EcoRepeat.WEEKLY:
        return "Weekly";
      case EcoRepeat.MONTHLY:
        return "Monthly";
      case EcoRepeat.QUARTERLY:
        return "Quarterly";
      case EcoRepeat.YEARLY:
        return "Yearly";
      case EcoRepeat.TERM:
        return "Per Term";
        default:
        return "Unknown";
    }
  },

  transferOption: (option: EcoTransferMethod): string => {
    switch (option) {
      case EcoTransferMethod.BANK:
        return "Bank";
      case EcoTransferMethod.CASH:
        return "Cash";
      case EcoTransferMethod.SWISH:
        return "Swish";
      case EcoTransferMethod.OTHER:
        return "Other";
      case EcoTransferMethod.CASHAPP:
        return "CashApp";
      case EcoTransferMethod.PAYPAL:
        return "PayPal";
      case EcoTransferMethod.VENMO:
        return "Venmo";
      default:
        return "Unknown";
    }
  },

  repeatEventOption: (option: string): string => {
    switch (option) {
      case REPEATABLE.ONCE:
        return "Once";
      case REPEATABLE.WEEKLY:
        return "Weekly";
      case REPEATABLE.BI_WEEKLY:
        return "Bi-weekly";
      default:
        return "Unknown";
    }
  },

  disputedTransactions: 'Questioned transactions',
  disputedTransactionsByMe: 'Questioned by me',
  purchaseProposalReceived: 'Purchase proposals received',
  purchaseProposalSent: 'Purchase proposals sent',
  balanceThisMonth: 'Balance this month (',
  balancePrevious: 'Balance from previous months',
  totalBalance: 'Total Balance',
  totalBalanceGet: 'You should get',
  totalBalancePay: 'You should pay',
  totalBalanceGetSharedAlternative: (balance:string, sharedTransfer:string, coparentName:string) =>
    `You should get ${balance} or ${coparentName} should transfer ${sharedTransfer} to shared account`,
  totalBalancePaySharedAlternative: (balance:string, sharedTransfer:string) =>
    `You should pay ${balance} or you should transfer ${sharedTransfer} to shared account`,
  upcomingPurchases: 'To buy',
  upcomingPurchasesNonUrgent: 'To buy next month',
  repeat: 'Repeat',
  agreementSeenBy: 'Seen by',
  rejectPendingAgreement: (agreement: string) => `Change for ${agreement} was rejected.`,
  rejectAgreement: (agreement: string) => `Suggestion ${agreement} was rejected.`,
  deletePendingAgreement: (agreement: string) => `Change for ${agreement} was deleted.`,
  deleteAgreement: (agreement: string) => `Suggestion ${agreement} was deleted.`,
  unseenPurchase: (purchase: string) => `Unseen purchase: ${purchase}.`,
  deletedPurchase: (purchase: string) => `Purchase ${purchase} was removed.`,
  unseenTransfer: (transfer: string) => `Unseen transfer ${transfer}.`,
  deletedTransfer: (transfer: string) => `Deleted transfer ${transfer}.`,


// economy help
ecoSuggHelp1: 'Here you can create a suggestion to buy or a recurring cost.',
ecoSuggHelp2: 'Suggestions can be one-time purchases or recurring purchases (such as subscription!).',
ecoSuggHelp3: 'Only parents see the Economy section.',

ecoDoneHelp1: 'All purchases and transfers you do are shown here. Only parents can see the economy.',
ecoRememberMark: "Don't forget to go back to the app and mark the transfer as completed when you're done.",


 // Cash App
 ecoCashAppSendMoney: "Send money via Cash App",
 ecoCashAppCashTagOne: "$Cashtag",
 ecoCashAppCashTagTwo: "Recipient $Cashtag",
 ecoCashAppAmount: "Amount",

  // Venmo
  ecoVenmoSendMoney: "Send money via Venmo",
  ecoVenmoOne: "Venmo",
  ecoVenmoRecieverInfo: "Recipient's Venmo",
  ecoVenmoPlaceholder: "Email, phone number, or username",
  ecoVenmoReciever: "Recipient",
  ecoVenmoNote: "Payment note",
  ecoVenmoVisibility: "Visibility",
  ecoVenmoPrivate: "Private",
  ecoVenmoPublic: "Public",
  ecoVenmoFriends: "Friends",


  // Paypal

  ecoPayPalSendMoney: "Send money via PayPal",
  ecoPayPalName: "PayPal",
  ecoPayPalAmount: "Amount",

  // onboarding controller


  onbBtnChooseLater: "We have no schedule",
  onbBtnMaybeLater: "Maybe later",
  onBCreateSchedule : "Create schedule",


  onbNotiTitle: "Don't miss anything!",
  onbNotiText: "Say yes to notifications so you always keep track of exchange days, activites and more!",
  onbNotiBtnYes: "Yes, please!",
  notificationPermissionSettingsMessage: "Notifications are disabled. Enable them in Android settings to receive reminders.",

  onbCoparentTitle: "What is the name of the other parent?",
  onbExistingAccount: "Existing account",
  onbCoparentText: "No messages are sent to them right now.",

  onbChildTitle: "What is the name of your children?",

  onbSyncTitle: "Sync? Yes!",
  onbSyncText: "If you sync the app with your phone calendar, you can easily keep track of everything - wherever you want!",
  onbSyncBtnAgree: "Sync to my calendar",
  onbSyncBtnTextDone: "Synced! next step",

  onbStartFree : "Start free trial",
  onbStartFreeAfter : "Then ",

  onbSubscriptionTitle: "Build a strong co-parenting team today",
  onbSubscibeBeneficiary: (days: number, benefactor:string) => <span>{`You have received a free period of ${days} days from `}<b>{benefactor}</b>{` so you do not have to start any subscription.`}</span>,




  onboardindCompletedTitle: "Let's go!",
  onboardindCompletedContent: <>
    A tip is to directly enter activities in the calendar.<br/><br/>
    There you will also find the packing list  - a fantastic tools to never miss an item!
  </>,
  onboardingCompletedButton: "to overview",

  // onboardingSteps
  onbScheduleShareText: (name: string | undefined) => <>Together with activities, the packing list and shared notes, your collaboration will flow more smoothly than before. At least that's what 90% of our users say!</>,

  onbScheduleCreated: "Your schedule is ready!",
  onbScheduleShare: "Ok",

    // Subscription
  subscriptionTitle: "Your trial",
  subscriptionSubTitleMonth: (daysFree:number, monthCost:string) => daysFree > 0?<>{`First ${daysFree} days free, `}<wbr/>{`then ${monthCost} per month`}</>:<>{`The subscription is ${monthCost} per month.`}</>,
  subscriptionSubTitleYear: (daysFree:number, monthCost:string, annualCost:string):string => "First ",
  subscriptionBuy:(daysFree:number):string => daysFree > 0?"Try now for free":"Subscribe",
  subscriptionInvitedFree : "The app is free for everyone you invite.",
  subscriptionStepOne: "Unlock access to all features and start building a strong co-parenting team.",
  subscriptionStepTitle: (daysOfTrial:number):string => `In ${daysOfTrial} days`,
  subscriptionStepTwo: "Get a notification to remind you when the trial ends",
  subscriptionStepThree: "Subscription starts. Cancel anytime before.",

  subscriptionWeb: "You need to start a subscription in the app. You then have access to the web-app if you want.",
  subscriptionStoreUnavailable: (storeName: string): string =>
    `The app could not connect to ${storeName}, so a subscription cannot be started right now. Check your internet connection and restart the app.`,
  subscriptionPurchaseFailedTitle: "The subscription could not be started",
  subscriptionPurchasesRestricted: "In-app purchases are turned off on this iPhone. Open Settings → Screen Time → Content & Privacy Restrictions and allow In-app Purchases. If the phone is managed, for example by an employer, you may need to ask them.",
  subscriptionAppStoreFailed: "The App Store could not complete the purchase. Check that your Apple Account has a working payment method (Settings → your name → Payment & Shipping) and try again.",
  subscriptionGooglePlayFailed: "Google Play could not start the purchase. Make sure the Play Store app is up to date, that you are signed in with your Google account, and that your payment method works (Play Store → your profile picture → Payments & subscriptions). Then try again.",
  subscriptionPurchaseFailed: "The purchase could not be completed. Please try again.",
  subscriptionContactSupport: "Still not working? Email us and we will help you:",
  subscriptionSupportEmail: "hello@co-parenting.app",

  // moment locale
  momentFromNow: (time: number): string => {
    const diff = Math.floor((time - Date.now()) / 1000); // positive = future, negative = past
    const absDiff = Math.abs(diff);

    if (absDiff < 60) return diff >= 0 ? "in a moment" : "just now";
    if (absDiff < 3600) {
      const mins = Math.floor(absDiff / 60);
      return diff >= 0 ? `in ${mins} min` : `${mins} min ago`;
    }
    if (absDiff < 86400) {
      const hours = Math.floor(absDiff / 3600);
      return diff >= 0 ? `in ${hours} h` : `${hours} h ago`;
    }
    const days = Math.floor(absDiff / 86400);
    return diff >= 0 ? `in ${days} days` : `${days} days ago`;
  },

  momentNewEvent: (time:number):string => {
    const d=new Date(time);
    const m=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    return `${m[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
  },

  // Privacy Policy
  privacyPolicyShort: 'Terms & privacy policy',
  privacyPolicyTitle: 'Varannan Vecka’s privacy policy',
  privacyPolicyContent: <>
    <h3>We care about your integrity ❤️!</h3>
    <h3>1. General</h3>
    <p>
      We at Happy Parents AB (“Happy Parents”, “Varannan Vecka” or “we”) are very happy for your interest in using
      our
      service Varannan Vecka (the “Service”). Data protection and the security of your data are of the highest
      priority for us.
      This privacy and cookie policy explain which data we collect about you and how it is processed and shared,
      the measures
      we have taken to keep your data secure, and how we use cookies. We also describe what rights you have
      regarding your
      personal data.
    </p>
    <p>
      When you use or register on varannanvecka.app, including its associated sites (jointly the “Website”), or
      otherwise
      interact with us, for example through the Service, you acknowledge that you understand that we collect,
      retain, and use
      your personal data in accordance with this Privacy Policy.
    </p>
    <p>
      <strong>
        A user's name, e-mail, profile picture, gender identity, age, or other personal information will never
        be shown
        publicly to others than to the user's “extended family” (those invited to the service to collaborate
        together).
      </strong>
    </p>

    <h3>2. Who we are</h3>
    <p>
      We are Happy Parents AB, company registration no. 559197-1717, Alströmmergatan 22, 112 47 Stockholm. You can
      reach us by
      telephone at +46 (0)707 61 72 92 or by e-mail at hello@varannanvecka.app. We are the data controller for the
      processing
      of your personal data.
    </p>
    <p>
      We trust that this Privacy Policy answers your questions about our collection, use, protection, and
      disclosure of your
      personal data. If you have additional questions, please contact us at the address, e-mail address, or
      telephone number
      provided above.
    </p>

    <h3>3. Amendments</h3>
    <p>
      We may amend this Privacy Policy from time to time. If we do so, the amended Privacy Policy will enter into
      force when
      we publish it on the Website. If we make significant changes, we will inform you based on what is
      appropriate regarding
      the circumstances, such as through an announcement by e-mail or as a notice in our system. The latest date
      of amendment
      is stated at the bottom of the Privacy Policy.
    </p>
    <p>
      If any amendment makes the Privacy Policy less protective of your personal data, such amendment will not
      apply to data
      we collected about you before the amendment was made. The amendment will, however, apply to such data if you
      provide
      your consent to the new version of the Privacy Policy or if you provide new information or restate the same
      information
      after the entry into force of the amendment.
    </p>

    <h3>4. Collection</h3>

    <h4>4.1 What information we collect</h4>
    <p>
      We collect the personal data that has been provided by you or collected on the Website through our use of
      cookies. The
      personal data we process consists of the following:
    </p>
    <ul>
      <li>Registration</li>
    </ul>
    <p>
      When you register at Varannan Vecka, we ask you to state your email and password, or register using a
      third-party
      registration such as Facebook or Google. If so, we collect the email and name provided by that service. We
      may verify
      your registration by a second factor authentication, such as through your mobile telephone number.
    </p>
    <ul>
      <li>User</li>
    </ul>
    <p>
      When you create your profile, we ask you for different kinds of personal data regarding who you are and your
      family. We
      also store the location based on your IP to find out what public holidays and vacations apply to your
      child’s school.
    </p>
    <ul>
      <li>Uploaded and data created by you</li>
    </ul>
    <p>We collect data from you when you enter or upload data through forms on our website, private chat
      messages/attachments.</p>
    <ul>
      <li>Information from others</li>
    </ul>
    <p>
      Other users may invite you to the system both as a Parent or as a Child or other family member. We collect
      the
      information provided, including name and e-mail.
    </p>
    <ul>
      <li>Collection of general and statistical data</li>
    </ul>
    <ul>
      <li>Logs</li>
    </ul>

    <h4>4.2 How we collect your information</h4>
    <p>
      We collect your personal data directly from you in connection with your visit or registration on the Website
      or when
      you use our App.
    </p>
    <p>
      We may also collect your data, to the extent you have given your consent to it and/or requested it, from our
      partners or
      other third parties, for example, information that you have provided when registering through Google or
      Facebook.
    </p>

    <p>
      We may complement information that you have provided to us with information from other sources, such as
      information
      that confirms your identity and profile information. We do this to ascertain the correctness of the
      information we are
      collecting and to be able to provide better service.
    </p>

    <p>
      We log and collect usage data when you visit or otherwise use our Service, including our Website, app, and
      platform
      technology (e.g., our off-site plugins), such as when you view or click on content or supply information. We
      use
      log-ins, cookies, device information, and internet protocol addresses to identify you and log your use.
    </p>

    <p>
      When you log in, we will also set up several cookies to save your login information and your screen display
      choices.
      Login cookies last for two days, and screen options cookies last for a year. If you select "Remember Me,"
      your login
      will persist for two weeks. If you log out of your account, the login cookies will be removed.
    </p>

    <p>If you edit or publish an article, an additional cookie will be saved in your browser. This cookie includes
      no personal
      data and simply indicates the post ID of the article you just edited. It expires after 1 day.</p>

    <h4>4.3 Video calls and recordings</h4>

    <p>
      Video calls made in the App are recorded. Both picture and sound are recorded, for every participant, for the
      duration of the call. Everyone taking part is told that the call is recorded before it starts - both on the
      screen the call is placed from and on the screen where it is answered. If you do not want to be recorded, do
      not place or answer the call.
    </p>

    <p>
      The recording is saved as a video file and made available to the participants of the call through a link in
      the chat the call belongs to. Anyone with access to that chat can open the file. We do not publish recordings
      and we do not share them with any third party other than the service providers we use to carry out the calls
      and store the files, as described in Clause 6.
    </p>

    <p>
      Recordings are stored under the same rules as other content in your chats, see Clause 8. You can ask us to
      delete a recording at any time, and the rights described in Clause 9 apply to recordings as well.
    </p>

    <h3>5. Processing purposes</h3>

    <p>
      Our service is a collaboration tool, and the purpose of the information gathering is to help you more easily
      create
      content that will help you collaborate around your children and their well-being.
    </p>

    <p>
      Please note that certain data can be used even without your consent, for example, if we need the data to
      train AI
      models. We always try to anonymize personal data if we do. We will never sell your personal data to other
      parties. We
      process your personal data for the purposes set out in Clauses 5.1-5.4 below.
    </p>

    <h4>5.1 Provide our Services</h4>

    <p>If you choose to register with us, our main use of data is to use it to help collaborate with other members
      in your
      extended family.</p>

    <p>
      We use your personal data as may be needed to provide the Service, e.g., to administer your account, to
      communicate
      with you, for billing purposes, and to provide support.
    </p>

    <p>
      We may use your personal data by analyzing images and text to generate data from them for you and your extended family.
    </p>

    <h4>5.2 Improving our Services and data analysis</h4>

    <p>
      We may use your data to improve our services and train our data models. For example, training AI to identify
      abusive
      language. We always try to anonymize information about before using it to train models.
    </p>

    <p>
      We aggregate and anonymize data (e.g., usage of different schedule setups) to provide insights. This
      anonymized data
      may be spread outside of Happy Parents.
    </p>

    <p>
      We will also process your personal data to produce statistics on how you use our Services. We can do this
      by, e.g.,
      performing customer satisfaction surveys and market research or by analyzing your use of the Website. We use
      your
      information to make the Services more user-friendly, e.g., by fixing bugs, amending the interface for you to
      easily
      reach the information you seek, or highlighting popular functions. This processing is based on our interest
      to
      continuously improve the Service and provide and develop new services and to perform further anonymized data
      analysis
      and use.
    </p>

    <h4>5.3 Prevent Abuse</h4>

    <p>
      Your personal data can also be used to prevent abuse of our Services or to prevent or investigate crimes.
      Abuse refers
      to, among other things, fraud, sending junk mail, harassment, attempts of unauthorized login to user
      accounts, and other
      measures that are in violation of our terms and conditions or law. We can also use your data to examine and
      defend
      ourselves against any legal claims from Users or third parties. This processing is based on our interest to
      avoid abuse
      of the Website or the Services and to defend ourselves against legal claims.
    </p>

    <h4>5.4 Direct marketing and marketing of the Service</h4>

    <p>
      We use your personal data to send newsletters, offers, and relevant information about our Services. The
      marketing
      material can be sent to you by mail, SMS, or e-mail. You may also receive offers from any of our partners.
      Such offers
      are made by us through the Website and not directly by our partners. This processing is based on your prior
      consent.
    </p>

    <h3>6. How we share your personal data</h3>

    <h4>6.1 Varannan Vecka does not share your personal information with any third party except as described
      below.</h4>

    <ul>
      <li>
        Service providers: Varannan Vecka may use third parties to manage one or more aspects of our business
        operations,
        including the processing or handling of personal information. We may share personal information with
        such third
        parties to perform services on our behalf such as chat and messaging services, processing payments,
        sending marketing
        communications, conducting analysis or research, verifying and validating information that you have
        provided to us,
        and providing customer support services.
      </li>
      <li>
        Sale or transfer of business or assets: Any information we have about you may be transferred or
        disclosed to a
        purchaser or prospective purchaser in the event of a sale, assignment, or other transfer of all or a
        portion of our
        business or assets. Should such a transfer occur, we will use reasonable efforts to ensure that the
        transferee uses
        your information in a manner that is consistent with this Privacy Policy.
      </li>
      <li>
        Varannan Vecka may also disclose your information if we are required to do so by law or to comply with
        legal requests
        (e.g. disclosure queries, court decisions, legal actions, or the like) or when it is necessary to
        detect, prevent, and
        address fraud and other criminal activity, to protect ourselves, you, and other users, including as part
        of an inquiry
        if we in good faith believe that such action is required by applicable law. The above may include
        answering legal
        requests from non-EU/EEA jurisdictions, where we in good faith believe that the response is required by
        the law of the
        relevant jurisdiction, affects users in this jurisdiction, and is in accordance with internationally
        recognized
        standards.
      </li>
    </ul>

    <h4>6.2 Anonymized and aggregated data may be made available without the Users' explicit consent (such as
      statistics).</h4>

    <p>
      We may thus publish anonymous and aggregated information about the use of Varannan Vecka or other
      conclusions that may
      be deduced from the use of Varannan Vecka.
    </p>

    <h3>7. How we protect your data</h3>

    <ol type="1">
      <li>
        The file containing your personal information will be stored on our servers and will only be accessible
        to our
        employees and those of our agents and service providers who require it in the course of their duties. We
        maintain
        appropriate safeguards and current security standards to protect your personal information against
        unauthorized
        access, disclosure, or misuse. For example, electronic records are stored in secure, limited-access
        servers, and
        electronic data is stored behind secured encryption access. We use technological tools like firewalls
        and passwords,
        and we ensure our employees are trained on the importance of maintaining the security and
        confidentiality of the
        personal information we process.
      </li>
      <li>
        Our Website uses encryption technology, such as Secure Sockets Layer, (“SSL”), to protect your personal
        information
        during data transmission. SSL encrypts ordering information such as your name, address, and payment
        information. Our
        Website uses an SSL certificate from GoDaddy to confirm that we are in compliance with security
        protocols in accordance
        with industry standards.
      </li>
      <li>
        When you register as a user and create an online account on our Website, you will be prompted to select
        a personal
        password. To maximize your level of protection, you should choose a strong personal password, which
        means that you
        should use at least 6 characters. You are solely responsible for maintaining the secrecy of your
        password and any
        account information. Varannan Vecka will never send an unsolicited communication asking you for your
        password or
        requesting that you update your account credentials.
      </li>
    </ol>

    <h3>8. Storage period</h3>

    <ol type="1">
      <li>
        We generally retain your personal data as long as it is necessary for the purposes it was collected for
        or as otherwise
        required or authorized by applicable law. This inter alia means that as long as our users want to be
        registered on our
        website we will store the data.
      </li>
      <li>It's up to you to delete your account if you want to, and this can be done through the settings of your
        account. After
        an account has been deleted we save the data for up to 12 months.
      </li>
      <li>Aggregated and anonymized data where the user may not be identified may be stored indefinitely.</li>
      <li>Chats and other jointly created items (such as shared schedules) will also be stored in the other
        person's inbox for as
        long as their data is not deleted (e.g. the user deletes their account plus another 12 months).
      </li>
      <li>Logs and statistical data may be stored for up to 36 months.</li>
    </ol>

    <h3>9. Your rights</h3>

    <ol type="1">
      <li>
        To register an account at Varannan Vecka is voluntarily as a User; you always have the possibility to
        remove or correct
        the information we have about you. You can do this on your personal page on the Website or in the
        Service. Please note,
        however, that we may continue to process your personal data to the extent necessary for the performance
        of our
        agreement with you or if there is any other legal basis than consent for processing the data.
      </li>
      <li>
        In accordance with applicable personal data legislation, you are entitled to be informed of the personal
        data we have
        processed about you, regardless of how the information was collected. If you would like such
        information, please submit
        a written request to us at the contact information provided in Clause 2.
      </li>
      <li>
        If your personal data is processed in breach of applicable personal data legislation, you are entitled
        to request that
        your personal data is corrected, blocked, or erased. You are also entitled to request that your
        information is
        transferred to another service provider (so-called data portability).
      </li>
      <li>Your personal data will not be processed for purposes related to direct marketing or profiling if you
        oppose such
        processing. You are, at any time, entitled to withdraw any given consent for the processing of personal
        data. Such
        withdrawal may be limited to include only part of the processing, e.g., the part connected to your
        membership with us
        or direct marketing. In each newsletter or marketing notification, there is a link included which you
        can use to
        unsubscribe.
      </li>
      <li>
        If you consider that we have processed your personal data in breach of applicable personal data
        legislation, you are
        entitled to lodge a complaint with the Swedish Data Protection Authority (Sw. Integritetsmyndigheten),
        which can be
        reached at Integritetsmyndigheten@itegritetsmyndigheten.se.
      </li>
    </ol>

    <h3>10. Transfer of personal data</h3>

    <p>
      If you have an account on this site or have left comments, you can request to receive an exported file of
      the personal
      data we hold about you, including any data you have provided to us. You can also request that we erase any
      personal data
      we hold about you. This does not include any data we are obliged to keep for administrative, legal, or
      security
      purposes.
    </p>
  </>,

  helpSchedule : "What do you want to do?",

  helpScheuleIntoTopic: "I am new and need an introduction",
  helpScheduleQuickTopic: "I want to change just a few days",
  helpScheduleTemplateTopic: "I want to plan a schedule for multiple days",
  helpScheduleTempPlaceTopic: "I want to change the time/location for many handovers",
  helpScheduleMultiTopic: "I want different schedules for different children",

  calendarView : "Layout",

  helpScheuleInto: (scheduleName: string, scheduleStatus: string) => <>
      <p>The custody schedule is used to plan who is responsible for the child. Making changes to the custody schedule does not affect other activities in the calendar.</p>
      <p>The custody schedule can be <b>private</b>, <b>shared</b>, or <b>current</b>.</p>
      <p>Private schedules are only visible to you and can be freely modified.</p>
      <p>Shared schedules can be inspected by everyone but are not automatically displayed in the calendar. Changes must be approved by the other co-parent and are sent as a suggestions. Only parents can create, view, and respond to suggestions.</p>
      <p>Current schedules are displayed in the calendar view.</p>
      <p>This schedule ({scheduleName}) is <b>{scheduleStatus}</b></p>
      <p>To share/make current, exit the schedule planner and click the menu at the top right.</p>
  </>,
  helpScheduleVeryQuick: "Click and drag the days you want to change. Under the wrench there are many tools!",
  helpScheduleQuick: <p>Click/drag on the days in the schedule you want to change. When you're satisfied, click send!</p>,
  helpScheduleTemplate: <p>If you want to plan a schedule for multiple days, click on the tools at the bottom right corner, then click on <b>Use template</b>.</p>,
  helpScheduleTempPlace: <>
      <p>To change the time and location for multiple days, click on the tools at the bottom right corner. Then click on <b>Change time/location</b>.</p>
      <p>Alternatively, if you want to change which days the exchanges occur, click <b>Use template</b>.</p>
  </>,
  helpScheduleMulti: <>
      <p>Click on the tools at the bottom right corner and then Child. Change it so that this schedule only applies to one of the children and click send. Then, in the calendar view (exit the schedule planner), click "create new" in the menu at the top right.</p>
      <p>Don't forget to share and set as current!</p>
  </>,
};


export default class TranslateNew {
  public static getInstance(): TranslateNew {
    if (!TranslateNew.instance) {
      TranslateNew.instance = new TranslateNew();
    }

    return TranslateNew.instance;
  }

  private static instance: TranslateNew;
  public lang: (typeof baselanguage);
  private chosenLanguage: "SE"|"EN" ;

  private constructor() {
    this.chosenLanguage = "EN";
    this.lang = engelska;
  }

  public setLanguage(language: string): void {
    if (language === "SE") {
      this.chosenLanguage = "SE";
      this.lang = baselanguage;
    } else if (language === "EN") {
      this.chosenLanguage = "EN";
      this.lang = engelska;
    }
  }

  public getLanguage(): "SE"|"EN" {
    return this.chosenLanguage;
  }

  public testEmailIsValid(email:string):boolean {
    if (email.length === 0) return true;
    const emailRegex = /^\w+([\.\+-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,7})+$/;
    if (email.trim().length === 0) {
      return false;
    } else {
      return emailRegex.test(email);
    }
  }


  public testPhoneIsValid(phoneNbr: string, countryCode: string): boolean {
    if (countryCode === "") return true; // No country code, no validation
    const phoneRegexMap: { [key: string]: RegExp } = {
      // Your originals (kept)
      "+46": /^(0[1-9]\d{7,9}|[1-9]\d{8})$/, // Sverige
      "+358": /^[1-9][0-9]{6,11}$/,          // Finland
      "+47": /^[2-9][0-9]{7}$/,              // Norge
      "+45": /^[2-9][0-9]{7}$/,              // Danmark
      "+34": /^[6-7][0-9]{8}$/,              // Spanien
      "+41": /^[1-9][0-9]{8}$/,              // Schweiz
      "+49": /^[1-9][0-9]{10,14}$/,          // Tyskland
      "+33": /^[1-9][0-9]{8}$/,              // Frankrike
      "+32": /^[1-9][0-9]{8,9}$/,            // Belgien
      "+31": /^[1-9][0-9]{8}$/,              // Nederländerna
      "+44": /^[1-9][0-9]{9}$/,              // Storbritannien
      "+1":  /^[2-9][0-9]{9}$/,              // USA

      // Added Europe
      "+354": /^[1-9][0-9]{6}$/,             // Island (7)
      "+372": /^[1-9][0-9]{6,7}$/,           // Estland (7–8)
      "+371": /^[1-9][0-9]{7}$/,             // Lettland (8)
      "+370": /^[1-9][0-9]{7}$/,             // Litauen (8)
      "+353": /^[1-9][0-9]{6,8}$/,           // Irland (7–9)
      "+352": /^[1-9][0-9]{7,10}$/,          // Luxemburg (8–11)
      "+43":  /^[1-9][0-9]{6,11}$/,          // Österrike (7–12)
      "+423": /^[1-9][0-9]{6,8}$/,           // Liechtenstein (7–9)
      "+377": /^[1-9][0-9]{7,8}$/,           // Monaco (8–9)
      "+376": /^[1-9][0-9]{5,8}$/,           // Andorra (6–9)
      "+378": /^[1-9][0-9]{5,9}$/,           // San Marino (6–10)
      "+39":  /^[1-9][0-9]{5,11}$/,          // Italien/Vatikanen (6–12)
      "+350": /^[1-9][0-9]{7}$/,             // Gibraltar (8)
      "+351": /^[1-9][0-9]{8}$/,             // Portugal (9)
      "+356": /^[1-9][0-9]{7}$/,             // Malta (8)
      "+30":  /^[1-9][0-9]{9}$/,             // Grekland (10)
      "+357": /^[1-9][0-9]{7}$/,             // Cypern (8)
      "+48":  /^[1-9][0-9]{8}$/,             // Polen (9)
      "+420": /^[1-9][0-9]{8}$/,             // Tjeckien (9)
      "+421": /^[1-9][0-9]{8}$/,             // Slovakien (9)
      "+36":  /^[1-9][0-9]{7,8}$/,           // Ungern (8–9)
      "+386": /^[1-9][0-9]{7,8}$/,           // Slovenien (8–9)
      "+385": /^[1-9][0-9]{7,8}$/,           // Kroatien (8–9)
      "+387": /^[1-9][0-9]{7}$/,             // Bosnien och Hercegovina (8)
      "+381": /^[1-9][0-9]{7,8}$/,           // Serbien (8–9)
      "+382": /^[1-9][0-9]{7,8}$/,           // Montenegro (8–9)
      "+389": /^[1-9][0-9]{7}$/,             // Nordmakedonien (8)
      "+355": /^[1-9][0-9]{7,8}$/,           // Albanien (8–9)
      "+383": /^[1-9][0-9]{7,8}$/,           // Kosovo (8–9)
      "+359": /^[1-9][0-9]{7,8}$/,           // Bulgarien (8–9)
      "+40":  /^[1-9][0-9]{8}$/,             // Rumänien (9)
      "+373": /^[1-9][0-9]{7}$/,             // Moldavien (8)
      "+380": /^[1-9][0-9]{8}$/,             // Ukraina (9)
      "+375": /^[1-9][0-9]{8,9}$/,           // Belarus (9–10)

      // Transcontinental
      "+7":   /^[1-9][0-9]{9}$/,             // Ryssland (10)
      "+90":  /^[1-9][0-9]{9}$/,             // Turkiet (10)
      "+995": /^[1-9][0-9]{8}$/,             // Georgien (9)
      "+374": /^[1-9][0-9]{7}$/,             // Armenien (8)
      "+994": /^[1-9][0-9]{8}$/,             // Azerbajdzjan (9)

      "+86":  /^[1-9][0-9]{10,11}$/,        // Kina (11–12)
      "+81":  /^[1-9][0-9]{9,10}$/,         // Japan (10–11)
      "+82":  /^[1-9][0-9]{8,9}$/,          // Sydkorea (9–10)
      "+61":  /^[2-9][0-9]{8}$/,             // Australien (9)
      "+64":  /^[2-9][0-9]{7,9}$/,           // Nya Zeeland (8–10)
    };

    phoneNbr = (phoneNbr || "").trim();
    if (phoneNbr.length === 0) {
      return false;
    }
    const regex = phoneRegexMap[countryCode];
    if (!regex) {
      return false;
    }
    return regex.test(phoneNbr);
  }



  public familyMemberName = (accountId: number | undefined, family: IFamilyMember[]): string => {
    if (accountId === undefined || family === undefined) {
      return this.lang.unknown;
    } else {
      if (accountId === 0) {
        return this.lang.varannanVecka;
      }
      for (const member of family) {
        if (member.id === accountId) {
          return (member.firstName);
        }
      }
      return this.lang.deletedAccount;
    }
  }

  public familyMemberNames = (accountIds: number[] | undefined, family: IFamilyMember[]): string => {
    if (accountIds === undefined) {
      return "unspecified";
    }
    if (accountIds.length === 0) {
      return TranslateNew.getInstance().lang.noone;
    }
    let names: string = "";
    let remaining = accountIds.length;
    for (const accountId of accountIds) {
      names = names + this.familyMemberName(accountId, family);
      remaining--;
      if (remaining === 1) {
        names = names + " & ";
      } else if (remaining > 1) {
        names = names + ", ";
      }
    }
    return names;
  }

  public formatWeekdayName = (dayName: string) => {
    
    switch (dayName.toLowerCase()) {
      case "monday":
        return this.lang.monday;
      case "tuesday":
        return this.lang.tuesday;
      case "wednesday":
        return this.lang.wednesday;
      case "thursday":
        return this.lang.thursday;
      case "friday":
        return this.lang.friday;
      case "saturday":
        return this.lang.saturday;
      case "sunday":
        return this.lang.sunday;
      default:
        return this.lang.unknown;
                                              }
  }

  public formatDateYearMonthDay = (date:Date) => {
    const month = date.getMonth() +1;
    const day = date.getDate();
    return (date.getFullYear()+"-"+(month<10?("0"+month):month)+"-"+(day<10?("0"+day):day))
  }

  public formatDateDayMonthYear = (date: Date) => {
    return this.formatDateMonthShort(date) + " "
      + date.getFullYear();
  }

  public formatDateReadable = (date: Date) => {
    return this.lang.getWeekdayName(date.getDay()) + ' '
      + this.lang.dateMonthOrder(date) + ', '
      + date.getFullYear();
  }

  public formatDateReadableToFrom = (dateFrom: Date, dateTo: Date) => {
    return this.lang.getMonthName(dateFrom.getMonth()) + ' '
      + dateFrom.getDate() + this.lang.dateEnding(dateFrom.getDate()) + ' to '
      + this.lang.getMonthName(dateTo.getMonth()) + ' '
      + dateTo.getDate() + this.lang.dateEnding(dateTo.getDate()) + ', '
      + dateTo.getFullYear();
  }

  public formatTime = (
    date: Date,
    locale: string = navigator.language || "sv-SE"
  ): string => {
    // A corrupt timestamp (missing field, string date, old persisted state) gives an
    // Invalid Date, and Intl.DateTimeFormat.format throws a RangeError on those —
    // return a harmless placeholder instead of crashing the render.
    if (!(date instanceof Date) || isNaN(date.getTime())) {
      return "";
    }

    const options: Intl.DateTimeFormatOptions = {
      hour:   'numeric',   // no zero‐pad, and respects locale’s 12h/24h choice
      minute: '2-digit'
    };

    try {
      return new Intl.DateTimeFormat(locale, options).format(date);
    } catch (error) {
      // Some WebViews report malformed navigator.language tags, which make the
      // Intl constructor throw a RangeError.
      return new Intl.DateTimeFormat("sv-SE", options).format(date);
    }
  }


  public formatDateShort = (date: Date) => {
    return this.lang.getWeekdayName(date.getDay()) + ', '
      + date.getDate() + this.lang.dateEnding(date.getDate()) + ' '
      + this.lang.getMonthName(date.getMonth());
  }

  public formatMonthDate = (date: Date) => {
    return (date.getDate() + this.lang.dateEnding(date.getDate())
      + ' '
      + this.lang.getMonthName(date.getMonth()));
  }

  public formatDateMonthShort = (date: Date) => {
    return (date.getDate() + this.lang.dateEnding(date.getDate())
      + ' '
      + this.lang.getMonthNameShort(date.getMonth()));
  }

  public formatNumber = (value: number, currency: string | undefined = undefined): string => {
    const style = currency ? 'currency' : 'decimal';

    return value.toLocaleString(this.currencyLocale(currency, this.chosenLanguage), { style, currency });
  }

  public currencyLocale(currency: string | undefined, lang: string): string {

    if (currency === "AUD") return "en-AU";
    else if (currency === "CAD") return "en-CA";
    else if (currency === "CHF") return "fr-CH";
    else if (currency === "DKK") return "da";
    else if (currency === "EUR") return "sv-SE";
    else if (currency === "GBP") return "en-GB";
    else if (currency === "JPY") return "ja";
    else if (currency === "NOK") return "no-NO";
    else if (currency === "NZD") return "en-NZ";
    else if (currency === "PLN") return "sv-SE";
    else if (currency === "SEK") return "sv-SE";
    else if (currency === "USD") return "en-US";
    else return "en-US";
  }

  public zeroPad = (num: number) => {
    return (num < 10 ? '0' : '') + num;
  }

  public avatar = (family:IFamilyMember[], accountId:number, style:React.CSSProperties) => {
    return (family
      .filter((person) => (accountId  === person.id))
      .map((person, index) =>
        <ImgAvatar key={person.id} altText={person.firstName} imgUrl={person.imageAvatar?person.avatarURL:undefined}
            imgName={person.avatar} style={style} 
            color={person.color} />
        ));
  }

  public avatarMem = (person:IFamilyMember, style:React.CSSProperties) => {
    return (
        <ImgAvatar key={person.id} altText={person.firstName} imgUrl={person.imageAvatar?person.avatarURL:undefined}
            imgName={person.avatar} style={style} 
            color={person.color} />
        );
  }
}



// WEBPACK FOOTER //
// ./src/translation/TranslateNew.tsx